webpackJsonp([79611799117203,35783957827783],{

/***/ 200:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"appUrl":"https://pipeline.social/m/subscribe/"}}},"layoutContext":{}}

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(328);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(200);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// ┌────────────────────────────────────────────────────────────┐ \\
	// │ Eve 0.5.4 - JavaScript Events Library                      │ \\
	// ├────────────────────────────────────────────────────────────┤ \\
	// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
	// └────────────────────────────────────────────────────────────┘ \\
	
	(function (glob) {
	    var version = "0.5.4",
	        has = "hasOwnProperty",
	        separator = /[\.\/]/,
	        comaseparator = /\s*,\s*/,
	        wildcard = "*",
	        numsort = function (a, b) {
	            return a - b;
	        },
	        current_event,
	        stop,
	        events = {n: {}},
	        firstDefined = function () {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	                if (typeof this[i] != "undefined") {
	                    return this[i];
	                }
	            }
	        },
	        lastDefined = function () {
	            var i = this.length;
	            while (--i) {
	                if (typeof this[i] != "undefined") {
	                    return this[i];
	                }
	            }
	        },
	        objtos = Object.prototype.toString,
	        Str = String,
	        isArray = Array.isArray || function (ar) {
	            return ar instanceof Array || objtos.call(ar) == "[object Array]";
	        },
	    /*\
	     * eve
	     [ method ]
	
	     * Fires event with given `name`, given scope and other parameters.
	
	     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
	     - scope (object) context for the event handlers
	     - varargs (...) the rest of arguments will be sent to event handlers
	
	     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
	    \*/
	        eve = function (name, scope) {
	            var oldstop = stop,
	                args = Array.prototype.slice.call(arguments, 2),
	                listeners = eve.listeners(name),
	                z = 0,
	                l,
	                indexed = [],
	                queue = {},
	                out = [],
	                ce = current_event;
	            out.firstDefined = firstDefined;
	            out.lastDefined = lastDefined;
	            current_event = name;
	            stop = 0;
	            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
	                indexed.push(listeners[i].zIndex);
	                if (listeners[i].zIndex < 0) {
	                    queue[listeners[i].zIndex] = listeners[i];
	                }
	            }
	            indexed.sort(numsort);
	            while (indexed[z] < 0) {
	                l = queue[indexed[z++]];
	                out.push(l.apply(scope, args));
	                if (stop) {
	                    stop = oldstop;
	                    return out;
	                }
	            }
	            for (i = 0; i < ii; i++) {
	                l = listeners[i];
	                if ("zIndex" in l) {
	                    if (l.zIndex == indexed[z]) {
	                        out.push(l.apply(scope, args));
	                        if (stop) {
	                            break;
	                        }
	                        do {
	                            z++;
	                            l = queue[indexed[z]];
	                            l && out.push(l.apply(scope, args));
	                            if (stop) {
	                                break;
	                            }
	                        } while (l)
	                    } else {
	                        queue[l.zIndex] = l;
	                    }
	                } else {
	                    out.push(l.apply(scope, args));
	                    if (stop) {
	                        break;
	                    }
	                }
	            }
	            stop = oldstop;
	            current_event = ce;
	            return out;
	        };
	    // Undocumented. Debug only.
	    eve._events = events;
	    /*\
	     * eve.listeners
	     [ method ]
	
	     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.
	
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated
	
	     = (array) array of event handlers
	    \*/
	    eve.listeners = function (name) {
	        var names = isArray(name) ? name : name.split(separator),
	            e = events,
	            item,
	            items,
	            k,
	            i,
	            ii,
	            j,
	            jj,
	            nes,
	            es = [e],
	            out = [];
	        for (i = 0, ii = names.length; i < ii; i++) {
	            nes = [];
	            for (j = 0, jj = es.length; j < jj; j++) {
	                e = es[j].n;
	                items = [e[names[i]], e[wildcard]];
	                k = 2;
	                while (k--) {
	                    item = items[k];
	                    if (item) {
	                        nes.push(item);
	                        out = out.concat(item.f || []);
	                    }
	                }
	            }
	            es = nes;
	        }
	        return out;
	    };
	    /*\
	     * eve.separator
	     [ method ]
	
	     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
	     * here. Be aware that if you pass a string longer than one character it will be treated as
	     * a list of characters.
	
	     - separator (string) new separator. Empty string resets to default: `.` or `/`.
	    \*/
	    eve.separator = function (sep) {
	        if (sep) {
	            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
	            sep = "[" + sep + "]";
	            separator = new RegExp(sep);
	        } else {
	            separator = /[\.\/]/;
	        }
	    };
	    /*\
	     * eve.on
	     [ method ]
	     **
	     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
	     | eve.on("*.under.*", f);
	     | eve("mouse.under.floor"); // triggers f
	     * Use @eve to trigger the listener.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	     **
	     - name (array) if you don’t want to use separators, you can use array of strings
	     - f (function) event handler function
	     **
	     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment.
	     > Example:
	     | eve.on("mouse", eatIt)(2);
	     | eve.on("mouse", scream);
	     | eve.on("mouse", catchIt)(1);
	     * This will ensure that `catchIt` function will be called before `eatIt`.
	     *
	     * If you want to put your handler before non-indexed handlers, specify a negative value.
	     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
	    \*/
	    eve.on = function (name, f) {
	        if (typeof f != "function") {
	            return function () {};
	        }
	        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
	        for (var i = 0, ii = names.length; i < ii; i++) {
	            (function (name) {
	                var names = isArray(name) ? name : Str(name).split(separator),
	                    e = events,
	                    exist;
	                for (var i = 0, ii = names.length; i < ii; i++) {
	                    e = e.n;
	                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
	                }
	                e.f = e.f || [];
	                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
	                    exist = true;
	                    break;
	                }
	                !exist && e.f.push(f);
	            }(names[i]));
	        }
	        return function (zIndex) {
	            if (+zIndex == +zIndex) {
	                f.zIndex = +zIndex;
	            }
	        };
	    };
	    /*\
	     * eve.f
	     [ method ]
	     **
	     * Returns function that will fire given event with optional arguments.
	     * Arguments that will be passed to the result function will be also
	     * concated to the list of final arguments.
	     | el.onclick = eve.f("click", 1, 2);
	     | eve.on("click", function (a, b, c) {
	     |     console.log(a, b, c); // 1, 2, [event object]
	     | });
	     - event (string) event name
	     - varargs (…) and any other arguments
	     = (function) possible event handler function
	    \*/
	    eve.f = function (event) {
	        var attrs = [].slice.call(arguments, 1);
	        return function () {
	            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
	        };
	    };
	    /*\
	     * eve.stop
	     [ method ]
	     **
	     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
	    \*/
	    eve.stop = function () {
	        stop = 1;
	    };
	    /*\
	     * eve.nt
	     [ method ]
	     **
	     * Could be used inside event handler to figure out actual name of the event.
	     **
	     - subname (string) #optional subname of the event
	     **
	     = (string) name of the event, if `subname` is not specified
	     * or
	     = (boolean) `true`, if current event’s name contains `subname`
	    \*/
	    eve.nt = function (subname) {
	        var cur = isArray(current_event) ? current_event.join(".") : current_event;
	        if (subname) {
	            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
	        }
	        return cur;
	    };
	    /*\
	     * eve.nts
	     [ method ]
	     **
	     * Could be used inside event handler to figure out actual name of the event.
	     **
	     **
	     = (array) names of the event
	    \*/
	    eve.nts = function () {
	        return isArray(current_event) ? current_event : current_event.split(separator);
	    };
	    /*\
	     * eve.off
	     [ method ]
	     **
	     * Removes given function from the list of event listeners assigned to given name.
	     * If no arguments specified all the events will be cleared.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	    \*/
	    /*\
	     * eve.unbind
	     [ method ]
	     **
	     * See @eve.off
	    \*/
	    eve.off = eve.unbind = function (name, f) {
	        if (!name) {
	            eve._events = events = {n: {}};
	            return;
	        }
	        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
	        if (names.length > 1) {
	            for (var i = 0, ii = names.length; i < ii; i++) {
	                eve.off(names[i], f);
	            }
	            return;
	        }
	        names = isArray(name) ? name : Str(name).split(separator);
	        var e,
	            key,
	            splice,
	            i, ii, j, jj,
	            cur = [events],
	            inodes = [];
	        for (i = 0, ii = names.length; i < ii; i++) {
	            for (j = 0; j < cur.length; j += splice.length - 2) {
	                splice = [j, 1];
	                e = cur[j].n;
	                if (names[i] != wildcard) {
	                    if (e[names[i]]) {
	                        splice.push(e[names[i]]);
	                        inodes.unshift({
	                            n: e,
	                            name: names[i]
	                        });
	                    }
	                } else {
	                    for (key in e) if (e[has](key)) {
	                        splice.push(e[key]);
	                        inodes.unshift({
	                            n: e,
	                            name: key
	                        });
	                    }
	                }
	                cur.splice.apply(cur, splice);
	            }
	        }
	        for (i = 0, ii = cur.length; i < ii; i++) {
	            e = cur[i];
	            while (e.n) {
	                if (f) {
	                    if (e.f) {
	                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
	                            e.f.splice(j, 1);
	                            break;
	                        }
	                        !e.f.length && delete e.f;
	                    }
	                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
	                        var funcs = e.n[key].f;
	                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
	                            funcs.splice(j, 1);
	                            break;
	                        }
	                        !funcs.length && delete e.n[key].f;
	                    }
	                } else {
	                    delete e.f;
	                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
	                        delete e.n[key].f;
	                    }
	                }
	                e = e.n;
	            }
	        }
	        // prune inner nodes in path
	        prune: for (i = 0, ii = inodes.length; i < ii; i++) {
	            e = inodes[i];
	            for (key in e.n[e.name].f) {
	                // not empty (has listeners)
	                continue prune;
	            }
	            for (key in e.n[e.name].n) {
	                // not empty (has children)
	                continue prune;
	            }
	            // is empty
	            delete e.n[e.name];
	        }
	    };
	    /*\
	     * eve.once
	     [ method ]
	     **
	     * Binds given event handler with a given name to only run once then unbind itself.
	     | eve.once("login", f);
	     | eve("login"); // triggers f
	     | eve("login"); // no listeners
	     * Use @eve to trigger the listener.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	     **
	     = (function) same return function as @eve.on
	    \*/
	    eve.once = function (name, f) {
	        var f2 = function () {
	            eve.off(name, f2);
	            return f.apply(this, arguments);
	        };
	        return eve.on(name, f2);
	    };
	    /*\
	     * eve.version
	     [ property (string) ]
	     **
	     * Current version of the library.
	    \*/
	    eve.version = version;
	    eve.toString = function () {
	        return "You are running Eve " + version;
	    };
	    glob.eve = eve;
	    typeof module != "undefined" && module.exports ? module.exports = eve :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () { return eve; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : glob.eve = eve;
	})(typeof window != "undefined" ? window : this);


/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = undefined;
	
	var _extends2 = __webpack_require__(19);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(92);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(60);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(12);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withPrefix = withPrefix;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(138);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__;
	}
	
	function withPrefix(path) {
	  return normalizePath(pathPrefix + path);
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	function createLocation(path, history) {
	  var location = (0, _history.createLocation)(path, null, null, history.location);
	  location.pathname = withPrefix(location.pathname);
	  return location;
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	
	  // Set up IntersectionObserver
	};var handleIntersection = function handleIntersection(el, cb) {
	  var io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      if (el === entry.target) {
	        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
	        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
	        if (entry.isIntersecting || entry.intersectionRatio > 0) {
	          io.unobserve(el);
	          io.disconnect();
	          cb();
	        }
	      }
	    });
	  });
	  // Add element to the observer
	  io.observe(el);
	};
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props, context) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    // Default to no support for IntersectionObserver
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    var IOSupported = false;
	    if (typeof window !== "undefined" && window.IntersectionObserver) {
	      IOSupported = true;
	    }
	
	    var history = context.router.history;
	
	    var to = createLocation(props.to, history);
	
	    _this.state = {
	      path: (0, _history.createPath)(to),
	      to: to,
	      IOSupported: IOSupported
	    };
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      var to = createLocation(nextProps.to, history);
	      this.setState({
	        path: (0, _history.createPath)(to),
	        to: to
	      });
	      // Preserve non IO functionality if no support
	      if (!this.state.IOSupported) {
	        ___loader.enqueue(this.state.to.pathname);
	      }
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    // Preserve non IO functionality if no support
	    if (!this.state.IOSupported) {
	      ___loader.enqueue(this.state.to.pathname);
	    }
	  };
	
	  GatsbyLink.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    this.props.innerRef && this.props.innerRef(ref);
	
	    if (this.state.IOSupported && ref) {
	      // If IO supported and element reference found, setup Observer functionality
	      handleIntersection(ref, function () {
	        ___loader.enqueue(_this2.state.to.pathname);
	      });
	    }
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        _onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    var El = void 0;
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this3.props[propName];
	    })) {
	      El = _reactRouterDom.NavLink;
	    } else {
	      El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function onClick(e) {
	        // eslint-disable-line
	        _onClick && _onClick(e);
	
	        if (e.button === 0 && // ignore right clicks
	        !_this3.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this3.state.path;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this3.state.path.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            } else {
	              // This is just a normal link to the current page so let's emulate default
	              // browser behavior by scrolling now to the top of the page.
	              window.scrollTo(0, 0);
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___navigateTo(_this3.state.to);
	          }
	        }
	
	        return true;
	      }
	    }, rest, {
	      to: this.state.to,
	      innerRef: this.handleRef
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	
	GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
	  innerRef: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	});
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var navigateTo = exports.navigateTo = function navigateTo(to) {
	  window.___navigateTo(to);
	};

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var BurgerIcon = (function (_Component) {
	  _inherits(BurgerIcon, _Component);
	
	  function BurgerIcon(props) {
	    _classCallCheck(this, BurgerIcon);
	
	    _get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      hover: false
	    };
	  }
	
	  _createClass(BurgerIcon, [{
	    key: 'getLineStyle',
	    value: function getLineStyle(index) {
	      return {
	        position: 'absolute',
	        height: '20%',
	        left: 0,
	        right: 0,
	        top: 20 * (index * 2) + '%',
	        opacity: this.state.hover ? 0.6 : 1
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon = undefined;
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        opacity: 0,
	        fontSize: 8,
	        cursor: 'pointer'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: 'bm-icon',
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmIcon)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          null,
	          [0, 1, 2].map(function (bar) {
	            return _react2['default'].createElement('span', {
	              key: bar,
	              className: ('bm-burger-bars ' + _this.props.barClassName).trim(),
	              style: _extends({}, _this.getLineStyle(bar), _this.props.styles.bmBurgerBars)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: ('bm-burger-button ' + this.props.className).trim(),
	          style: _extends({ zIndex: 1000 }, this.props.styles.bmBurgerButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          {
	            onClick: this.props.onClick,
	            onMouseOver: function () {
	              return _this.setState({ hover: true });
	            },
	            onMouseOut: function () {
	              return _this.setState({ hover: false });
	            },
	            style: buttonStyle
	          },
	          'Open Menu'
	        )
	      );
	    }
	  }]);
	
	  return BurgerIcon;
	})(_react.Component);
	
	exports['default'] = BurgerIcon;
	
	BurgerIcon.propTypes = {
	  barClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	BurgerIcon.defaultProps = {
	  barClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  slide: __webpack_require__(585),
	  stack: __webpack_require__(586),
	  elastic: __webpack_require__(578),
	  bubble: __webpack_require__(577),
	  push: __webpack_require__(580),
	  pushRotate: __webpack_require__(581),
	  scaleDown: __webpack_require__(583),
	  scaleRotate: __webpack_require__(584),
	  fallDown: __webpack_require__(579),
	  reveal: __webpack_require__(582)
	};
	module.exports = exports['default'];

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var CrossIcon = (function (_Component) {
	  _inherits(CrossIcon, _Component);
	
	  function CrossIcon() {
	    _classCallCheck(this, CrossIcon);
	
	    _get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(CrossIcon, [{
	    key: 'getCrossStyle',
	    value: function getCrossStyle(type) {
	      return {
	        position: 'absolute',
	        width: 3,
	        height: 14,
	        transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon;
	      var buttonWrapperStyle = {
	        position: 'absolute',
	        width: 24,
	        height: 24,
	        right: 8,
	        top: 8
	      };
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        textIndent: -9999,
	        background: 'transparent',
	        outline: 'none',
	        cursor: 'pointer'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: 'bm-cross',
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmCross)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          { style: { position: 'absolute', top: '6px', right: '14px' } },
	          ['before', 'after'].map(function (type, i) {
	            return _react2['default'].createElement('span', {
	              key: i,
	              className: ('bm-cross ' + _this.props.crossClassName).trim(),
	              style: _extends({}, _this.getCrossStyle(type), _this.props.styles.bmCross)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: ('bm-cross-button ' + this.props.className).trim(),
	          style: _extends({}, buttonWrapperStyle, this.props.styles.bmCrossButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          { onClick: this.props.onClick, style: buttonStyle },
	          'Close Menu'
	        )
	      );
	    }
	  }]);
	
	  return CrossIcon;
	})(_react.Component);
	
	exports['default'] = CrossIcon;
	
	CrossIcon.propTypes = {
	  crossClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	CrossIcon.defaultProps = {
	  crossClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var styles = {
	  overlay: function overlay(isOpen) {
	    return {
	      position: 'fixed',
	      zIndex: 1000,
	      width: '100%',
	      height: '100%',
	      background: 'rgba(0, 0, 0, 0.3)',
	      opacity: isOpen ? 1 : 0,
	      MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      position: 'fixed',
	      right: right ? 0 : 'inherit',
	      zIndex: 1100,
	      width: width,
	      height: '100%',
	      MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  menu: function menu() {
	    return {
	      height: '100%',
	      boxSizing: 'border-box',
	      overflow: 'auto'
	    };
	  },
	
	  itemList: function itemList() {
	    return {
	      height: '100%'
	    };
	  },
	
	  item: function item() {
	    return {
	      display: 'block',
	      outline: 'none'
	    };
	  },
	
	  burgerIcon: function burgerIcon(isOpen, width, right) {
	    return {};
	  }
	};
	
	exports['default'] = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(25);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _baseStyles = __webpack_require__(576);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	var _BurgerIcon = __webpack_require__(573);
	
	var _BurgerIcon2 = _interopRequireDefault(_BurgerIcon);
	
	var _CrossIcon = __webpack_require__(575);
	
	var _CrossIcon2 = _interopRequireDefault(_CrossIcon);
	
	exports['default'] = function (styles) {
	  var Menu = (function (_Component) {
	    _inherits(Menu, _Component);
	
	    function Menu(props) {
	      _classCallCheck(this, Menu);
	
	      _get(Object.getPrototypeOf(Menu.prototype), 'constructor', this).call(this, props);
	      this.state = {
	        isOpen: false
	      };
	    }
	
	    _createClass(Menu, [{
	      key: 'toggleMenu',
	      value: function toggleMenu() {
	        var _this = this;
	
	        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	        var isOpen = options.isOpen;
	        var noStateChange = options.noStateChange;
	
	        var newState = {
	          isOpen: typeof isOpen !== 'undefined' ? isOpen : !this.state.isOpen
	        };
	
	        this.applyWrapperStyles();
	
	        this.setState(newState, function () {
	          !noStateChange && _this.props.onStateChange(newState);
	
	          // Timeout ensures wrappers are cleared after animation finishes.
	          _this.timeoutId && clearTimeout(_this.timeoutId);
	          _this.timeoutId = setTimeout(function () {
	            _this.timeoutId = null;
	            if (!newState.isOpen) {
	              _this.applyWrapperStyles(false);
	            }
	          }, 500);
	        });
	      }
	
	      // Applies component-specific styles to external wrapper elements.
	    }, {
	      key: 'applyWrapperStyles',
	      value: function applyWrapperStyles() {
	        var set = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	        if (this.props.bodyClassName) {
	          var body = document.querySelector('body');
	          body.classList[set ? 'add' : 'remove'](this.props.bodyClassName);
	        }
	
	        if (styles.pageWrap && this.props.pageWrapId) {
	          this.handleExternalWrapper(this.props.pageWrapId, styles.pageWrap, set);
	        }
	
	        if (styles.outerContainer && this.props.outerContainerId) {
	          this.handleExternalWrapper(this.props.outerContainerId, styles.outerContainer, set);
	        }
	      }
	
	      // Sets or unsets styles on DOM elements outside the menu component.
	      // This is necessary for correct page interaction with some of the menus.
	      // Throws and returns if the required external elements don't exist,
	      // which means any external page animations won't be applied.
	    }, {
	      key: 'handleExternalWrapper',
	      value: function handleExternalWrapper(id, wrapperStyles, set) {
	        var html = document.querySelector('html');
	        var body = document.querySelector('body');
	        var wrapper = document.getElementById(id);
	
	        if (!wrapper) {
	          console.error("Element with ID '" + id + "' not found");
	          return;
	        }
	
	        var builtStyles = this.getStyle(wrapperStyles);
	
	        for (var prop in builtStyles) {
	          if (builtStyles.hasOwnProperty(prop)) {
	            wrapper.style[prop] = set ? builtStyles[prop] : '';
	          }
	        }
	
	        // Prevent any horizontal scroll.
	        [html, body].forEach(function (element) {
	          element.style['overflow-x'] = set ? 'hidden' : '';
	        });
	      }
	
	      // Builds styles incrementally for a given element.
	    }, {
	      key: 'getStyles',
	      value: function getStyles(el, index, inline) {
	        var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());
	
	        // Set base styles.
	        var output = _baseStyles2['default'][el] ? this.getStyle(_baseStyles2['default'][el]) : {};
	
	        // Add animation-specific styles.
	        if (styles[el]) {
	          output = _extends({}, output, this.getStyle(styles[el], index + 1));
	        }
	
	        // Add custom styles.
	        if (this.props.styles[propName]) {
	          output = _extends({}, output, this.props.styles[propName]);
	        }
	
	        // Add element inline styles.
	        if (inline) {
	          output = _extends({}, output, inline);
	        }
	
	        return output;
	      }
	    }, {
	      key: 'getStyle',
	      value: function getStyle(style, index) {
	        var width = this.props.width;
	        if (typeof width !== 'string') width = width + 'px';
	
	        return style(this.state.isOpen, width, this.props.right, index);
	      }
	    }, {
	      key: 'listenForClose',
	      value: function listenForClose(e) {
	        e = e || window.event;
	
	        if (this.state.isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'shouldDisableOverlayClick',
	      value: function shouldDisableOverlayClick() {
	        if (typeof this.props.disableOverlayClick === 'function') {
	          return this.props.disableOverlayClick();
	        } else {
	          return this.props.disableOverlayClick;
	        }
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        if (!styles) {
	          throw new Error('No styles supplied');
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        window.onkeydown = this.listenForClose.bind(this);
	
	        // Allow initial open state to be set by props.
	        if (this.props.isOpen) {
	          this.toggleMenu({ isOpen: true, noStateChange: true });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.onkeydown = null;
	
	        this.applyWrapperStyles(false);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        var _this2 = this;
	
	        if (styles.svg) {
	          (function () {
	            var morphShape = _reactDom2['default'].findDOMNode(_this2, 'bm-morph-shape');
	            var path = styles.svg.lib(morphShape).select('path');
	
	            if (_this2.state.isOpen) {
	              // Animate SVG path.
	              styles.svg.animate(path);
	            } else {
	              // Reset path (timeout ensures animation happens off screen).
	              setTimeout(function () {
	                path.attr('d', styles.svg.pathInitial);
	              }, 300);
	            }
	          })();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (typeof nextProps.isOpen !== 'undefined' && nextProps.isOpen !== this.state.isOpen) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        return _react2['default'].createElement(
	          'div',
	          null,
	          !this.props.noOverlay && _react2['default'].createElement('div', {
	            className: ('bm-overlay ' + this.props.overlayClassName).trim(),
	            onClick: function () {
	              return !_this3.shouldDisableOverlayClick() && _this3.toggleMenu();
	            },
	            style: this.getStyles('overlay')
	          }),
	          _react2['default'].createElement(
	            'div',
	            {
	              id: this.props.id,
	              className: ('bm-menu-wrap ' + this.props.className).trim(),
	              style: this.getStyles('menuWrap')
	            },
	            styles.svg && _react2['default'].createElement(
	              'div',
	              {
	                className: ('bm-morph-shape ' + this.props.morphShapeClassName).trim(),
	                style: this.getStyles('morphShape')
	              },
	              _react2['default'].createElement(
	                'svg',
	                {
	                  width: '100%',
	                  height: '100%',
	                  viewBox: '0 0 100 800',
	                  preserveAspectRatio: 'none'
	                },
	                _react2['default'].createElement('path', { d: styles.svg.pathInitial })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              {
	                className: ('bm-menu ' + this.props.menuClassName).trim(),
	                style: this.getStyles('menu')
	              },
	              _react2['default'].createElement(
	                'nav',
	                {
	                  className: ('bm-item-list ' + this.props.itemListClassName).trim(),
	                  style: this.getStyles('itemList')
	                },
	                _react2['default'].Children.map(this.props.children, function (item, index) {
	                  if (item) {
	                    var extraProps = {
	                      key: index,
	                      style: _this3.getStyles('item', index, item.props.style)
	                    };
	                    return _react2['default'].cloneElement(item, extraProps);
	                  }
	                })
	              )
	            ),
	            this.props.customCrossIcon !== false && _react2['default'].createElement(
	              'div',
	              { style: this.getStyles('closeButton') },
	              _react2['default'].createElement(_CrossIcon2['default'], {
	                onClick: function () {
	                  return _this3.toggleMenu();
	                },
	                styles: this.props.styles,
	                customIcon: this.props.customCrossIcon,
	                className: this.props.crossButtonClassName,
	                crossClassName: this.props.crossClassName
	              })
	            )
	          ),
	          this.props.customBurgerIcon !== false && _react2['default'].createElement(
	            'div',
	            { style: this.getStyles('burgerIcon') },
	            _react2['default'].createElement(_BurgerIcon2['default'], {
	              onClick: function () {
	                return _this3.toggleMenu();
	              },
	              styles: this.props.styles,
	              customIcon: this.props.customBurgerIcon,
	              className: this.props.burgerButtonClassName,
	              barClassName: this.props.burgerBarClassName
	            })
	          )
	        );
	      }
	    }]);
	
	    return Menu;
	  })(_react.Component);
	
	  Menu.propTypes = {
	    bodyClassName: _propTypes2['default'].string,
	    burgerBarClassName: _propTypes2['default'].string,
	    burgerButtonClassName: _propTypes2['default'].string,
	    crossButtonClassName: _propTypes2['default'].string,
	    crossClassName: _propTypes2['default'].string,
	    customBurgerIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    customCrossIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    disableOverlayClick: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].func]),
	    id: _propTypes2['default'].string,
	    isOpen: _propTypes2['default'].bool,
	    itemListClassName: _propTypes2['default'].string,
	    menuClassName: _propTypes2['default'].string,
	    morphShapeClassName: _propTypes2['default'].string,
	    noOverlay: _propTypes2['default'].bool,
	    onStateChange: _propTypes2['default'].func,
	    outerContainerId: styles && styles.outerContainer ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    overlayClassName: _propTypes2['default'].string,
	    pageWrapId: styles && styles.pageWrap ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    right: _propTypes2['default'].bool,
	    styles: _propTypes2['default'].object,
	    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	  };
	
	  Menu.defaultProps = {
	    bodyClassName: '',
	    burgerBarClassName: '',
	    burgerButtonClassName: '',
	    className: '',
	    crossButtonClassName: '',
	    crossClassName: '',
	    id: '',
	    itemListClassName: '',
	    menuClassName: '',
	    morphShapeClassName: '',
	    noOverlay: false,
	    onStateChange: function onStateChange() {},
	    outerContainerId: '',
	    overlayClassName: '',
	    pageWrapId: '',
	    styles: {},
	    width: 300
	  };
	
	  return Menu;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _snapsvgImporter = __webpack_require__(297);
	
	var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);
	
	var _menuFactory = __webpack_require__(28);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  svg: {
	    lib: _snapsvgImporter2['default'],
	    pathInitial: 'M-7.312,0H0c0,0,0,113.839,0,400c0,264.506,0,400,0,400h-7.312V0z',
	    pathOpen: 'M-7.312,0H15c0,0,66,113.339,66,399.5C81,664.006,15,800,15,800H-7.312V0z;M-7.312,0H100c0,0,0,113.839,0,400c0,264.506,0,400,0,400H-7.312V0z',
	    animate: function animate(path) {
	      var pos = 0;
	      var steps = this.pathOpen.split(';');
	      var stepsTotal = steps.length;
	      var mina = window.mina;
	
	      var nextStep = function nextStep() {
	        if (pos > stepsTotal - 1) return;
	
	        path.animate({ path: steps[pos] }, pos === 0 ? 400 : 500, pos === 0 ? mina.easein : mina.elastic, function () {
	          nextStep();
	        });
	
	        pos++;
	      };
	
	      nextStep();
	    }
	  },
	
	  morphShape: function morphShape(isOpen, width, right) {
	    return {
	      position: 'absolute',
	      width: '100%',
	      height: '100%',
	      right: right ? 'inherit' : 0,
	      left: right ? 0 : 'inherit',
	      MozTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      MsTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      OTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      WebkitTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      transform: right ? 'rotateY(180deg)' : 'rotateY(0deg)'
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: isOpen ? 'transform 0.4s 0s' : 'transform 0.4s'
	    };
	  },
	
	  menu: function menu(isOpen, width, right) {
	    width -= 140;
	    return {
	      position: 'fixed',
	      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  },
	
	  item: function item(isOpen, width, right, nthChild) {
	    width -= 140;
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.3s 0.4s, transform 0.3s 0.4s' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  },
	
	  closeButton: function closeButton(isOpen, width, right) {
	    width -= 140;
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _snapsvgImporter = __webpack_require__(297);
	
	var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);
	
	var _menuFactory = __webpack_require__(28);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  svg: {
	    lib: _snapsvgImporter2['default'],
	    pathInitial: 'M-1,0h101c0,0-97.833,153.603-97.833,396.167C2.167,627.579,100,800,100,800H-1V0z',
	    pathOpen: 'M-1,0h101c0,0,0-1,0,395c0,404,0,405,0,405H-1V0z',
	    animate: function animate(path) {
	      path.animate({ path: this.pathOpen }, 400, window.mina.easeinout);
	    }
	  },
	
	  morphShape: function morphShape(isOpen, width, right) {
	    return {
	      position: 'absolute',
	      width: 120,
	      height: '100%',
	      right: right ? 'inherit' : 0,
	      left: right ? 0 : 'inherit',
	      MozTransform: right ? 'rotateY(180deg)' : '',
	      MsTransform: right ? 'rotateY(180deg)' : '',
	      OTransform: right ? 'rotateY(180deg)' : '',
	      WebkitTransform: right ? 'rotateY(180deg)' : '',
	      transform: right ? 'rotateY(180deg)' : ''
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: 'all 0.3s'
	    };
	  },
	
	  menu: function menu(isOpen, width, right) {
	    return {
	      position: 'fixed',
	      right: right ? 0 : 'inherit',
	      width: 180,
	      whiteSpace: 'nowrap',
	      boxSizing: 'border-box',
	      overflow: 'visible'
	    };
	  },
	
	  itemList: function itemList(isOpen, width, right) {
	    if (right) {
	      return {
	        position: 'relative',
	        left: '-110px',
	        width: '170%',
	        overflow: 'auto'
	      };
	    }
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      transition: isOpen ? 'all 0.3s' : 'all 0.3s 0.1s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(28);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      OTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      transform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      transition: 'all 0.5s ease-in-out'
	    };
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      perspectiveOrigin: '0% 50%',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(28);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(28);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      transformOrigin: right ? '100% 50%' : '0% 50%',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(28);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      visibility: isOpen ? 'visible' : 'hidden',
	      MozTransform: 'translate3d(0, 0, 0)',
	      MsTransform: 'translate3d(0, 0, 0)',
	      OTransform: 'translate3d(0, 0, 0)',
	      WebkitTransform: 'translate3d(0, 0, 0)',
	      transform: 'translate3d(0, 0, 0)',
	      zIndex: 1000
	    };
	  },
	
	  overlay: function overlay(isOpen, width, right) {
	    return {
	      zIndex: 1400,
	      MozTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      MsTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      OTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      WebkitTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transition: 'all 0.5s',
	      visibility: isOpen ? 'visible' : 'hidden'
	    };
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s',
	      zIndex: 1200,
	      position: 'relative'
	    };
	  },
	
	  burgerIcon: function burgerIcon(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      MsTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      OTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      WebkitTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transition: 'all 0.1s',
	      position: 'relative',
	      zIndex: 1300
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(28);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      MsTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      OTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      transform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      transformOrigin: '100%',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer() {
	    return {
	      perspective: '1500px'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(28);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(28);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(28);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0.4s cubic-bezier(0.7, 0, 0.3, 1)'
	    };
	  },
	
	  item: function item(isOpen, width, right, nthChild) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      OTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      transform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0s 0.2s cubic-bezier(0.7, 0, 0.3, 1)'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function () {
	  var Snap = undefined;
	  try {
	    Snap = __webpack_require__(610);
	  } finally {
	    return Snap;
	  }
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mixpanelShape = __webpack_require__(208);
	
	var _mixpanelShape2 = _interopRequireDefault(_mixpanelShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MixpanelProvider = function (_Component) {
	    _inherits(MixpanelProvider, _Component);
	
	    function MixpanelProvider(props, context) {
	        _classCallCheck(this, MixpanelProvider);
	
	        var _this = _possibleConstructorReturn(this, (MixpanelProvider.__proto__ || Object.getPrototypeOf(MixpanelProvider)).call(this, props, context));
	
	        _this._mixpanel = props.mixpanel;
	        return _this;
	    }
	
	    _createClass(MixpanelProvider, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return { mixpanel: this._mixpanel };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var children = this.props.children;
	
	            return _react.Children.only(children);
	        }
	    }]);
	
	    return MixpanelProvider;
	}(_react.Component);
	
	exports.default = MixpanelProvider;
	
	MixpanelProvider.propTypes = {
	    mixpanel: _mixpanelShape2.default.isRequired,
	    children: _propTypes2.default.element.isRequired
	};
	MixpanelProvider.childContextTypes = {
	    mixpanel: _mixpanelShape2.default.isRequired
	};

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MixpanelProvider = __webpack_require__(206);
	
	var _MixpanelProvider2 = _interopRequireDefault(_MixpanelProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MixpanelProvider2.default;

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.shape({
	    init: _propTypes2.default.func.isRequired,
	    track: _propTypes2.default.func.isRequired
	});

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	window.eve = __webpack_require__(446)
	
	// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	var mina = (function (eve) {
	    var animations = {},
	    requestAnimFrame = window.requestAnimationFrame       ||
	                       window.webkitRequestAnimationFrame ||
	                       window.mozRequestAnimationFrame    ||
	                       window.oRequestAnimationFrame      ||
	                       window.msRequestAnimationFrame     ||
	                       function (callback) {
	                           setTimeout(callback, 16, new Date().getTime());
	                           return true;
	                       },
	    requestID,
	    isArray = Array.isArray || function (a) {
	        return a instanceof Array ||
	            Object.prototype.toString.call(a) == "[object Array]";
	    },
	    idgen = 0,
	    idprefix = "M" + (+new Date).toString(36),
	    ID = function () {
	        return idprefix + (idgen++).toString(36);
	    },
	    diff = function (a, b, A, B) {
	        if (isArray(a)) {
	            res = [];
	            for (var i = 0, ii = a.length; i < ii; i++) {
	                res[i] = diff(a[i], b, A[i], B);
	            }
	            return res;
	        }
	        var dif = (A - a) / (B - b);
	        return function (bb) {
	            return a + dif * (bb - b);
	        };
	    },
	    timer = Date.now || function () {
	        return +new Date;
	    },
	    sta = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.s;
	        }
	        var ds = a.s - val;
	        a.b += a.dur * ds;
	        a.B += a.dur * ds;
	        a.s = val;
	    },
	    speed = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.spd;
	        }
	        a.spd = val;
	    },
	    duration = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.dur;
	        }
	        a.s = a.s * val / a.dur;
	        a.dur = val;
	    },
	    stopit = function () {
	        var a = this;
	        delete animations[a.id];
	        a.update();
	        eve("mina.stop." + a.id, a);
	    },
	    pause = function () {
	        var a = this;
	        if (a.pdif) {
	            return;
	        }
	        delete animations[a.id];
	        a.update();
	        a.pdif = a.get() - a.b;
	    },
	    resume = function () {
	        var a = this;
	        if (!a.pdif) {
	            return;
	        }
	        a.b = a.get() - a.pdif;
	        delete a.pdif;
	        animations[a.id] = a;
	        frame();
	    },
	    update = function () {
	        var a = this,
	            res;
	        if (isArray(a.start)) {
	            res = [];
	            for (var j = 0, jj = a.start.length; j < jj; j++) {
	                res[j] = +a.start[j] +
	                    (a.end[j] - a.start[j]) * a.easing(a.s);
	            }
	        } else {
	            res = +a.start + (a.end - a.start) * a.easing(a.s);
	        }
	        a.set(res);
	    },
	    frame = function (timeStamp) {
	        // Manual invokation?
	        if (!timeStamp) {
	            // Frame loop stopped?
	            if (!requestID) {
	                // Start frame loop...
	                requestID = requestAnimFrame(frame);
	            }
	            return;
	        }
	        var len = 0;
	        for (var i in animations) if (animations.hasOwnProperty(i)) {
	            var a = animations[i],
	                b = a.get(),
	                res;
	            len++;
	            a.s = (b - a.b) / (a.dur / a.spd);
	            if (a.s >= 1) {
	                delete animations[i];
	                a.s = 1;
	                len--;
	                (function (a) {
	                    setTimeout(function () {
	                        eve("mina.finish." + a.id, a);
	                    });
	                }(a));
	            }
	            a.update();
	        }
	        requestID = len ? requestAnimFrame(frame) : false;
	    },
	    /*\
	     * mina
	     [ method ]
	     **
	     * Generic animation of numbers
	     **
	     - a (number) start _slave_ number
	     - A (number) end _slave_ number
	     - b (number) start _master_ number (start time in general case)
	     - B (number) end _master_ number (end time in general case)
	     - get (function) getter of _master_ number (see @mina.time)
	     - set (function) setter of _slave_ number
	     - easing (function) #optional easing function, default is @mina.linear
	     = (object) animation descriptor
	     o {
	     o         id (string) animation id,
	     o         start (number) start _slave_ number,
	     o         end (number) end _slave_ number,
	     o         b (number) start _master_ number,
	     o         s (number) animation status (0..1),
	     o         dur (number) animation duration,
	     o         spd (number) animation speed,
	     o         get (function) getter of _master_ number (see @mina.time),
	     o         set (function) setter of _slave_ number,
	     o         easing (function) easing function, default is @mina.linear,
	     o         status (function) status getter/setter,
	     o         speed (function) speed getter/setter,
	     o         duration (function) duration getter/setter,
	     o         stop (function) animation stopper
	     o         pause (function) pauses the animation
	     o         resume (function) resumes the animation
	     o         update (function) calles setter with the right value of the animation
	     o }
	    \*/
	    mina = function (a, A, b, B, get, set, easing) {
	        var anim = {
	            id: ID(),
	            start: a,
	            end: A,
	            b: b,
	            s: 0,
	            dur: B - b,
	            spd: 1,
	            get: get,
	            set: set,
	            easing: easing || mina.linear,
	            status: sta,
	            speed: speed,
	            duration: duration,
	            stop: stopit,
	            pause: pause,
	            resume: resume,
	            update: update
	        };
	        animations[anim.id] = anim;
	        var len = 0, i;
	        for (i in animations) if (animations.hasOwnProperty(i)) {
	            len++;
	            if (len == 2) {
	                break;
	            }
	        }
	        len == 1 && frame();
	        return anim;
	    };
	    /*\
	     * mina.time
	     [ method ]
	     **
	     * Returns the current time. Equivalent to:
	     | function () {
	     |     return (new Date).getTime();
	     | }
	    \*/
	    mina.time = timer;
	    /*\
	     * mina.getById
	     [ method ]
	     **
	     * Returns an animation by its id
	     - id (string) animation's id
	     = (object) See @mina
	    \*/
	    mina.getById = function (id) {
	        return animations[id] || null;
	    };
	
	    /*\
	     * mina.linear
	     [ method ]
	     **
	     * Default linear easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.linear = function (n) {
	        return n;
	    };
	    /*\
	     * mina.easeout
	     [ method ]
	     **
	     * Easeout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easeout = function (n) {
	        return Math.pow(n, 1.7);
	    };
	    /*\
	     * mina.easein
	     [ method ]
	     **
	     * Easein easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easein = function (n) {
	        return Math.pow(n, .48);
	    };
	    /*\
	     * mina.easeinout
	     [ method ]
	     **
	     * Easeinout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easeinout = function (n) {
	        if (n == 1) {
	            return 1;
	        }
	        if (n == 0) {
	            return 0;
	        }
	        var q = .48 - n / 1.04,
	            Q = Math.sqrt(.1734 + q * q),
	            x = Q - q,
	            X = Math.pow(Math.abs(x), 1 / 3) * (x < 0 ? -1 : 1),
	            y = -Q - q,
	            Y = Math.pow(Math.abs(y), 1 / 3) * (y < 0 ? -1 : 1),
	            t = X + Y + .5;
	        return (1 - t) * 3 * t * t + t * t * t;
	    };
	    /*\
	     * mina.backin
	     [ method ]
	     **
	     * Backin easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.backin = function (n) {
	        if (n == 1) {
	            return 1;
	        }
	        var s = 1.70158;
	        return n * n * ((s + 1) * n - s);
	    };
	    /*\
	     * mina.backout
	     [ method ]
	     **
	     * Backout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.backout = function (n) {
	        if (n == 0) {
	            return 0;
	        }
	        n = n - 1;
	        var s = 1.70158;
	        return n * n * ((s + 1) * n + s) + 1;
	    };
	    /*\
	     * mina.elastic
	     [ method ]
	     **
	     * Elastic easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.elastic = function (n) {
	        if (n == !!n) {
	            return n;
	        }
	        return Math.pow(2, -10 * n) * Math.sin((n - .075) *
	            (2 * Math.PI) / .3) + 1;
	    };
	    /*\
	     * mina.bounce
	     [ method ]
	     **
	     * Bounce easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.bounce = function (n) {
	        var s = 7.5625,
	            p = 2.75,
	            l;
	        if (n < 1 / p) {
	            l = s * n * n;
	        } else {
	            if (n < 2 / p) {
	                n -= 1.5 / p;
	                l = s * n * n + .75;
	            } else {
	                if (n < 2.5 / p) {
	                    n -= 2.25 / p;
	                    l = s * n * n + .9375;
	                } else {
	                    n -= 2.625 / p;
	                    l = s * n * n + .984375;
	                }
	            }
	        }
	        return l;
	    };
	    window.mina = mina;
	    return mina;
	})(typeof eve == "undefined" ? function () {} : eve);
	
	// Copyright (c) 2013 - 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	
	var Snap = (function(root) {
	Snap.version = "0.5.1";
	/*\
	 * Snap
	 [ method ]
	 **
	 * Creates a drawing surface or wraps existing SVG element.
	 **
	 - width (number|string) width of surface
	 - height (number|string) height of surface
	 * or
	 - DOM (SVGElement) element to be wrapped into Snap structure
	 * or
	 - array (array) array of elements (will return set of elements)
	 * or
	 - query (string) CSS query selector
	 = (object) @Element
	\*/
	function Snap(w, h) {
	    if (w) {
	        if (w.nodeType) {
	            return wrap(w);
	        }
	        if (is(w, "array") && Snap.set) {
	            return Snap.set.apply(Snap, w);
	        }
	        if (w instanceof Element) {
	            return w;
	        }
	        if (h == null) {
	            try {
	                w = glob.doc.querySelector(String(w));
	                return wrap(w);
	            } catch (e) {
	                return null;
	            }
	        }
	    }
	    w = w == null ? "100%" : w;
	    h = h == null ? "100%" : h;
	    return new Paper(w, h);
	}
	Snap.toString = function () {
	    return "Snap v" + this.version;
	};
	Snap._ = {};
	var glob = {
	    win: root.window,
	    doc: root.window.document
	};
	Snap._.glob = glob;
	var has = "hasOwnProperty",
	    Str = String,
	    toFloat = parseFloat,
	    toInt = parseInt,
	    math = Math,
	    mmax = math.max,
	    mmin = math.min,
	    abs = math.abs,
	    pow = math.pow,
	    PI = math.PI,
	    round = math.round,
	    E = "",
	    S = " ",
	    objectToString = Object.prototype.toString,
	    ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i,
	    colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,
	    bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
	    separator = Snap._.separator = /[,\s]+/,
	    whitespace = /[\s]/g,
	    commaSpaces = /[\s]*,[\s]*/,
	    hsrg = {hs: 1, rg: 1},
	    pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
	    tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
	    pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/ig,
	    idgen = 0,
	    idprefix = "S" + (+new Date).toString(36),
	    ID = function (el) {
	        return (el && el.type ? el.type : E) + idprefix + (idgen++).toString(36);
	    },
	    xlink = "http://www.w3.org/1999/xlink",
	    xmlns = "http://www.w3.org/2000/svg",
	    hub = {},
	    /*\
	     * Snap.url
	     [ method ]
	     **
	     * Wraps path into `"url('<path>')"`.
	     - value (string) path
	     = (string) wrapped path
	    \*/
	    URL = Snap.url = function (url) {
	        return "url('#" + url + "')";
	    };
	
	function $(el, attr) {
	    if (attr) {
	        if (el == "#text") {
	            el = glob.doc.createTextNode(attr.text || attr["#text"] || "");
	        }
	        if (el == "#comment") {
	            el = glob.doc.createComment(attr.text || attr["#text"] || "");
	        }
	        if (typeof el == "string") {
	            el = $(el);
	        }
	        if (typeof attr == "string") {
	            if (el.nodeType == 1) {
	                if (attr.substring(0, 6) == "xlink:") {
	                    return el.getAttributeNS(xlink, attr.substring(6));
	                }
	                if (attr.substring(0, 4) == "xml:") {
	                    return el.getAttributeNS(xmlns, attr.substring(4));
	                }
	                return el.getAttribute(attr);
	            } else if (attr == "text") {
	                return el.nodeValue;
	            } else {
	                return null;
	            }
	        }
	        if (el.nodeType == 1) {
	            for (var key in attr) if (attr[has](key)) {
	                var val = Str(attr[key]);
	                if (val) {
	                    if (key.substring(0, 6) == "xlink:") {
	                        el.setAttributeNS(xlink, key.substring(6), val);
	                    } else if (key.substring(0, 4) == "xml:") {
	                        el.setAttributeNS(xmlns, key.substring(4), val);
	                    } else {
	                        el.setAttribute(key, val);
	                    }
	                } else {
	                    el.removeAttribute(key);
	                }
	            }
	        } else if ("text" in attr) {
	            el.nodeValue = attr.text;
	        }
	    } else {
	        el = glob.doc.createElementNS(xmlns, el);
	    }
	    return el;
	}
	Snap._.$ = $;
	Snap._.id = ID;
	function getAttrs(el) {
	    var attrs = el.attributes,
	        name,
	        out = {};
	    for (var i = 0; i < attrs.length; i++) {
	        if (attrs[i].namespaceURI == xlink) {
	            name = "xlink:";
	        } else {
	            name = "";
	        }
	        name += attrs[i].name;
	        out[name] = attrs[i].textContent;
	    }
	    return out;
	}
	function is(o, type) {
	    type = Str.prototype.toLowerCase.call(type);
	    if (type == "finite") {
	        return isFinite(o);
	    }
	    if (type == "array" &&
	        (o instanceof Array || Array.isArray && Array.isArray(o))) {
	        return true;
	    }
	    return  type == "null" && o === null ||
	            type == typeof o && o !== null ||
	            type == "object" && o === Object(o) ||
	            objectToString.call(o).slice(8, -1).toLowerCase() == type;
	}
	/*\
	 * Snap.format
	 [ method ]
	 **
	 * Replaces construction of type `{<name>}` to the corresponding argument
	 **
	 - token (string) string to format
	 - json (object) object which properties are used as a replacement
	 = (string) formatted string
	 > Usage
	 | // this draws a rectangular shape equivalent to "M10,20h40v50h-40z"
	 | paper.path(Snap.format("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
	 |     x: 10,
	 |     y: 20,
	 |     dim: {
	 |         width: 40,
	 |         height: 50,
	 |         "negative width": -40
	 |     }
	 | }));
	\*/
	Snap.format = (function () {
	    var tokenRegex = /\{([^\}]+)\}/g,
	        objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, // matches .xxxxx or ["xxxxx"] to run over object properties
	        replacer = function (all, key, obj) {
	            var res = obj;
	            key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
	                name = name || quotedName;
	                if (res) {
	                    if (name in res) {
	                        res = res[name];
	                    }
	                    typeof res == "function" && isFunc && (res = res());
	                }
	            });
	            res = (res == null || res == obj ? all : res) + "";
	            return res;
	        };
	    return function (str, obj) {
	        return Str(str).replace(tokenRegex, function (all, key) {
	            return replacer(all, key, obj);
	        });
	    };
	})();
	function clone(obj) {
	    if (typeof obj == "function" || Object(obj) !== obj) {
	        return obj;
	    }
	    var res = new obj.constructor;
	    for (var key in obj) if (obj[has](key)) {
	        res[key] = clone(obj[key]);
	    }
	    return res;
	}
	Snap._.clone = clone;
	function repush(array, item) {
	    for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
	        return array.push(array.splice(i, 1)[0]);
	    }
	}
	function cacher(f, scope, postprocessor) {
	    function newf() {
	        var arg = Array.prototype.slice.call(arguments, 0),
	            args = arg.join("\u2400"),
	            cache = newf.cache = newf.cache || {},
	            count = newf.count = newf.count || [];
	        if (cache[has](args)) {
	            repush(count, args);
	            return postprocessor ? postprocessor(cache[args]) : cache[args];
	        }
	        count.length >= 1e3 && delete cache[count.shift()];
	        count.push(args);
	        cache[args] = f.apply(scope, arg);
	        return postprocessor ? postprocessor(cache[args]) : cache[args];
	    }
	    return newf;
	}
	Snap._.cacher = cacher;
	function angle(x1, y1, x2, y2, x3, y3) {
	    if (x3 == null) {
	        var x = x1 - x2,
	            y = y1 - y2;
	        if (!x && !y) {
	            return 0;
	        }
	        return (180 + math.atan2(-y, -x) * 180 / PI + 360) % 360;
	    } else {
	        return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
	    }
	}
	function rad(deg) {
	    return deg % 360 * PI / 180;
	}
	function deg(rad) {
	    return rad * 180 / PI % 360;
	}
	function x_y() {
	    return this.x + S + this.y;
	}
	function x_y_w_h() {
	    return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
	}
	
	/*\
	 * Snap.rad
	 [ method ]
	 **
	 * Transform angle to radians
	 - deg (number) angle in degrees
	 = (number) angle in radians
	\*/
	Snap.rad = rad;
	/*\
	 * Snap.deg
	 [ method ]
	 **
	 * Transform angle to degrees
	 - rad (number) angle in radians
	 = (number) angle in degrees
	\*/
	Snap.deg = deg;
	/*\
	 * Snap.sin
	 [ method ]
	 **
	 * Equivalent to `Math.sin()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) sin
	\*/
	Snap.sin = function (angle) {
	    return math.sin(Snap.rad(angle));
	};
	/*\
	 * Snap.tan
	 [ method ]
	 **
	 * Equivalent to `Math.tan()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) tan
	\*/
	Snap.tan = function (angle) {
	    return math.tan(Snap.rad(angle));
	};
	/*\
	 * Snap.cos
	 [ method ]
	 **
	 * Equivalent to `Math.cos()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) cos
	\*/
	Snap.cos = function (angle) {
	    return math.cos(Snap.rad(angle));
	};
	/*\
	 * Snap.asin
	 [ method ]
	 **
	 * Equivalent to `Math.asin()` only works with degrees, not radians.
	 - num (number) value
	 = (number) asin in degrees
	\*/
	Snap.asin = function (num) {
	    return Snap.deg(math.asin(num));
	};
	/*\
	 * Snap.acos
	 [ method ]
	 **
	 * Equivalent to `Math.acos()` only works with degrees, not radians.
	 - num (number) value
	 = (number) acos in degrees
	\*/
	Snap.acos = function (num) {
	    return Snap.deg(math.acos(num));
	};
	/*\
	 * Snap.atan
	 [ method ]
	 **
	 * Equivalent to `Math.atan()` only works with degrees, not radians.
	 - num (number) value
	 = (number) atan in degrees
	\*/
	Snap.atan = function (num) {
	    return Snap.deg(math.atan(num));
	};
	/*\
	 * Snap.atan2
	 [ method ]
	 **
	 * Equivalent to `Math.atan2()` only works with degrees, not radians.
	 - num (number) value
	 = (number) atan2 in degrees
	\*/
	Snap.atan2 = function (num) {
	    return Snap.deg(math.atan2(num));
	};
	/*\
	 * Snap.angle
	 [ method ]
	 **
	 * Returns an angle between two or three points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 - x3 (number) #optional x coord of third point
	 - y3 (number) #optional y coord of third point
	 = (number) angle in degrees
	\*/
	Snap.angle = angle;
	/*\
	 * Snap.len
	 [ method ]
	 **
	 * Returns distance between two points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 = (number) distance
	\*/
	Snap.len = function (x1, y1, x2, y2) {
	    return Math.sqrt(Snap.len2(x1, y1, x2, y2));
	};
	/*\
	 * Snap.len2
	 [ method ]
	 **
	 * Returns squared distance between two points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 = (number) distance
	\*/
	Snap.len2 = function (x1, y1, x2, y2) {
	    return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
	};
	/*\
	 * Snap.closestPoint
	 [ method ]
	 **
	 * Returns closest point to a given one on a given path.
	 - path (Element) path element
	 - x (number) x coord of a point
	 - y (number) y coord of a point
	 = (object) in format
	 {
	    x (number) x coord of the point on the path
	    y (number) y coord of the point on the path
	    length (number) length of the path to the point
	    distance (number) distance from the given point to the path
	 }
	\*/
	// Copied from http://bl.ocks.org/mbostock/8027637
	Snap.closestPoint = function (path, x, y) {
	    function distance2(p) {
	        var dx = p.x - x,
	            dy = p.y - y;
	        return dx * dx + dy * dy;
	    }
	    var pathNode = path.node,
	        pathLength = pathNode.getTotalLength(),
	        precision = pathLength / pathNode.pathSegList.numberOfItems * .125,
	        best,
	        bestLength,
	        bestDistance = Infinity;
	
	    // linear scan for coarse approximation
	    for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
	        if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
	            best = scan;
	            bestLength = scanLength;
	            bestDistance = scanDistance;
	        }
	    }
	
	    // binary search for precise estimate
	    precision *= .5;
	    while (precision > .5) {
	        var before,
	            after,
	            beforeLength,
	            afterLength,
	            beforeDistance,
	            afterDistance;
	        if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
	            best = before;
	            bestLength = beforeLength;
	            bestDistance = beforeDistance;
	        } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
	            best = after;
	            bestLength = afterLength;
	            bestDistance = afterDistance;
	        } else {
	            precision *= .5;
	        }
	    }
	
	    best = {
	        x: best.x,
	        y: best.y,
	        length: bestLength,
	        distance: Math.sqrt(bestDistance)
	    };
	    return best;
	}
	/*\
	 * Snap.is
	 [ method ]
	 **
	 * Handy replacement for the `typeof` operator
	 - o (…) any object or primitive
	 - type (string) name of the type, e.g., `string`, `function`, `number`, etc.
	 = (boolean) `true` if given value is of given type
	\*/
	Snap.is = is;
	/*\
	 * Snap.snapTo
	 [ method ]
	 **
	 * Snaps given value to given grid
	 - values (array|number) given array of values or step of the grid
	 - value (number) value to adjust
	 - tolerance (number) #optional maximum distance to the target value that would trigger the snap. Default is `10`.
	 = (number) adjusted value
	\*/
	Snap.snapTo = function (values, value, tolerance) {
	    tolerance = is(tolerance, "finite") ? tolerance : 10;
	    if (is(values, "array")) {
	        var i = values.length;
	        while (i--) if (abs(values[i] - value) <= tolerance) {
	            return values[i];
	        }
	    } else {
	        values = +values;
	        var rem = value % values;
	        if (rem < tolerance) {
	            return value - rem;
	        }
	        if (rem > values - tolerance) {
	            return value - rem + values;
	        }
	    }
	    return value;
	};
	// Colour
	/*\
	 * Snap.getRGB
	 [ method ]
	 **
	 * Parses color string as RGB object
	 - color (string) color string in one of the following formats:
	 # <ul>
	 #     <li>Color name (<code>red</code>, <code>green</code>, <code>cornflowerblue</code>, etc)</li>
	 #     <li>#••• — shortened HTML color: (<code>#000</code>, <code>#fc0</code>, etc.)</li>
	 #     <li>#•••••• — full length HTML color: (<code>#000000</code>, <code>#bd2300</code>)</li>
	 #     <li>rgb(•••, •••, •••) — red, green and blue channels values: (<code>rgb(200,&nbsp;100,&nbsp;0)</code>)</li>
	 #     <li>rgba(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>)</li>
	 #     <li>rgba(•••%, •••%, •••%, •••%) — also with opacity</li>
	 #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>)</li>
	 #     <li>hsba(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
	 #     <li>hsba(•••%, •••%, •••%, •••%) — also with opacity</li>
	 #     <li>hsl(•••, •••, •••) — hue, saturation and luminosity values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;0.5)</code>)</li>
	 #     <li>hsla(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
	 #     <li>hsla(•••%, •••%, •••%, •••%) — also with opacity</li>
	 # </ul>
	 * Note that `%` can be used any time: `rgb(20%, 255, 50%)`.
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••,
	 o     error (boolean) true if string can't be parsed
	 o }
	\*/
	Snap.getRGB = cacher(function (colour) {
	    if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
	        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	    }
	    if (colour == "none") {
	        return {r: -1, g: -1, b: -1, hex: "none", toString: rgbtoString};
	    }
	    !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
	    if (!colour) {
	        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	    }
	    var res,
	        red,
	        green,
	        blue,
	        opacity,
	        t,
	        values,
	        rgb = colour.match(colourRegExp);
	    if (rgb) {
	        if (rgb[2]) {
	            blue = toInt(rgb[2].substring(5), 16);
	            green = toInt(rgb[2].substring(3, 5), 16);
	            red = toInt(rgb[2].substring(1, 3), 16);
	        }
	        if (rgb[3]) {
	            blue = toInt((t = rgb[3].charAt(3)) + t, 16);
	            green = toInt((t = rgb[3].charAt(2)) + t, 16);
	            red = toInt((t = rgb[3].charAt(1)) + t, 16);
	        }
	        if (rgb[4]) {
	            values = rgb[4].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red *= 2.55);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green *= 2.55);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue *= 2.55);
	            rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	        }
	        if (rgb[5]) {
	            values = rgb[5].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red /= 100);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green /= 100);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue /= 100);
	            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
	            rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	            return Snap.hsb2rgb(red, green, blue, opacity);
	        }
	        if (rgb[6]) {
	            values = rgb[6].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red /= 100);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green /= 100);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue /= 100);
	            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
	            rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	            return Snap.hsl2rgb(red, green, blue, opacity);
	        }
	        red = mmin(math.round(red), 255);
	        green = mmin(math.round(green), 255);
	        blue = mmin(math.round(blue), 255);
	        opacity = mmin(mmax(opacity, 0), 1);
	        rgb = {r: red, g: green, b: blue, toString: rgbtoString};
	        rgb.hex = "#" + (16777216 | blue | green << 8 | red << 16).toString(16).slice(1);
	        rgb.opacity = is(opacity, "finite") ? opacity : 1;
	        return rgb;
	    }
	    return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	}, Snap);
	/*\
	 * Snap.hsb
	 [ method ]
	 **
	 * Converts HSB values to a hex representation of the color
	 - h (number) hue
	 - s (number) saturation
	 - b (number) value or brightness
	 = (string) hex representation of the color
	\*/
	Snap.hsb = cacher(function (h, s, b) {
	    return Snap.hsb2rgb(h, s, b).hex;
	});
	/*\
	 * Snap.hsl
	 [ method ]
	 **
	 * Converts HSL values to a hex representation of the color
	 - h (number) hue
	 - s (number) saturation
	 - l (number) luminosity
	 = (string) hex representation of the color
	\*/
	Snap.hsl = cacher(function (h, s, l) {
	    return Snap.hsl2rgb(h, s, l).hex;
	});
	/*\
	 * Snap.rgb
	 [ method ]
	 **
	 * Converts RGB values to a hex representation of the color
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (string) hex representation of the color
	\*/
	Snap.rgb = cacher(function (r, g, b, o) {
	    if (is(o, "finite")) {
	        var round = math.round;
	        return "rgba(" + [round(r), round(g), round(b), +o.toFixed(2)] + ")";
	    }
	    return "#" + (16777216 | b | g << 8 | r << 16).toString(16).slice(1);
	});
	var toHex = function (color) {
	    var i = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0],
	        red = "rgb(255, 0, 0)";
	    toHex = cacher(function (color) {
	        if (color.toLowerCase() == "red") {
	            return red;
	        }
	        i.style.color = red;
	        i.style.color = color;
	        var out = glob.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
	        return out == red ? null : out;
	    });
	    return toHex(color);
	},
	hsbtoString = function () {
	    return "hsb(" + [this.h, this.s, this.b] + ")";
	},
	hsltoString = function () {
	    return "hsl(" + [this.h, this.s, this.l] + ")";
	},
	rgbtoString = function () {
	    return this.opacity == 1 || this.opacity == null ?
	            this.hex :
	            "rgba(" + [this.r, this.g, this.b, this.opacity] + ")";
	},
	prepareRGB = function (r, g, b) {
	    if (g == null && is(r, "object") && "r" in r && "g" in r && "b" in r) {
	        b = r.b;
	        g = r.g;
	        r = r.r;
	    }
	    if (g == null && is(r, string)) {
	        var clr = Snap.getRGB(r);
	        r = clr.r;
	        g = clr.g;
	        b = clr.b;
	    }
	    if (r > 1 || g > 1 || b > 1) {
	        r /= 255;
	        g /= 255;
	        b /= 255;
	    }
	
	    return [r, g, b];
	},
	packageRGB = function (r, g, b, o) {
	    r = math.round(r * 255);
	    g = math.round(g * 255);
	    b = math.round(b * 255);
	    var rgb = {
	        r: r,
	        g: g,
	        b: b,
	        opacity: is(o, "finite") ? o : 1,
	        hex: Snap.rgb(r, g, b),
	        toString: rgbtoString
	    };
	    is(o, "finite") && (rgb.opacity = o);
	    return rgb;
	};
	/*\
	 * Snap.color
	 [ method ]
	 **
	 * Parses the color string and returns an object featuring the color's component values
	 - clr (string) color string in one of the supported formats (see @Snap.getRGB)
	 = (object) Combined RGB/HSB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••,
	 o     error (boolean) `true` if string can't be parsed,
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     v (number) value (brightness),
	 o     l (number) lightness
	 o }
	\*/
	Snap.color = function (clr) {
	    var rgb;
	    if (is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
	        rgb = Snap.hsb2rgb(clr);
	        clr.r = rgb.r;
	        clr.g = rgb.g;
	        clr.b = rgb.b;
	        clr.opacity = 1;
	        clr.hex = rgb.hex;
	    } else if (is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
	        rgb = Snap.hsl2rgb(clr);
	        clr.r = rgb.r;
	        clr.g = rgb.g;
	        clr.b = rgb.b;
	        clr.opacity = 1;
	        clr.hex = rgb.hex;
	    } else {
	        if (is(clr, "string")) {
	            clr = Snap.getRGB(clr);
	        }
	        if (is(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
	            rgb = Snap.rgb2hsl(clr);
	            clr.h = rgb.h;
	            clr.s = rgb.s;
	            clr.l = rgb.l;
	            rgb = Snap.rgb2hsb(clr);
	            clr.v = rgb.b;
	        } else {
	            clr = {hex: "none"};
	            clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
	            clr.error = 1;
	        }
	    }
	    clr.toString = rgbtoString;
	    return clr;
	};
	/*\
	 * Snap.hsb2rgb
	 [ method ]
	 **
	 * Converts HSB values to an RGB object
	 - h (number) hue
	 - s (number) saturation
	 - v (number) value or brightness
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••
	 o }
	\*/
	Snap.hsb2rgb = function (h, s, v, o) {
	    if (is(h, "object") && "h" in h && "s" in h && "b" in h) {
	        v = h.b;
	        s = h.s;
	        o = h.o;
	        h = h.h;
	    }
	    h *= 360;
	    var R, G, B, X, C;
	    h = h % 360 / 60;
	    C = v * s;
	    X = C * (1 - abs(h % 2 - 1));
	    R = G = B = v - C;
	
	    h = ~~h;
	    R += [C, X, 0, 0, X, C][h];
	    G += [X, C, C, X, 0, 0][h];
	    B += [0, 0, X, C, C, X][h];
	    return packageRGB(R, G, B, o);
	};
	/*\
	 * Snap.hsl2rgb
	 [ method ]
	 **
	 * Converts HSL values to an RGB object
	 - h (number) hue
	 - s (number) saturation
	 - l (number) luminosity
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••
	 o }
	\*/
	Snap.hsl2rgb = function (h, s, l, o) {
	    if (is(h, "object") && "h" in h && "s" in h && "l" in h) {
	        l = h.l;
	        s = h.s;
	        h = h.h;
	    }
	    if (h > 1 || s > 1 || l > 1) {
	        h /= 360;
	        s /= 100;
	        l /= 100;
	    }
	    h *= 360;
	    var R, G, B, X, C;
	    h = h % 360 / 60;
	    C = 2 * s * (l < .5 ? l : 1 - l);
	    X = C * (1 - abs(h % 2 - 1));
	    R = G = B = l - C / 2;
	
	    h = ~~h;
	    R += [C, X, 0, 0, X, C][h];
	    G += [X, C, C, X, 0, 0][h];
	    B += [0, 0, X, C, C, X][h];
	    return packageRGB(R, G, B, o);
	};
	/*\
	 * Snap.rgb2hsb
	 [ method ]
	 **
	 * Converts RGB values to an HSB object
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (object) HSB object in the following format:
	 o {
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     b (number) brightness
	 o }
	\*/
	Snap.rgb2hsb = function (r, g, b) {
	    b = prepareRGB(r, g, b);
	    r = b[0];
	    g = b[1];
	    b = b[2];
	
	    var H, S, V, C;
	    V = mmax(r, g, b);
	    C = V - mmin(r, g, b);
	    H = C == 0 ? null :
	        V == r ? (g - b) / C :
	        V == g ? (b - r) / C + 2 :
	                 (r - g) / C + 4;
	    H = (H + 360) % 6 * 60 / 360;
	    S = C == 0 ? 0 : C / V;
	    return {h: H, s: S, b: V, toString: hsbtoString};
	};
	/*\
	 * Snap.rgb2hsl
	 [ method ]
	 **
	 * Converts RGB values to an HSL object
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (object) HSL object in the following format:
	 o {
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     l (number) luminosity
	 o }
	\*/
	Snap.rgb2hsl = function (r, g, b) {
	    b = prepareRGB(r, g, b);
	    r = b[0];
	    g = b[1];
	    b = b[2];
	
	    var H, S, L, M, m, C;
	    M = mmax(r, g, b);
	    m = mmin(r, g, b);
	    C = M - m;
	    H = C == 0 ? null :
	        M == r ? (g - b) / C :
	        M == g ? (b - r) / C + 2 :
	                 (r - g) / C + 4;
	    H = (H + 360) % 6 * 60 / 360;
	    L = (M + m) / 2;
	    S = C == 0 ? 0 :
	         L < .5 ? C / (2 * L) :
	                  C / (2 - 2 * L);
	    return {h: H, s: S, l: L, toString: hsltoString};
	};
	
	// Transformations
	/*\
	 * Snap.parsePathString
	 [ method ]
	 **
	 * Utility method
	 **
	 * Parses given path string into an array of arrays of path segments
	 - pathString (string|array) path string or array of segments (in the last case it is returned straight away)
	 = (array) array of segments
	\*/
	Snap.parsePathString = function (pathString) {
	    if (!pathString) {
	        return null;
	    }
	    var pth = Snap.path(pathString);
	    if (pth.arr) {
	        return Snap.path.clone(pth.arr);
	    }
	
	    var paramCounts = {a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0},
	        data = [];
	    if (is(pathString, "array") && is(pathString[0], "array")) { // rough assumption
	        data = Snap.path.clone(pathString);
	    }
	    if (!data.length) {
	        Str(pathString).replace(pathCommand, function (a, b, c) {
	            var params = [],
	                name = b.toLowerCase();
	            c.replace(pathValues, function (a, b) {
	                b && params.push(+b);
	            });
	            if (name == "m" && params.length > 2) {
	                data.push([b].concat(params.splice(0, 2)));
	                name = "l";
	                b = b == "m" ? "l" : "L";
	            }
	            if (name == "o" && params.length == 1) {
	                data.push([b, params[0]]);
	            }
	            if (name == "r") {
	                data.push([b].concat(params));
	            } else while (params.length >= paramCounts[name]) {
	                data.push([b].concat(params.splice(0, paramCounts[name])));
	                if (!paramCounts[name]) {
	                    break;
	                }
	            }
	        });
	    }
	    data.toString = Snap.path.toString;
	    pth.arr = Snap.path.clone(data);
	    return data;
	};
	/*\
	 * Snap.parseTransformString
	 [ method ]
	 **
	 * Utility method
	 **
	 * Parses given transform string into an array of transformations
	 - TString (string|array) transform string or array of transformations (in the last case it is returned straight away)
	 = (array) array of transformations
	\*/
	var parseTransformString = Snap.parseTransformString = function (TString) {
	    if (!TString) {
	        return null;
	    }
	    var paramCounts = {r: 3, s: 4, t: 2, m: 6},
	        data = [];
	    if (is(TString, "array") && is(TString[0], "array")) { // rough assumption
	        data = Snap.path.clone(TString);
	    }
	    if (!data.length) {
	        Str(TString).replace(tCommand, function (a, b, c) {
	            var params = [],
	                name = b.toLowerCase();
	            c.replace(pathValues, function (a, b) {
	                b && params.push(+b);
	            });
	            data.push([b].concat(params));
	        });
	    }
	    data.toString = Snap.path.toString;
	    return data;
	};
	function svgTransform2string(tstr) {
	    var res = [];
	    tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function (all, name, params) {
	        params = params.split(/\s*,\s*|\s+/);
	        if (name == "rotate" && params.length == 1) {
	            params.push(0, 0);
	        }
	        if (name == "scale") {
	            if (params.length > 2) {
	                params = params.slice(0, 2);
	            } else if (params.length == 2) {
	                params.push(0, 0);
	            }
	            if (params.length == 1) {
	                params.push(params[0], 0, 0);
	            }
	        }
	        if (name == "skewX") {
	            res.push(["m", 1, 0, math.tan(rad(params[0])), 1, 0, 0]);
	        } else if (name == "skewY") {
	            res.push(["m", 1, math.tan(rad(params[0])), 0, 1, 0, 0]);
	        } else {
	            res.push([name.charAt(0)].concat(params));
	        }
	        return all;
	    });
	    return res;
	}
	Snap._.svgTransform2string = svgTransform2string;
	Snap._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
	function transform2matrix(tstr, bbox) {
	    var tdata = parseTransformString(tstr),
	        m = new Snap.Matrix;
	    if (tdata) {
	        for (var i = 0, ii = tdata.length; i < ii; i++) {
	            var t = tdata[i],
	                tlen = t.length,
	                command = Str(t[0]).toLowerCase(),
	                absolute = t[0] != command,
	                inver = absolute ? m.invert() : 0,
	                x1,
	                y1,
	                x2,
	                y2,
	                bb;
	            if (command == "t" && tlen == 2){
	                m.translate(t[1], 0);
	            } else if (command == "t" && tlen == 3) {
	                if (absolute) {
	                    x1 = inver.x(0, 0);
	                    y1 = inver.y(0, 0);
	                    x2 = inver.x(t[1], t[2]);
	                    y2 = inver.y(t[1], t[2]);
	                    m.translate(x2 - x1, y2 - y1);
	                } else {
	                    m.translate(t[1], t[2]);
	                }
	            } else if (command == "r") {
	                if (tlen == 2) {
	                    bb = bb || bbox;
	                    m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
	                } else if (tlen == 4) {
	                    if (absolute) {
	                        x2 = inver.x(t[2], t[3]);
	                        y2 = inver.y(t[2], t[3]);
	                        m.rotate(t[1], x2, y2);
	                    } else {
	                        m.rotate(t[1], t[2], t[3]);
	                    }
	                }
	            } else if (command == "s") {
	                if (tlen == 2 || tlen == 3) {
	                    bb = bb || bbox;
	                    m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
	                } else if (tlen == 4) {
	                    if (absolute) {
	                        x2 = inver.x(t[2], t[3]);
	                        y2 = inver.y(t[2], t[3]);
	                        m.scale(t[1], t[1], x2, y2);
	                    } else {
	                        m.scale(t[1], t[1], t[2], t[3]);
	                    }
	                } else if (tlen == 5) {
	                    if (absolute) {
	                        x2 = inver.x(t[3], t[4]);
	                        y2 = inver.y(t[3], t[4]);
	                        m.scale(t[1], t[2], x2, y2);
	                    } else {
	                        m.scale(t[1], t[2], t[3], t[4]);
	                    }
	                }
	            } else if (command == "m" && tlen == 7) {
	                m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
	            }
	        }
	    }
	    return m;
	}
	Snap._.transform2matrix = transform2matrix;
	Snap._unit2px = unit2px;
	var contains = glob.doc.contains || glob.doc.compareDocumentPosition ?
	    function (a, b) {
	        var adown = a.nodeType == 9 ? a.documentElement : a,
	            bup = b && b.parentNode;
	            return a == bup || !!(bup && bup.nodeType == 1 && (
	                adown.contains ?
	                    adown.contains(bup) :
	                    a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
	            ));
	    } :
	    function (a, b) {
	        if (b) {
	            while (b) {
	                b = b.parentNode;
	                if (b == a) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	function getSomeDefs(el) {
	    var p = el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) ||
	            el.node.parentNode && wrap(el.node.parentNode) ||
	            Snap.select("svg") ||
	            Snap(0, 0),
	        pdefs = p.select("defs"),
	        defs  = pdefs == null ? false : pdefs.node;
	    if (!defs) {
	        defs = make("defs", p.node).node;
	    }
	    return defs;
	}
	function getSomeSVG(el) {
	    return el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || Snap.select("svg");
	}
	Snap._.getSomeDefs = getSomeDefs;
	Snap._.getSomeSVG = getSomeSVG;
	function unit2px(el, name, value) {
	    var svg = getSomeSVG(el).node,
	        out = {},
	        mgr = svg.querySelector(".svg---mgr");
	    if (!mgr) {
	        mgr = $("rect");
	        $(mgr, {x: -9e9, y: -9e9, width: 10, height: 10, "class": "svg---mgr", fill: "none"});
	        svg.appendChild(mgr);
	    }
	    function getW(val) {
	        if (val == null) {
	            return E;
	        }
	        if (val == +val) {
	            return val;
	        }
	        $(mgr, {width: val});
	        try {
	            return mgr.getBBox().width;
	        } catch (e) {
	            return 0;
	        }
	    }
	    function getH(val) {
	        if (val == null) {
	            return E;
	        }
	        if (val == +val) {
	            return val;
	        }
	        $(mgr, {height: val});
	        try {
	            return mgr.getBBox().height;
	        } catch (e) {
	            return 0;
	        }
	    }
	    function set(nam, f) {
	        if (name == null) {
	            out[nam] = f(el.attr(nam) || 0);
	        } else if (nam == name) {
	            out = f(value == null ? el.attr(nam) || 0 : value);
	        }
	    }
	    switch (el.type) {
	        case "rect":
	            set("rx", getW);
	            set("ry", getH);
	        case "image":
	            set("width", getW);
	            set("height", getH);
	        case "text":
	            set("x", getW);
	            set("y", getH);
	        break;
	        case "circle":
	            set("cx", getW);
	            set("cy", getH);
	            set("r", getW);
	        break;
	        case "ellipse":
	            set("cx", getW);
	            set("cy", getH);
	            set("rx", getW);
	            set("ry", getH);
	        break;
	        case "line":
	            set("x1", getW);
	            set("x2", getW);
	            set("y1", getH);
	            set("y2", getH);
	        break;
	        case "marker":
	            set("refX", getW);
	            set("markerWidth", getW);
	            set("refY", getH);
	            set("markerHeight", getH);
	        break;
	        case "radialGradient":
	            set("fx", getW);
	            set("fy", getH);
	        break;
	        case "tspan":
	            set("dx", getW);
	            set("dy", getH);
	        break;
	        default:
	            set(name, getW);
	    }
	    svg.removeChild(mgr);
	    return out;
	}
	/*\
	 * Snap.select
	 [ method ]
	 **
	 * Wraps a DOM element specified by CSS selector as @Element
	 - query (string) CSS selector of the element
	 = (Element) the current element
	\*/
	Snap.select = function (query) {
	    query = Str(query).replace(/([^\\]):/g, "$1\\:");
	    return wrap(glob.doc.querySelector(query));
	};
	/*\
	 * Snap.selectAll
	 [ method ]
	 **
	 * Wraps DOM elements specified by CSS selector as set or array of @Element
	 - query (string) CSS selector of the element
	 = (Element) the current element
	\*/
	Snap.selectAll = function (query) {
	    var nodelist = glob.doc.querySelectorAll(query),
	        set = (Snap.set || Array)();
	    for (var i = 0; i < nodelist.length; i++) {
	        set.push(wrap(nodelist[i]));
	    }
	    return set;
	};
	
	function add2group(list) {
	    if (!is(list, "array")) {
	        list = Array.prototype.slice.call(arguments, 0);
	    }
	    var i = 0,
	        j = 0,
	        node = this.node;
	    while (this[i]) delete this[i++];
	    for (i = 0; i < list.length; i++) {
	        if (list[i].type == "set") {
	            list[i].forEach(function (el) {
	                node.appendChild(el.node);
	            });
	        } else {
	            node.appendChild(list[i].node);
	        }
	    }
	    var children = node.childNodes;
	    for (i = 0; i < children.length; i++) {
	        this[j++] = wrap(children[i]);
	    }
	    return this;
	}
	// Hub garbage collector every 10s
	setInterval(function () {
	    for (var key in hub) if (hub[has](key)) {
	        var el = hub[key],
	            node = el.node;
	        if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) {
	            delete hub[key];
	        }
	    }
	}, 1e4);
	function Element(el) {
	    if (el.snap in hub) {
	        return hub[el.snap];
	    }
	    var svg;
	    try {
	        svg = el.ownerSVGElement;
	    } catch(e) {}
	    /*\
	     * Element.node
	     [ property (object) ]
	     **
	     * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
	     > Usage
	     | // draw a circle at coordinate 10,10 with radius of 10
	     | var c = paper.circle(10, 10, 10);
	     | c.node.onclick = function () {
	     |     c.attr("fill", "red");
	     | };
	    \*/
	    this.node = el;
	    if (svg) {
	        this.paper = new Paper(svg);
	    }
	    /*\
	     * Element.type
	     [ property (string) ]
	     **
	     * SVG tag name of the given element.
	    \*/
	    this.type = el.tagName || el.nodeName;
	    var id = this.id = ID(this);
	    this.anims = {};
	    this._ = {
	        transform: []
	    };
	    el.snap = id;
	    hub[id] = this;
	    if (this.type == "g") {
	        this.add = add2group;
	    }
	    if (this.type in {g: 1, mask: 1, pattern: 1, symbol: 1}) {
	        for (var method in Paper.prototype) if (Paper.prototype[has](method)) {
	            this[method] = Paper.prototype[method];
	        }
	    }
	}
	   /*\
	     * Element.attr
	     [ method ]
	     **
	     * Gets or sets given attributes of the element.
	     **
	     - params (object) contains key-value pairs of attributes you want to set
	     * or
	     - param (string) name of the attribute
	     = (Element) the current element
	     * or
	     = (string) value of attribute
	     > Usage
	     | el.attr({
	     |     fill: "#fc0",
	     |     stroke: "#000",
	     |     strokeWidth: 2, // CamelCase...
	     |     "fill-opacity": 0.5, // or dash-separated names
	     |     width: "*=2" // prefixed values
	     | });
	     | console.log(el.attr("fill")); // #fc0
	     * Prefixed values in format `"+=10"` supported. All four operations
	     * (`+`, `-`, `*` and `/`) could be used. Optionally you can use units for `+`
	     * and `-`: `"+=2em"`.
	    \*/
	    Element.prototype.attr = function (params, value) {
	        var el = this,
	            node = el.node;
	        if (!params) {
	            if (node.nodeType != 1) {
	                return {
	                    text: node.nodeValue
	                };
	            }
	            var attr = node.attributes,
	                out = {};
	            for (var i = 0, ii = attr.length; i < ii; i++) {
	                out[attr[i].nodeName] = attr[i].nodeValue;
	            }
	            return out;
	        }
	        if (is(params, "string")) {
	            if (arguments.length > 1) {
	                var json = {};
	                json[params] = value;
	                params = json;
	            } else {
	                return eve("snap.util.getattr." + params, el).firstDefined();
	            }
	        }
	        for (var att in params) {
	            if (params[has](att)) {
	                eve("snap.util.attr." + att, el, params[att]);
	            }
	        }
	        return el;
	    };
	/*\
	 * Snap.parse
	 [ method ]
	 **
	 * Parses SVG fragment and converts it into a @Fragment
	 **
	 - svg (string) SVG string
	 = (Fragment) the @Fragment
	\*/
	Snap.parse = function (svg) {
	    var f = glob.doc.createDocumentFragment(),
	        full = true,
	        div = glob.doc.createElement("div");
	    svg = Str(svg);
	    if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
	        svg = "<svg>" + svg + "</svg>";
	        full = false;
	    }
	    div.innerHTML = svg;
	    svg = div.getElementsByTagName("svg")[0];
	    if (svg) {
	        if (full) {
	            f = svg;
	        } else {
	            while (svg.firstChild) {
	                f.appendChild(svg.firstChild);
	            }
	        }
	    }
	    return new Fragment(f);
	};
	function Fragment(frag) {
	    this.node = frag;
	}
	/*\
	 * Snap.fragment
	 [ method ]
	 **
	 * Creates a DOM fragment from a given list of elements or strings
	 **
	 - varargs (…) SVG string
	 = (Fragment) the @Fragment
	\*/
	Snap.fragment = function () {
	    var args = Array.prototype.slice.call(arguments, 0),
	        f = glob.doc.createDocumentFragment();
	    for (var i = 0, ii = args.length; i < ii; i++) {
	        var item = args[i];
	        if (item.node && item.node.nodeType) {
	            f.appendChild(item.node);
	        }
	        if (item.nodeType) {
	            f.appendChild(item);
	        }
	        if (typeof item == "string") {
	            f.appendChild(Snap.parse(item).node);
	        }
	    }
	    return new Fragment(f);
	};
	
	function make(name, parent) {
	    var res = $(name);
	    parent.appendChild(res);
	    var el = wrap(res);
	    return el;
	}
	function Paper(w, h) {
	    var res,
	        desc,
	        defs,
	        proto = Paper.prototype;
	    if (w && w.tagName && w.tagName.toLowerCase() == "svg") {
	        if (w.snap in hub) {
	            return hub[w.snap];
	        }
	        var doc = w.ownerDocument;
	        res = new Element(w);
	        desc = w.getElementsByTagName("desc")[0];
	        defs = w.getElementsByTagName("defs")[0];
	        if (!desc) {
	            desc = $("desc");
	            desc.appendChild(doc.createTextNode("Created with Snap"));
	            res.node.appendChild(desc);
	        }
	        if (!defs) {
	            defs = $("defs");
	            res.node.appendChild(defs);
	        }
	        res.defs = defs;
	        for (var key in proto) if (proto[has](key)) {
	            res[key] = proto[key];
	        }
	        res.paper = res.root = res;
	    } else {
	        res = make("svg", glob.doc.body);
	        $(res.node, {
	            height: h,
	            version: 1.1,
	            width: w,
	            xmlns: xmlns
	        });
	    }
	    return res;
	}
	function wrap(dom) {
	    if (!dom) {
	        return dom;
	    }
	    if (dom instanceof Element || dom instanceof Fragment) {
	        return dom;
	    }
	    if (dom.tagName && dom.tagName.toLowerCase() == "svg") {
	        return new Paper(dom);
	    }
	    if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") {
	        return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
	    }
	    return new Element(dom);
	}
	
	Snap._.make = make;
	Snap._.wrap = wrap;
	/*\
	 * Paper.el
	 [ method ]
	 **
	 * Creates an element on paper with a given name and no attributes
	 **
	 - name (string) tag name
	 - attr (object) attributes
	 = (Element) the current element
	 > Usage
	 | var c = paper.circle(10, 10, 10); // is the same as...
	 | var c = paper.el("circle").attr({
	 |     cx: 10,
	 |     cy: 10,
	 |     r: 10
	 | });
	 | // and the same as
	 | var c = paper.el("circle", {
	 |     cx: 10,
	 |     cy: 10,
	 |     r: 10
	 | });
	\*/
	Paper.prototype.el = function (name, attr) {
	    var el = make(name, this.node);
	    attr && el.attr(attr);
	    return el;
	};
	/*\
	 * Element.children
	 [ method ]
	 **
	 * Returns array of all the children of the element.
	 = (array) array of Elements
	\*/
	Element.prototype.children = function () {
	    var out = [],
	        ch = this.node.childNodes;
	    for (var i = 0, ii = ch.length; i < ii; i++) {
	        out[i] = Snap(ch[i]);
	    }
	    return out;
	};
	function jsonFiller(root, o) {
	    for (var i = 0, ii = root.length; i < ii; i++) {
	        var item = {
	                type: root[i].type,
	                attr: root[i].attr()
	            },
	            children = root[i].children();
	        o.push(item);
	        if (children.length) {
	            jsonFiller(children, item.childNodes = []);
	        }
	    }
	}
	/*\
	 * Element.toJSON
	 [ method ]
	 **
	 * Returns object representation of the given element and all its children.
	 = (object) in format
	 o {
	 o     type (string) this.type,
	 o     attr (object) attributes map,
	 o     childNodes (array) optional array of children in the same format
	 o }
	\*/
	Element.prototype.toJSON = function () {
	    var out = [];
	    jsonFiller([this], out);
	    return out[0];
	};
	// default
	eve.on("snap.util.getattr", function () {
	    var att = eve.nt();
	    att = att.substring(att.lastIndexOf(".") + 1);
	    var css = att.replace(/[A-Z]/g, function (letter) {
	        return "-" + letter.toLowerCase();
	    });
	    if (cssAttr[has](css)) {
	        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
	    } else {
	        return $(this.node, att);
	    }
	});
	var cssAttr = {
	    "alignment-baseline": 0,
	    "baseline-shift": 0,
	    "clip": 0,
	    "clip-path": 0,
	    "clip-rule": 0,
	    "color": 0,
	    "color-interpolation": 0,
	    "color-interpolation-filters": 0,
	    "color-profile": 0,
	    "color-rendering": 0,
	    "cursor": 0,
	    "direction": 0,
	    "display": 0,
	    "dominant-baseline": 0,
	    "enable-background": 0,
	    "fill": 0,
	    "fill-opacity": 0,
	    "fill-rule": 0,
	    "filter": 0,
	    "flood-color": 0,
	    "flood-opacity": 0,
	    "font": 0,
	    "font-family": 0,
	    "font-size": 0,
	    "font-size-adjust": 0,
	    "font-stretch": 0,
	    "font-style": 0,
	    "font-variant": 0,
	    "font-weight": 0,
	    "glyph-orientation-horizontal": 0,
	    "glyph-orientation-vertical": 0,
	    "image-rendering": 0,
	    "kerning": 0,
	    "letter-spacing": 0,
	    "lighting-color": 0,
	    "marker": 0,
	    "marker-end": 0,
	    "marker-mid": 0,
	    "marker-start": 0,
	    "mask": 0,
	    "opacity": 0,
	    "overflow": 0,
	    "pointer-events": 0,
	    "shape-rendering": 0,
	    "stop-color": 0,
	    "stop-opacity": 0,
	    "stroke": 0,
	    "stroke-dasharray": 0,
	    "stroke-dashoffset": 0,
	    "stroke-linecap": 0,
	    "stroke-linejoin": 0,
	    "stroke-miterlimit": 0,
	    "stroke-opacity": 0,
	    "stroke-width": 0,
	    "text-anchor": 0,
	    "text-decoration": 0,
	    "text-rendering": 0,
	    "unicode-bidi": 0,
	    "visibility": 0,
	    "word-spacing": 0,
	    "writing-mode": 0
	};
	
	eve.on("snap.util.attr", function (value) {
	    var att = eve.nt(),
	        attr = {};
	    att = att.substring(att.lastIndexOf(".") + 1);
	    attr[att] = value;
	    var style = att.replace(/-(\w)/gi, function (all, letter) {
	            return letter.toUpperCase();
	        }),
	        css = att.replace(/[A-Z]/g, function (letter) {
	            return "-" + letter.toLowerCase();
	        });
	    if (cssAttr[has](css)) {
	        this.node.style[style] = value == null ? E : value;
	    } else {
	        $(this.node, attr);
	    }
	});
	(function (proto) {}(Paper.prototype));
	
	// simple ajax
	/*\
	 * Snap.ajax
	 [ method ]
	 **
	 * Simple implementation of Ajax
	 **
	 - url (string) URL
	 - postData (object|string) data for post request
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	 * or
	 - url (string) URL
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	 = (XMLHttpRequest) the XMLHttpRequest object, just in case
	\*/
	Snap.ajax = function (url, postData, callback, scope){
	    var req = new XMLHttpRequest,
	        id = ID();
	    if (req) {
	        if (is(postData, "function")) {
	            scope = callback;
	            callback = postData;
	            postData = null;
	        } else if (is(postData, "object")) {
	            var pd = [];
	            for (var key in postData) if (postData.hasOwnProperty(key)) {
	                pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
	            }
	            postData = pd.join("&");
	        }
	        req.open(postData ? "POST" : "GET", url, true);
	        if (postData) {
	            req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	            req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	        }
	        if (callback) {
	            eve.once("snap.ajax." + id + ".0", callback);
	            eve.once("snap.ajax." + id + ".200", callback);
	            eve.once("snap.ajax." + id + ".304", callback);
	        }
	        req.onreadystatechange = function() {
	            if (req.readyState != 4) return;
	            eve("snap.ajax." + id + "." + req.status, scope, req);
	        };
	        if (req.readyState == 4) {
	            return req;
	        }
	        req.send(postData);
	        return req;
	    }
	};
	/*\
	 * Snap.load
	 [ method ]
	 **
	 * Loads external SVG file as a @Fragment (see @Snap.ajax for more advanced AJAX)
	 **
	 - url (string) URL
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	\*/
	Snap.load = function (url, callback, scope) {
	    Snap.ajax(url, function (req) {
	        var f = Snap.parse(req.responseText);
	        scope ? callback.call(scope, f) : callback(f);
	    });
	};
	var getOffset = function (elem) {
	    var box = elem.getBoundingClientRect(),
	        doc = elem.ownerDocument,
	        body = doc.body,
	        docElem = doc.documentElement,
	        clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0,
	        top  = box.top  + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop ) - clientTop,
	        left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
	    return {
	        y: top,
	        x: left
	    };
	};
	/*\
	 * Snap.getElementByPoint
	 [ method ]
	 **
	 * Returns you topmost element under given point.
	 **
	 = (object) Snap element object
	 - x (number) x coordinate from the top left corner of the window
	 - y (number) y coordinate from the top left corner of the window
	 > Usage
	 | Snap.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
	\*/
	Snap.getElementByPoint = function (x, y) {
	    var paper = this,
	        svg = paper.canvas,
	        target = glob.doc.elementFromPoint(x, y);
	    if (glob.win.opera && target.tagName == "svg") {
	        var so = getOffset(target),
	            sr = target.createSVGRect();
	        sr.x = x - so.x;
	        sr.y = y - so.y;
	        sr.width = sr.height = 1;
	        var hits = target.getIntersectionList(sr, null);
	        if (hits.length) {
	            target = hits[hits.length - 1];
	        }
	    }
	    if (!target) {
	        return null;
	    }
	    return wrap(target);
	};
	/*\
	 * Snap.plugin
	 [ method ]
	 **
	 * Let you write plugins. You pass in a function with five arguments, like this:
	 | Snap.plugin(function (Snap, Element, Paper, global, Fragment) {
	 |     Snap.newmethod = function () {};
	 |     Element.prototype.newmethod = function () {};
	 |     Paper.prototype.newmethod = function () {};
	 | });
	 * Inside the function you have access to all main objects (and their
	 * prototypes). This allow you to extend anything you want.
	 **
	 - f (function) your plugin body
	\*/
	Snap.plugin = function (f) {
	    f(Snap, Element, Paper, glob, Fragment);
	};
	glob.win.Snap = Snap;
	return Snap;
	}(window || this));
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        Str = String,
	        unit2px = Snap._unit2px,
	        $ = Snap._.$,
	        make = Snap._.make,
	        getSomeDefs = Snap._.getSomeDefs,
	        has = "hasOwnProperty",
	        wrap = Snap._.wrap;
	    /*\
	     * Element.getBBox
	     [ method ]
	     **
	     * Returns the bounding box descriptor for the given element
	     **
	     = (object) bounding box descriptor:
	     o {
	     o     cx: (number) x of the center,
	     o     cy: (number) x of the center,
	     o     h: (number) height,
	     o     height: (number) height,
	     o     path: (string) path command for the box,
	     o     r0: (number) radius of a circle that fully encloses the box,
	     o     r1: (number) radius of the smallest circle that can be enclosed,
	     o     r2: (number) radius of the largest circle that can be enclosed,
	     o     vb: (string) box as a viewbox command,
	     o     w: (number) width,
	     o     width: (number) width,
	     o     x2: (number) x of the right side,
	     o     x: (number) x of the left side,
	     o     y2: (number) y of the bottom edge,
	     o     y: (number) y of the top edge
	     o }
	    \*/
	    elproto.getBBox = function (isWithoutTransform) {
	        if (this.type == "tspan") {
	            return Snap._.box(this.node.getClientRects().item(0));
	        }
	        if (!Snap.Matrix || !Snap.path) {
	            return this.node.getBBox();
	        }
	        var el = this,
	            m = new Snap.Matrix;
	        if (el.removed) {
	            return Snap._.box();
	        }
	        while (el.type == "use") {
	            if (!isWithoutTransform) {
	                m = m.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
	            }
	            if (el.original) {
	                el = el.original;
	            } else {
	                var href = el.attr("xlink:href");
	                el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
	            }
	        }
	        var _ = el._,
	            pathfinder = Snap.path.get[el.type] || Snap.path.get.deflt;
	        try {
	            if (isWithoutTransform) {
	                _.bboxwt = pathfinder ? Snap.path.getBBox(el.realPath = pathfinder(el)) : Snap._.box(el.node.getBBox());
	                return Snap._.box(_.bboxwt);
	            } else {
	                el.realPath = pathfinder(el);
	                el.matrix = el.transform().localMatrix;
	                _.bbox = Snap.path.getBBox(Snap.path.map(el.realPath, m.add(el.matrix)));
	                return Snap._.box(_.bbox);
	            }
	        } catch (e) {
	            // Firefox doesn’t give you bbox of hidden element
	            return Snap._.box();
	        }
	    };
	    var propString = function () {
	        return this.string;
	    };
	    function extractTransform(el, tstr) {
	        if (tstr == null) {
	            var doReturn = true;
	            if (el.type == "linearGradient" || el.type == "radialGradient") {
	                tstr = el.node.getAttribute("gradientTransform");
	            } else if (el.type == "pattern") {
	                tstr = el.node.getAttribute("patternTransform");
	            } else {
	                tstr = el.node.getAttribute("transform");
	            }
	            if (!tstr) {
	                return new Snap.Matrix;
	            }
	            tstr = Snap._.svgTransform2string(tstr);
	        } else {
	            if (!Snap._.rgTransform.test(tstr)) {
	                tstr = Snap._.svgTransform2string(tstr);
	            } else {
	                tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || "");
	            }
	            if (is(tstr, "array")) {
	                tstr = Snap.path ? Snap.path.toString.call(tstr) : Str(tstr);
	            }
	            el._.transform = tstr;
	        }
	        var m = Snap._.transform2matrix(tstr, el.getBBox(1));
	        if (doReturn) {
	            return m;
	        } else {
	            el.matrix = m;
	        }
	    }
	    /*\
	     * Element.transform
	     [ method ]
	     **
	     * Gets or sets transformation of the element
	     **
	     - tstr (string) transform string in Snap or SVG format
	     = (Element) the current element
	     * or
	     = (object) transformation descriptor:
	     o {
	     o     string (string) transform string,
	     o     globalMatrix (Matrix) matrix of all transformations applied to element or its parents,
	     o     localMatrix (Matrix) matrix of transformations applied only to the element,
	     o     diffMatrix (Matrix) matrix of difference between global and local transformations,
	     o     global (string) global transformation as string,
	     o     local (string) local transformation as string,
	     o     toString (function) returns `string` property
	     o }
	    \*/
	    elproto.transform = function (tstr) {
	        var _ = this._;
	        if (tstr == null) {
	            var papa = this,
	                global = new Snap.Matrix(this.node.getCTM()),
	                local = extractTransform(this),
	                ms = [local],
	                m = new Snap.Matrix,
	                i,
	                localString = local.toTransformString(),
	                string = Str(local) == Str(this.matrix) ?
	                            Str(_.transform) : localString;
	            while (papa.type != "svg" && (papa = papa.parent())) {
	                ms.push(extractTransform(papa));
	            }
	            i = ms.length;
	            while (i--) {
	                m.add(ms[i]);
	            }
	            return {
	                string: string,
	                globalMatrix: global,
	                totalMatrix: m,
	                localMatrix: local,
	                diffMatrix: global.clone().add(local.invert()),
	                global: global.toTransformString(),
	                total: m.toTransformString(),
	                local: localString,
	                toString: propString
	            };
	        }
	        if (tstr instanceof Snap.Matrix) {
	            this.matrix = tstr;
	            this._.transform = tstr.toTransformString();
	        } else {
	            extractTransform(this, tstr);
	        }
	
	        if (this.node) {
	            if (this.type == "linearGradient" || this.type == "radialGradient") {
	                $(this.node, {gradientTransform: this.matrix});
	            } else if (this.type == "pattern") {
	                $(this.node, {patternTransform: this.matrix});
	            } else {
	                $(this.node, {transform: this.matrix});
	            }
	        }
	
	        return this;
	    };
	    /*\
	     * Element.parent
	     [ method ]
	     **
	     * Returns the element's parent
	     **
	     = (Element) the parent element
	    \*/
	    elproto.parent = function () {
	        return wrap(this.node.parentNode);
	    };
	    /*\
	     * Element.append
	     [ method ]
	     **
	     * Appends the given element to current one
	     **
	     - el (Element|Set) element to append
	     = (Element) the parent element
	    \*/
	    /*\
	     * Element.add
	     [ method ]
	     **
	     * See @Element.append
	    \*/
	    elproto.append = elproto.add = function (el) {
	        if (el) {
	            if (el.type == "set") {
	                var it = this;
	                el.forEach(function (el) {
	                    it.add(el);
	                });
	                return this;
	            }
	            el = wrap(el);
	            this.node.appendChild(el.node);
	            el.paper = this.paper;
	        }
	        return this;
	    };
	    /*\
	     * Element.appendTo
	     [ method ]
	     **
	     * Appends the current element to the given one
	     **
	     - el (Element) parent element to append to
	     = (Element) the child element
	    \*/
	    elproto.appendTo = function (el) {
	        if (el) {
	            el = wrap(el);
	            el.append(this);
	        }
	        return this;
	    };
	    /*\
	     * Element.prepend
	     [ method ]
	     **
	     * Prepends the given element to the current one
	     **
	     - el (Element) element to prepend
	     = (Element) the parent element
	    \*/
	    elproto.prepend = function (el) {
	        if (el) {
	            if (el.type == "set") {
	                var it = this,
	                    first;
	                el.forEach(function (el) {
	                    if (first) {
	                        first.after(el);
	                    } else {
	                        it.prepend(el);
	                    }
	                    first = el;
	                });
	                return this;
	            }
	            el = wrap(el);
	            var parent = el.parent();
	            this.node.insertBefore(el.node, this.node.firstChild);
	            this.add && this.add();
	            el.paper = this.paper;
	            this.parent() && this.parent().add();
	            parent && parent.add();
	        }
	        return this;
	    };
	    /*\
	     * Element.prependTo
	     [ method ]
	     **
	     * Prepends the current element to the given one
	     **
	     - el (Element) parent element to prepend to
	     = (Element) the child element
	    \*/
	    elproto.prependTo = function (el) {
	        el = wrap(el);
	        el.prepend(this);
	        return this;
	    };
	    /*\
	     * Element.before
	     [ method ]
	     **
	     * Inserts given element before the current one
	     **
	     - el (Element) element to insert
	     = (Element) the parent element
	    \*/
	    elproto.before = function (el) {
	        if (el.type == "set") {
	            var it = this;
	            el.forEach(function (el) {
	                var parent = el.parent();
	                it.node.parentNode.insertBefore(el.node, it.node);
	                parent && parent.add();
	            });
	            this.parent().add();
	            return this;
	        }
	        el = wrap(el);
	        var parent = el.parent();
	        this.node.parentNode.insertBefore(el.node, this.node);
	        this.parent() && this.parent().add();
	        parent && parent.add();
	        el.paper = this.paper;
	        return this;
	    };
	    /*\
	     * Element.after
	     [ method ]
	     **
	     * Inserts given element after the current one
	     **
	     - el (Element) element to insert
	     = (Element) the parent element
	    \*/
	    elproto.after = function (el) {
	        el = wrap(el);
	        var parent = el.parent();
	        if (this.node.nextSibling) {
	            this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
	        } else {
	            this.node.parentNode.appendChild(el.node);
	        }
	        this.parent() && this.parent().add();
	        parent && parent.add();
	        el.paper = this.paper;
	        return this;
	    };
	    /*\
	     * Element.insertBefore
	     [ method ]
	     **
	     * Inserts the element after the given one
	     **
	     - el (Element) element next to whom insert to
	     = (Element) the parent element
	    \*/
	    elproto.insertBefore = function (el) {
	        el = wrap(el);
	        var parent = this.parent();
	        el.node.parentNode.insertBefore(this.node, el.node);
	        this.paper = el.paper;
	        parent && parent.add();
	        el.parent() && el.parent().add();
	        return this;
	    };
	    /*\
	     * Element.insertAfter
	     [ method ]
	     **
	     * Inserts the element after the given one
	     **
	     - el (Element) element next to whom insert to
	     = (Element) the parent element
	    \*/
	    elproto.insertAfter = function (el) {
	        el = wrap(el);
	        var parent = this.parent();
	        el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
	        this.paper = el.paper;
	        parent && parent.add();
	        el.parent() && el.parent().add();
	        return this;
	    };
	    /*\
	     * Element.remove
	     [ method ]
	     **
	     * Removes element from the DOM
	     = (Element) the detached element
	    \*/
	    elproto.remove = function () {
	        var parent = this.parent();
	        this.node.parentNode && this.node.parentNode.removeChild(this.node);
	        delete this.paper;
	        this.removed = true;
	        parent && parent.add();
	        return this;
	    };
	    /*\
	     * Element.select
	     [ method ]
	     **
	     * Gathers the nested @Element matching the given set of CSS selectors
	     **
	     - query (string) CSS selector
	     = (Element) result of query selection
	    \*/
	    elproto.select = function (query) {
	        return wrap(this.node.querySelector(query));
	    };
	    /*\
	     * Element.selectAll
	     [ method ]
	     **
	     * Gathers nested @Element objects matching the given set of CSS selectors
	     **
	     - query (string) CSS selector
	     = (Set|array) result of query selection
	    \*/
	    elproto.selectAll = function (query) {
	        var nodelist = this.node.querySelectorAll(query),
	            set = (Snap.set || Array)();
	        for (var i = 0; i < nodelist.length; i++) {
	            set.push(wrap(nodelist[i]));
	        }
	        return set;
	    };
	    /*\
	     * Element.asPX
	     [ method ]
	     **
	     * Returns given attribute of the element as a `px` value (not %, em, etc.)
	     **
	     - attr (string) attribute name
	     - value (string) #optional attribute value
	     = (Element) result of query selection
	    \*/
	    elproto.asPX = function (attr, value) {
	        if (value == null) {
	            value = this.attr(attr);
	        }
	        return +unit2px(this, attr, value);
	    };
	    // SIERRA Element.use(): I suggest adding a note about how to access the original element the returned <use> instantiates. It's a part of SVG with which ordinary web developers may be least familiar.
	    /*\
	     * Element.use
	     [ method ]
	     **
	     * Creates a `<use>` element linked to the current element
	     **
	     = (Element) the `<use>` element
	    \*/
	    elproto.use = function () {
	        var use,
	            id = this.node.id;
	        if (!id) {
	            id = this.id;
	            $(this.node, {
	                id: id
	            });
	        }
	        if (this.type == "linearGradient" || this.type == "radialGradient" ||
	            this.type == "pattern") {
	            use = make(this.type, this.node.parentNode);
	        } else {
	            use = make("use", this.node.parentNode);
	        }
	        $(use.node, {
	            "xlink:href": "#" + id
	        });
	        use.original = this;
	        return use;
	    };
	    function fixids(el) {
	        var els = el.selectAll("*"),
	            it,
	            url = /^\s*url\(("|'|)(.*)\1\)\s*$/,
	            ids = [],
	            uses = {};
	        function urltest(it, name) {
	            var val = $(it.node, name);
	            val = val && val.match(url);
	            val = val && val[2];
	            if (val && val.charAt() == "#") {
	                val = val.substring(1);
	            } else {
	                return;
	            }
	            if (val) {
	                uses[val] = (uses[val] || []).concat(function (id) {
	                    var attr = {};
	                    attr[name] = Snap.url(id);
	                    $(it.node, attr);
	                });
	            }
	        }
	        function linktest(it) {
	            var val = $(it.node, "xlink:href");
	            if (val && val.charAt() == "#") {
	                val = val.substring(1);
	            } else {
	                return;
	            }
	            if (val) {
	                uses[val] = (uses[val] || []).concat(function (id) {
	                    it.attr("xlink:href", "#" + id);
	                });
	            }
	        }
	        for (var i = 0, ii = els.length; i < ii; i++) {
	            it = els[i];
	            urltest(it, "fill");
	            urltest(it, "stroke");
	            urltest(it, "filter");
	            urltest(it, "mask");
	            urltest(it, "clip-path");
	            linktest(it);
	            var oldid = $(it.node, "id");
	            if (oldid) {
	                $(it.node, {id: it.id});
	                ids.push({
	                    old: oldid,
	                    id: it.id
	                });
	            }
	        }
	        for (i = 0, ii = ids.length; i < ii; i++) {
	            var fs = uses[ids[i].old];
	            if (fs) {
	                for (var j = 0, jj = fs.length; j < jj; j++) {
	                    fs[j](ids[i].id);
	                }
	            }
	        }
	    }
	    /*\
	     * Element.clone
	     [ method ]
	     **
	     * Creates a clone of the element and inserts it after the element
	     **
	     = (Element) the clone
	    \*/
	    elproto.clone = function () {
	        var clone = wrap(this.node.cloneNode(true));
	        if ($(clone.node, "id")) {
	            $(clone.node, {id: clone.id});
	        }
	        fixids(clone);
	        clone.insertAfter(this);
	        return clone;
	    };
	    /*\
	     * Element.toDefs
	     [ method ]
	     **
	     * Moves element to the shared `<defs>` area
	     **
	     = (Element) the element
	    \*/
	    elproto.toDefs = function () {
	        var defs = getSomeDefs(this);
	        defs.appendChild(this.node);
	        return this;
	    };
	    /*\
	     * Element.toPattern
	     [ method ]
	     **
	     * Creates a `<pattern>` element from the current element
	     **
	     * To create a pattern you have to specify the pattern rect:
	     - x (string|number)
	     - y (string|number)
	     - width (string|number)
	     - height (string|number)
	     = (Element) the `<pattern>` element
	     * You can use pattern later on as an argument for `fill` attribute:
	     | var p = paper.path("M10-5-10,15M15,0,0,15M0-5-20,15").attr({
	     |         fill: "none",
	     |         stroke: "#bada55",
	     |         strokeWidth: 5
	     |     }).pattern(0, 0, 10, 10),
	     |     c = paper.circle(200, 200, 100);
	     | c.attr({
	     |     fill: p
	     | });
	    \*/
	    elproto.pattern = elproto.toPattern = function (x, y, width, height) {
	        var p = make("pattern", getSomeDefs(this));
	        if (x == null) {
	            x = this.getBBox();
	        }
	        if (is(x, "object") && "x" in x) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            x = x.x;
	        }
	        $(p.node, {
	            x: x,
	            y: y,
	            width: width,
	            height: height,
	            patternUnits: "userSpaceOnUse",
	            id: p.id,
	            viewBox: [x, y, width, height].join(" ")
	        });
	        p.node.appendChild(this.node);
	        return p;
	    };
	// SIERRA Element.marker(): clarify what a reference point is. E.g., helps you offset the object from its edge such as when centering it over a path.
	// SIERRA Element.marker(): I suggest the method should accept default reference point values.  Perhaps centered with (refX = width/2) and (refY = height/2)? Also, couldn't it assume the element's current _width_ and _height_? And please specify what _x_ and _y_ mean: offsets? If so, from where?  Couldn't they also be assigned default values?
	    /*\
	     * Element.marker
	     [ method ]
	     **
	     * Creates a `<marker>` element from the current element
	     **
	     * To create a marker you have to specify the bounding rect and reference point:
	     - x (number)
	     - y (number)
	     - width (number)
	     - height (number)
	     - refX (number)
	     - refY (number)
	     = (Element) the `<marker>` element
	     * You can specify the marker later as an argument for `marker-start`, `marker-end`, `marker-mid`, and `marker` attributes. The `marker` attribute places the marker at every point along the path, and `marker-mid` places them at every point except the start and end.
	    \*/
	    // TODO add usage for markers
	    elproto.marker = function (x, y, width, height, refX, refY) {
	        var p = make("marker", getSomeDefs(this));
	        if (x == null) {
	            x = this.getBBox();
	        }
	        if (is(x, "object") && "x" in x) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            refX = x.refX || x.cx;
	            refY = x.refY || x.cy;
	            x = x.x;
	        }
	        $(p.node, {
	            viewBox: [x, y, width, height].join(" "),
	            markerWidth: width,
	            markerHeight: height,
	            orient: "auto",
	            refX: refX || 0,
	            refY: refY || 0,
	            id: p.id
	        });
	        p.node.appendChild(this.node);
	        return p;
	    };
	    var eldata = {};
	    /*\
	     * Element.data
	     [ method ]
	     **
	     * Adds or retrieves given value associated with given key. (Don’t confuse
	     * with `data-` attributes)
	     *
	     * See also @Element.removeData
	     - key (string) key to store data
	     - value (any) #optional value to store
	     = (object) @Element
	     * or, if value is not specified:
	     = (any) value
	     > Usage
	     | for (var i = 0, i < 5, i++) {
	     |     paper.circle(10 + 15 * i, 10, 10)
	     |          .attr({fill: "#000"})
	     |          .data("i", i)
	     |          .click(function () {
	     |             alert(this.data("i"));
	     |          });
	     | }
	    \*/
	    elproto.data = function (key, value) {
	        var data = eldata[this.id] = eldata[this.id] || {};
	        if (arguments.length == 0){
	            eve("snap.data.get." + this.id, this, data, null);
	            return data;
	        }
	        if (arguments.length == 1) {
	            if (Snap.is(key, "object")) {
	                for (var i in key) if (key[has](i)) {
	                    this.data(i, key[i]);
	                }
	                return this;
	            }
	            eve("snap.data.get." + this.id, this, data[key], key);
	            return data[key];
	        }
	        data[key] = value;
	        eve("snap.data.set." + this.id, this, value, key);
	        return this;
	    };
	    /*\
	     * Element.removeData
	     [ method ]
	     **
	     * Removes value associated with an element by given key.
	     * If key is not provided, removes all the data of the element.
	     - key (string) #optional key
	     = (object) @Element
	    \*/
	    elproto.removeData = function (key) {
	        if (key == null) {
	            eldata[this.id] = {};
	        } else {
	            eldata[this.id] && delete eldata[this.id][key];
	        }
	        return this;
	    };
	    /*\
	     * Element.outerSVG
	     [ method ]
	     **
	     * Returns SVG code for the element, equivalent to HTML's `outerHTML`.
	     *
	     * See also @Element.innerSVG
	     = (string) SVG code for the element
	    \*/
	    /*\
	     * Element.toString
	     [ method ]
	     **
	     * See @Element.outerSVG
	    \*/
	    elproto.outerSVG = elproto.toString = toString(1);
	    /*\
	     * Element.innerSVG
	     [ method ]
	     **
	     * Returns SVG code for the element's contents, equivalent to HTML's `innerHTML`
	     = (string) SVG code for the element
	    \*/
	    elproto.innerSVG = toString();
	    function toString(type) {
	        return function () {
	            var res = type ? "<" + this.type : "",
	                attr = this.node.attributes,
	                chld = this.node.childNodes;
	            if (type) {
	                for (var i = 0, ii = attr.length; i < ii; i++) {
	                    res += " " + attr[i].name + '="' +
	                            attr[i].value.replace(/"/g, '\\"') + '"';
	                }
	            }
	            if (chld.length) {
	                type && (res += ">");
	                for (i = 0, ii = chld.length; i < ii; i++) {
	                    if (chld[i].nodeType == 3) {
	                        res += chld[i].nodeValue;
	                    } else if (chld[i].nodeType == 1) {
	                        res += wrap(chld[i]).toString();
	                    }
	                }
	                type && (res += "</" + this.type + ">");
	            } else {
	                type && (res += "/>");
	            }
	            return res;
	        };
	    }
	    elproto.toDataURL = function () {
	        if (window && window.btoa) {
	            var bb = this.getBBox(),
	                svg = Snap.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
	                x: +bb.x.toFixed(3),
	                y: +bb.y.toFixed(3),
	                width: +bb.width.toFixed(3),
	                height: +bb.height.toFixed(3),
	                contents: this.outerSVG()
	            });
	            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
	        }
	    };
	    /*\
	     * Fragment.select
	     [ method ]
	     **
	     * See @Element.select
	    \*/
	    Fragment.prototype.select = elproto.select;
	    /*\
	     * Fragment.selectAll
	     [ method ]
	     **
	     * See @Element.selectAll
	    \*/
	    Fragment.prototype.selectAll = elproto.selectAll;
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var objectToString = Object.prototype.toString,
	        Str = String,
	        math = Math,
	        E = "";
	    function Matrix(a, b, c, d, e, f) {
	        if (b == null && objectToString.call(a) == "[object SVGMatrix]") {
	            this.a = a.a;
	            this.b = a.b;
	            this.c = a.c;
	            this.d = a.d;
	            this.e = a.e;
	            this.f = a.f;
	            return;
	        }
	        if (a != null) {
	            this.a = +a;
	            this.b = +b;
	            this.c = +c;
	            this.d = +d;
	            this.e = +e;
	            this.f = +f;
	        } else {
	            this.a = 1;
	            this.b = 0;
	            this.c = 0;
	            this.d = 1;
	            this.e = 0;
	            this.f = 0;
	        }
	    }
	    (function (matrixproto) {
	        /*\
	         * Matrix.add
	         [ method ]
	         **
	         * Adds the given matrix to existing one
	         - a (number)
	         - b (number)
	         - c (number)
	         - d (number)
	         - e (number)
	         - f (number)
	         * or
	         - matrix (object) @Matrix
	        \*/
	        matrixproto.add = function (a, b, c, d, e, f) {
	            if (a && a instanceof Matrix) {
	                return this.add(a.a, a.b, a.c, a.d, a.e, a.f);
	            }
	            var aNew = a * this.a + b * this.c,
	                bNew = a * this.b + b * this.d;
	            this.e += e * this.a + f * this.c;
	            this.f += e * this.b + f * this.d;
	            this.c = c * this.a + d * this.c;
	            this.d = c * this.b + d * this.d;
	
	            this.a = aNew;
	            this.b = bNew;
	            return this;
	        };
	        /*\
	         * Matrix.multLeft
	         [ method ]
	         **
	         * Multiplies a passed affine transform to the left: M * this.
	         - a (number)
	         - b (number)
	         - c (number)
	         - d (number)
	         - e (number)
	         - f (number)
	         * or
	         - matrix (object) @Matrix
	        \*/
	        Matrix.prototype.multLeft = function (a, b, c, d, e, f) {
	            if (a && a instanceof Matrix) {
	                return this.multLeft(a.a, a.b, a.c, a.d, a.e, a.f);
	            }
	            var aNew = a * this.a + c * this.b,
	                cNew = a * this.c + c * this.d,
	                eNew = a * this.e + c * this.f + e;
	            this.b = b * this.a + d * this.b;
	            this.d = b * this.c + d * this.d;
	            this.f = b * this.e + d * this.f + f;
	
	            this.a = aNew;
	            this.c = cNew;
	            this.e = eNew;
	            return this;
	        };
	        /*\
	         * Matrix.invert
	         [ method ]
	         **
	         * Returns an inverted version of the matrix
	         = (object) @Matrix
	        \*/
	        matrixproto.invert = function () {
	            var me = this,
	                x = me.a * me.d - me.b * me.c;
	            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
	        };
	        /*\
	         * Matrix.clone
	         [ method ]
	         **
	         * Returns a copy of the matrix
	         = (object) @Matrix
	        \*/
	        matrixproto.clone = function () {
	            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
	        };
	        /*\
	         * Matrix.translate
	         [ method ]
	         **
	         * Translate the matrix
	         - x (number) horizontal offset distance
	         - y (number) vertical offset distance
	        \*/
	        matrixproto.translate = function (x, y) {
	            this.e += x * this.a + y * this.c;
	            this.f += x * this.b + y * this.d;
	            return this;
	        };
	        /*\
	         * Matrix.scale
	         [ method ]
	         **
	         * Scales the matrix
	         - x (number) amount to be scaled, with `1` resulting in no change
	         - y (number) #optional amount to scale along the vertical axis. (Otherwise `x` applies to both axes.)
	         - cx (number) #optional horizontal origin point from which to scale
	         - cy (number) #optional vertical origin point from which to scale
	         * Default cx, cy is the middle point of the element.
	        \*/
	        matrixproto.scale = function (x, y, cx, cy) {
	            y == null && (y = x);
	            (cx || cy) && this.translate(cx, cy);
	            this.a *= x;
	            this.b *= x;
	            this.c *= y;
	            this.d *= y;
	            (cx || cy) && this.translate(-cx, -cy);
	            return this;
	        };
	        /*\
	         * Matrix.rotate
	         [ method ]
	         **
	         * Rotates the matrix
	         - a (number) angle of rotation, in degrees
	         - x (number) horizontal origin point from which to rotate
	         - y (number) vertical origin point from which to rotate
	        \*/
	        matrixproto.rotate = function (a, x, y) {
	            a = Snap.rad(a);
	            x = x || 0;
	            y = y || 0;
	            var cos = +math.cos(a).toFixed(9),
	                sin = +math.sin(a).toFixed(9);
	            this.add(cos, sin, -sin, cos, x, y);
	            return this.add(1, 0, 0, 1, -x, -y);
	        };
	        /*\
	         * Matrix.skewX
	         [ method ]
	         **
	         * Skews the matrix along the x-axis
	         - x (number) Angle to skew along the x-axis (in degrees).
	        \*/
	        matrixproto.skewX = function (x) {
	            return this.skew(x, 0);
	        };
	        /*\
	         * Matrix.skewY
	         [ method ]
	         **
	         * Skews the matrix along the y-axis
	         - y (number) Angle to skew along the y-axis (in degrees).
	        \*/
	        matrixproto.skewY = function (y) {
	            return this.skew(0, y);
	        };
	        /*\
	         * Matrix.skew
	         [ method ]
	         **
	         * Skews the matrix
	         - y (number) Angle to skew along the y-axis (in degrees).
	         - x (number) Angle to skew along the x-axis (in degrees).
	        \*/
	        matrixproto.skew = function (x, y) {
	            x = x || 0;
	            y = y || 0;
	            x = Snap.rad(x);
	            y = Snap.rad(y);
	            var c = math.tan(x).toFixed(9);
	            var b = math.tan(y).toFixed(9);
	            return this.add(1, b, c, 1, 0, 0);
	        };
	        /*\
	         * Matrix.x
	         [ method ]
	         **
	         * Returns x coordinate for given point after transformation described by the matrix. See also @Matrix.y
	         - x (number)
	         - y (number)
	         = (number) x
	        \*/
	        matrixproto.x = function (x, y) {
	            return x * this.a + y * this.c + this.e;
	        };
	        /*\
	         * Matrix.y
	         [ method ]
	         **
	         * Returns y coordinate for given point after transformation described by the matrix. See also @Matrix.x
	         - x (number)
	         - y (number)
	         = (number) y
	        \*/
	        matrixproto.y = function (x, y) {
	            return x * this.b + y * this.d + this.f;
	        };
	        matrixproto.get = function (i) {
	            return +this[Str.fromCharCode(97 + i)].toFixed(4);
	        };
	        matrixproto.toString = function () {
	            return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
	        };
	        matrixproto.offset = function () {
	            return [this.e.toFixed(4), this.f.toFixed(4)];
	        };
	        function norm(a) {
	            return a[0] * a[0] + a[1] * a[1];
	        }
	        function normalize(a) {
	            var mag = math.sqrt(norm(a));
	            a[0] && (a[0] /= mag);
	            a[1] && (a[1] /= mag);
	        }
	        /*\
	         * Matrix.determinant
	         [ method ]
	         **
	         * Finds determinant of the given matrix.
	         = (number) determinant
	        \*/
	        matrixproto.determinant = function () {
	            return this.a * this.d - this.b * this.c;
	        };
	        /*\
	         * Matrix.split
	         [ method ]
	         **
	         * Splits matrix into primitive transformations
	         = (object) in format:
	         o dx (number) translation by x
	         o dy (number) translation by y
	         o scalex (number) scale by x
	         o scaley (number) scale by y
	         o shear (number) shear
	         o rotate (number) rotation in deg
	         o isSimple (boolean) could it be represented via simple transformations
	        \*/
	        matrixproto.split = function () {
	            var out = {};
	            // translation
	            out.dx = this.e;
	            out.dy = this.f;
	
	            // scale and shear
	            var row = [[this.a, this.b], [this.c, this.d]];
	            out.scalex = math.sqrt(norm(row[0]));
	            normalize(row[0]);
	
	            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
	            row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];
	
	            out.scaley = math.sqrt(norm(row[1]));
	            normalize(row[1]);
	            out.shear /= out.scaley;
	
	            if (this.determinant() < 0) {
	                out.scalex = -out.scalex;
	            }
	
	            // rotation
	            var sin = row[0][1],
	                cos = row[1][1];
	            if (cos < 0) {
	                out.rotate = Snap.deg(math.acos(cos));
	                if (sin < 0) {
	                    out.rotate = 360 - out.rotate;
	                }
	            } else {
	                out.rotate = Snap.deg(math.asin(sin));
	            }
	
	            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
	            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
	            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
	            return out;
	        };
	        /*\
	         * Matrix.toTransformString
	         [ method ]
	         **
	         * Returns transform string that represents given matrix
	         = (string) transform string
	        \*/
	        matrixproto.toTransformString = function (shorter) {
	            var s = shorter || this.split();
	            if (!+s.shear.toFixed(9)) {
	                s.scalex = +s.scalex.toFixed(4);
	                s.scaley = +s.scaley.toFixed(4);
	                s.rotate = +s.rotate.toFixed(4);
	                return  (s.dx || s.dy ? "t" + [+s.dx.toFixed(4), +s.dy.toFixed(4)] : E) +
	                        (s.rotate ? "r" + [+s.rotate.toFixed(4), 0, 0] : E) +
	                        (s.scalex != 1 || s.scaley != 1 ? "s" + [s.scalex, s.scaley, 0, 0] : E);
	            } else {
	                return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
	            }
	        };
	    })(Matrix.prototype);
	    /*\
	     * Snap.Matrix
	     [ method ]
	     **
	     * Matrix constructor, extend on your own risk.
	     * To create matrices use @Snap.matrix.
	    \*/
	    Snap.Matrix = Matrix;
	    /*\
	     * Snap.matrix
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns a matrix based on the given parameters
	     - a (number)
	     - b (number)
	     - c (number)
	     - d (number)
	     - e (number)
	     - f (number)
	     * or
	     - svgMatrix (SVGMatrix)
	     = (object) @Matrix
	    \*/
	    Snap.matrix = function (a, b, c, d, e, f) {
	        return new Matrix(a, b, c, d, e, f);
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var has = "hasOwnProperty",
	        make = Snap._.make,
	        wrap = Snap._.wrap,
	        is = Snap.is,
	        getSomeDefs = Snap._.getSomeDefs,
	        reURLValue = /^url\((['"]?)([^)]+)\1\)$/,
	        $ = Snap._.$,
	        URL = Snap.url,
	        Str = String,
	        separator = Snap._.separator,
	        E = "";
	    /*\
	     * Snap.deurl
	     [ method ]
	     **
	     * Unwraps path from `"url(<path>)"`.
	     - value (string) url path
	     = (string) unwrapped path
	    \*/
	    Snap.deurl = function (value) {
	        var res = String(value).match(reURLValue);
	        return res ? res[2] : value;
	    }
	    // Attributes event handlers
	    eve.on("snap.util.attr.mask", function (value) {
	        if (value instanceof Element || value instanceof Fragment) {
	            eve.stop();
	            if (value instanceof Fragment && value.node.childNodes.length == 1) {
	                value = value.node.firstChild;
	                getSomeDefs(this).appendChild(value);
	                value = wrap(value);
	            }
	            if (value.type == "mask") {
	                var mask = value;
	            } else {
	                mask = make("mask", getSomeDefs(this));
	                mask.node.appendChild(value.node);
	            }
	            !mask.node.id && $(mask.node, {
	                id: mask.id
	            });
	            $(this.node, {
	                mask: URL(mask.id)
	            });
	        }
	    });
	    (function (clipIt) {
	        eve.on("snap.util.attr.clip", clipIt);
	        eve.on("snap.util.attr.clip-path", clipIt);
	        eve.on("snap.util.attr.clipPath", clipIt);
	    }(function (value) {
	        if (value instanceof Element || value instanceof Fragment) {
	            eve.stop();
	            var clip,
	                node = value.node;
	            while (node) {
	                if (node.nodeName === "clipPath") {
	                    clip = new Element(node);
	                    break;
	                }
	                if (node.nodeName === "svg") {
	                    clip = undefined;
	                    break;
	                }
	                node = node.parentNode;
	            }
	            if (!clip) {
	                clip = make("clipPath", getSomeDefs(this));
	                clip.node.appendChild(value.node);
	                !clip.node.id && $(clip.node, {
	                    id: clip.id
	                });
	            }
	            $(this.node, {
	                "clip-path": URL(clip.node.id || clip.id)
	            });
	        }
	    }));
	    function fillStroke(name) {
	        return function (value) {
	            eve.stop();
	            if (value instanceof Fragment && value.node.childNodes.length == 1 &&
	                (value.node.firstChild.tagName == "radialGradient" ||
	                value.node.firstChild.tagName == "linearGradient" ||
	                value.node.firstChild.tagName == "pattern")) {
	                value = value.node.firstChild;
	                getSomeDefs(this).appendChild(value);
	                value = wrap(value);
	            }
	            if (value instanceof Element) {
	                if (value.type == "radialGradient" || value.type == "linearGradient"
	                   || value.type == "pattern") {
	                    if (!value.node.id) {
	                        $(value.node, {
	                            id: value.id
	                        });
	                    }
	                    var fill = URL(value.node.id);
	                } else {
	                    fill = value.attr(name);
	                }
	            } else {
	                fill = Snap.color(value);
	                if (fill.error) {
	                    var grad = Snap(getSomeDefs(this).ownerSVGElement).gradient(value);
	                    if (grad) {
	                        if (!grad.node.id) {
	                            $(grad.node, {
	                                id: grad.id
	                            });
	                        }
	                        fill = URL(grad.node.id);
	                    } else {
	                        fill = value;
	                    }
	                } else {
	                    fill = Str(fill);
	                }
	            }
	            var attrs = {};
	            attrs[name] = fill;
	            $(this.node, attrs);
	            this.node.style[name] = E;
	        };
	    }
	    eve.on("snap.util.attr.fill", fillStroke("fill"));
	    eve.on("snap.util.attr.stroke", fillStroke("stroke"));
	    var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
	    eve.on("snap.util.grad.parse", function parseGrad(string) {
	        string = Str(string);
	        var tokens = string.match(gradrg);
	        if (!tokens) {
	            return null;
	        }
	        var type = tokens[1],
	            params = tokens[2],
	            stops = tokens[3];
	        params = params.split(/\s*,\s*/).map(function (el) {
	            return +el == el ? +el : el;
	        });
	        if (params.length == 1 && params[0] == 0) {
	            params = [];
	        }
	        stops = stops.split("-");
	        stops = stops.map(function (el) {
	            el = el.split(":");
	            var out = {
	                color: el[0]
	            };
	            if (el[1]) {
	                out.offset = parseFloat(el[1]);
	            }
	            return out;
	        });
	        var len = stops.length,
	            start = 0,
	            j = 0;
	        function seed(i, end) {
	            var step = (end - start) / (i - j);
	            for (var k = j; k < i; k++) {
	                stops[k].offset = +(+start + step * (k - j)).toFixed(2);
	            }
	            j = i;
	            start = end;
	        }
	        len--;
	        for (var i = 0; i < len; i++) if ("offset" in stops[i]) {
	            seed(i, stops[i].offset);
	        }
	        stops[len].offset = stops[len].offset || 100;
	        seed(len, stops[len].offset);
	        return {
	            type: type,
	            params: params,
	            stops: stops
	        };
	    });
	
	    eve.on("snap.util.attr.d", function (value) {
	        eve.stop();
	        if (is(value, "array") && is(value[0], "array")) {
	            value = Snap.path.toString.call(value);
	        }
	        value = Str(value);
	        if (value.match(/[ruo]/i)) {
	            value = Snap.path.toAbsolute(value);
	        }
	        $(this.node, {d: value});
	    })(-1);
	    eve.on("snap.util.attr.#text", function (value) {
	        eve.stop();
	        value = Str(value);
	        var txt = glob.doc.createTextNode(value);
	        while (this.node.firstChild) {
	            this.node.removeChild(this.node.firstChild);
	        }
	        this.node.appendChild(txt);
	    })(-1);
	    eve.on("snap.util.attr.path", function (value) {
	        eve.stop();
	        this.attr({d: value});
	    })(-1);
	    eve.on("snap.util.attr.class", function (value) {
	        eve.stop();
	        this.node.className.baseVal = value;
	    })(-1);
	    eve.on("snap.util.attr.viewBox", function (value) {
	        var vb;
	        if (is(value, "object") && "x" in value) {
	            vb = [value.x, value.y, value.width, value.height].join(" ");
	        } else if (is(value, "array")) {
	            vb = value.join(" ");
	        } else {
	            vb = value;
	        }
	        $(this.node, {
	            viewBox: vb
	        });
	        eve.stop();
	    })(-1);
	    eve.on("snap.util.attr.transform", function (value) {
	        this.transform(value);
	        eve.stop();
	    })(-1);
	    eve.on("snap.util.attr.r", function (value) {
	        if (this.type == "rect") {
	            eve.stop();
	            $(this.node, {
	                rx: value,
	                ry: value
	            });
	        }
	    })(-1);
	    eve.on("snap.util.attr.textpath", function (value) {
	        eve.stop();
	        if (this.type == "text") {
	            var id, tp, node;
	            if (!value && this.textPath) {
	                tp = this.textPath;
	                while (tp.node.firstChild) {
	                    this.node.appendChild(tp.node.firstChild);
	                }
	                tp.remove();
	                delete this.textPath;
	                return;
	            }
	            if (is(value, "string")) {
	                var defs = getSomeDefs(this),
	                    path = wrap(defs.parentNode).path(value);
	                defs.appendChild(path.node);
	                id = path.id;
	                path.attr({id: id});
	            } else {
	                value = wrap(value);
	                if (value instanceof Element) {
	                    id = value.attr("id");
	                    if (!id) {
	                        id = value.id;
	                        value.attr({id: id});
	                    }
	                }
	            }
	            if (id) {
	                tp = this.textPath;
	                node = this.node;
	                if (tp) {
	                    tp.attr({"xlink:href": "#" + id});
	                } else {
	                    tp = $("textPath", {
	                        "xlink:href": "#" + id
	                    });
	                    while (node.firstChild) {
	                        tp.appendChild(node.firstChild);
	                    }
	                    node.appendChild(tp);
	                    this.textPath = wrap(tp);
	                }
	            }
	        }
	    })(-1);
	    eve.on("snap.util.attr.text", function (value) {
	        if (this.type == "text") {
	            var i = 0,
	                node = this.node,
	                tuner = function (chunk) {
	                    var out = $("tspan");
	                    if (is(chunk, "array")) {
	                        for (var i = 0; i < chunk.length; i++) {
	                            out.appendChild(tuner(chunk[i]));
	                        }
	                    } else {
	                        out.appendChild(glob.doc.createTextNode(chunk));
	                    }
	                    out.normalize && out.normalize();
	                    return out;
	                };
	            while (node.firstChild) {
	                node.removeChild(node.firstChild);
	            }
	            var tuned = tuner(value);
	            while (tuned.firstChild) {
	                node.appendChild(tuned.firstChild);
	            }
	        }
	        eve.stop();
	    })(-1);
	    function setFontSize(value) {
	        eve.stop();
	        if (value == +value) {
	            value += "px";
	        }
	        this.node.style.fontSize = value;
	    }
	    eve.on("snap.util.attr.fontSize", setFontSize)(-1);
	    eve.on("snap.util.attr.font-size", setFontSize)(-1);
	
	
	    eve.on("snap.util.getattr.transform", function () {
	        eve.stop();
	        return this.transform();
	    })(-1);
	    eve.on("snap.util.getattr.textpath", function () {
	        eve.stop();
	        return this.textPath;
	    })(-1);
	    // Markers
	    (function () {
	        function getter(end) {
	            return function () {
	                eve.stop();
	                var style = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
	                if (style == "none") {
	                    return style;
	                } else {
	                    return Snap(glob.doc.getElementById(style.match(reURLValue)[1]));
	                }
	            };
	        }
	        function setter(end) {
	            return function (value) {
	                eve.stop();
	                var name = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
	                if (value == "" || !value) {
	                    this.node.style[name] = "none";
	                    return;
	                }
	                if (value.type == "marker") {
	                    var id = value.node.id;
	                    if (!id) {
	                        $(value.node, {id: value.id});
	                    }
	                    this.node.style[name] = URL(id);
	                    return;
	                }
	            };
	        }
	        eve.on("snap.util.getattr.marker-end", getter("end"))(-1);
	        eve.on("snap.util.getattr.markerEnd", getter("end"))(-1);
	        eve.on("snap.util.getattr.marker-start", getter("start"))(-1);
	        eve.on("snap.util.getattr.markerStart", getter("start"))(-1);
	        eve.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
	        eve.on("snap.util.getattr.markerMid", getter("mid"))(-1);
	        eve.on("snap.util.attr.marker-end", setter("end"))(-1);
	        eve.on("snap.util.attr.markerEnd", setter("end"))(-1);
	        eve.on("snap.util.attr.marker-start", setter("start"))(-1);
	        eve.on("snap.util.attr.markerStart", setter("start"))(-1);
	        eve.on("snap.util.attr.marker-mid", setter("mid"))(-1);
	        eve.on("snap.util.attr.markerMid", setter("mid"))(-1);
	    }());
	    eve.on("snap.util.getattr.r", function () {
	        if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
	            eve.stop();
	            return $(this.node, "rx");
	        }
	    })(-1);
	    function textExtract(node) {
	        var out = [];
	        var children = node.childNodes;
	        for (var i = 0, ii = children.length; i < ii; i++) {
	            var chi = children[i];
	            if (chi.nodeType == 3) {
	                out.push(chi.nodeValue);
	            }
	            if (chi.tagName == "tspan") {
	                if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) {
	                    out.push(chi.firstChild.nodeValue);
	                } else {
	                    out.push(textExtract(chi));
	                }
	            }
	        }
	        return out;
	    }
	    eve.on("snap.util.getattr.text", function () {
	        if (this.type == "text" || this.type == "tspan") {
	            eve.stop();
	            var out = textExtract(this.node);
	            return out.length == 1 ? out[0] : out;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.#text", function () {
	        return this.node.textContent;
	    })(-1);
	    eve.on("snap.util.getattr.fill", function (internal) {
	        if (internal) {
	            return;
	        }
	        eve.stop();
	        var value = eve("snap.util.getattr.fill", this, true).firstDefined();
	        return Snap(Snap.deurl(value)) || value;
	    })(-1);
	    eve.on("snap.util.getattr.stroke", function (internal) {
	        if (internal) {
	            return;
	        }
	        eve.stop();
	        var value = eve("snap.util.getattr.stroke", this, true).firstDefined();
	        return Snap(Snap.deurl(value)) || value;
	    })(-1);
	    eve.on("snap.util.getattr.viewBox", function () {
	        eve.stop();
	        var vb = $(this.node, "viewBox");
	        if (vb) {
	            vb = vb.split(separator);
	            return Snap._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
	        } else {
	            return;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.points", function () {
	        var p = $(this.node, "points");
	        eve.stop();
	        if (p) {
	            return p.split(separator);
	        } else {
	            return;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.path", function () {
	        var p = $(this.node, "d");
	        eve.stop();
	        return p;
	    })(-1);
	    eve.on("snap.util.getattr.class", function () {
	        return this.node.className.baseVal;
	    })(-1);
	    function getFontSize() {
	        eve.stop();
	        return this.node.style.fontSize;
	    }
	    eve.on("snap.util.getattr.fontSize", getFontSize)(-1);
	    eve.on("snap.util.getattr.font-size", getFontSize)(-1);
	});
	
	// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var rgNotSpace = /\S+/g,
	        rgBadSpace = /[\t\r\n\f]/g,
	        rgTrim = /(^\s+|\s+$)/g,
	        Str = String,
	        elproto = Element.prototype;
	    /*\
	     * Element.addClass
	     [ method ]
	     **
	     * Adds given class name or list of class names to the element.
	     - value (string) class name or space separated list of class names
	     **
	     = (Element) original element.
	    \*/
	    elproto.addClass = function (value) {
	        var classes = Str(value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	
	        if (classes.length) {
	            j = 0;
	            while (clazz = classes[j++]) {
	                pos = curClasses.indexOf(clazz);
	                if (!~pos) {
	                    curClasses.push(clazz);
	                }
	            }
	
	            finalValue = curClasses.join(" ");
	            if (className != finalValue) {
	                elem.className.baseVal = finalValue;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Element.removeClass
	     [ method ]
	     **
	     * Removes given class name or list of class names from the element.
	     - value (string) class name or space separated list of class names
	     **
	     = (Element) original element.
	    \*/
	    elproto.removeClass = function (value) {
	        var classes = Str(value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	        if (curClasses.length) {
	            j = 0;
	            while (clazz = classes[j++]) {
	                pos = curClasses.indexOf(clazz);
	                if (~pos) {
	                    curClasses.splice(pos, 1);
	                }
	            }
	
	            finalValue = curClasses.join(" ");
	            if (className != finalValue) {
	                elem.className.baseVal = finalValue;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Element.hasClass
	     [ method ]
	     **
	     * Checks if the element has a given class name in the list of class names applied to it.
	     - value (string) class name
	     **
	     = (boolean) `true` if the element has given class
	    \*/
	    elproto.hasClass = function (value) {
	        var elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [];
	        return !!~curClasses.indexOf(value);
	    };
	    /*\
	     * Element.toggleClass
	     [ method ]
	     **
	     * Add or remove one or more classes from the element, depending on either
	     * the class’s presence or the value of the `flag` argument.
	     - value (string) class name or space separated list of class names
	     - flag (boolean) value to determine whether the class should be added or removed
	     **
	     = (Element) original element.
	    \*/
	    elproto.toggleClass = function (value, flag) {
	        if (flag != null) {
	            if (flag) {
	                return this.addClass(value);
	            } else {
	                return this.removeClass(value);
	            }
	        }
	        var classes = (value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	        j = 0;
	        while (clazz = classes[j++]) {
	            pos = curClasses.indexOf(clazz);
	            if (~pos) {
	                curClasses.splice(pos, 1);
	            } else {
	                curClasses.push(clazz);
	            }
	        }
	
	        finalValue = curClasses.join(" ");
	        if (className != finalValue) {
	            elem.className.baseVal = finalValue;
	        }
	        return this;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var operators = {
	            "+": function (x, y) {
	                    return x + y;
	                },
	            "-": function (x, y) {
	                    return x - y;
	                },
	            "/": function (x, y) {
	                    return x / y;
	                },
	            "*": function (x, y) {
	                    return x * y;
	                }
	        },
	        Str = String,
	        reUnit = /[a-z]+$/i,
	        reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
	    function getNumber(val) {
	        return val;
	    }
	    function getUnit(unit) {
	        return function (val) {
	            return +val.toFixed(3) + unit;
	        };
	    }
	    eve.on("snap.util.attr", function (val) {
	        var plus = Str(val).match(reAddon);
	        if (plus) {
	            var evnt = eve.nt(),
	                name = evnt.substring(evnt.lastIndexOf(".") + 1),
	                a = this.attr(name),
	                atr = {};
	            eve.stop();
	            var unit = plus[3] || "",
	                aUnit = a.match(reUnit),
	                op = operators[plus[1]];
	            if (aUnit && aUnit == unit) {
	                val = op(parseFloat(a), +plus[2]);
	            } else {
	                a = this.asPX(name);
	                val = op(this.asPX(name), this.asPX(name, plus[2] + unit));
	            }
	            if (isNaN(a) || isNaN(val)) {
	                return;
	            }
	            atr[name] = val;
	            this.attr(atr);
	        }
	    })(-10);
	    eve.on("snap.util.equal", function (name, b) {
	        var A, B, a = Str(this.attr(name) || ""),
	            el = this,
	            bplus = Str(b).match(reAddon);
	        if (bplus) {
	            eve.stop();
	            var unit = bplus[3] || "",
	                aUnit = a.match(reUnit),
	                op = operators[bplus[1]];
	            if (aUnit && aUnit == unit) {
	                return {
	                    from: parseFloat(a),
	                    to: op(parseFloat(a), +bplus[2]),
	                    f: getUnit(aUnit)
	                };
	            } else {
	                a = this.asPX(name);
	                return {
	                    from: a,
	                    to: op(a, this.asPX(name, bplus[2] + unit)),
	                    f: getNumber
	                };
	            }
	        }
	    })(-10);
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var proto = Paper.prototype,
	        is = Snap.is;
	    /*\
	     * Paper.rect
	     [ method ]
	     *
	     * Draws a rectangle
	     **
	     - x (number) x coordinate of the top left corner
	     - y (number) y coordinate of the top left corner
	     - width (number) width
	     - height (number) height
	     - rx (number) #optional horizontal radius for rounded corners, default is 0
	     - ry (number) #optional vertical radius for rounded corners, default is rx or 0
	     = (object) the `rect` element
	     **
	     > Usage
	     | // regular rectangle
	     | var c = paper.rect(10, 10, 50, 50);
	     | // rectangle with rounded corners
	     | var c = paper.rect(40, 40, 50, 50, 10);
	    \*/
	    proto.rect = function (x, y, w, h, rx, ry) {
	        var attr;
	        if (ry == null) {
	            ry = rx;
	        }
	        if (is(x, "object") && x == "[object Object]") {
	            attr = x;
	        } else if (x != null) {
	            attr = {
	                x: x,
	                y: y,
	                width: w,
	                height: h
	            };
	            if (rx != null) {
	                attr.rx = rx;
	                attr.ry = ry;
	            }
	        }
	        return this.el("rect", attr);
	    };
	    /*\
	     * Paper.circle
	     [ method ]
	     **
	     * Draws a circle
	     **
	     - x (number) x coordinate of the centre
	     - y (number) y coordinate of the centre
	     - r (number) radius
	     = (object) the `circle` element
	     **
	     > Usage
	     | var c = paper.circle(50, 50, 40);
	    \*/
	    proto.circle = function (cx, cy, r) {
	        var attr;
	        if (is(cx, "object") && cx == "[object Object]") {
	            attr = cx;
	        } else if (cx != null) {
	            attr = {
	                cx: cx,
	                cy: cy,
	                r: r
	            };
	        }
	        return this.el("circle", attr);
	    };
	
	    var preload = (function () {
	        function onerror() {
	            this.parentNode.removeChild(this);
	        }
	        return function (src, f) {
	            var img = glob.doc.createElement("img"),
	                body = glob.doc.body;
	            img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
	            img.onload = function () {
	                f.call(img);
	                img.onload = img.onerror = null;
	                body.removeChild(img);
	            };
	            img.onerror = onerror;
	            body.appendChild(img);
	            img.src = src;
	        };
	    }());
	
	    /*\
	     * Paper.image
	     [ method ]
	     **
	     * Places an image on the surface
	     **
	     - src (string) URI of the source image
	     - x (number) x offset position
	     - y (number) y offset position
	     - width (number) width of the image
	     - height (number) height of the image
	     = (object) the `image` element
	     * or
	     = (object) Snap element object with type `image`
	     **
	     > Usage
	     | var c = paper.image("apple.png", 10, 10, 80, 80);
	    \*/
	    proto.image = function (src, x, y, width, height) {
	        var el = this.el("image");
	        if (is(src, "object") && "src" in src) {
	            el.attr(src);
	        } else if (src != null) {
	            var set = {
	                "xlink:href": src,
	                preserveAspectRatio: "none"
	            };
	            if (x != null && y != null) {
	                set.x = x;
	                set.y = y;
	            }
	            if (width != null && height != null) {
	                set.width = width;
	                set.height = height;
	            } else {
	                preload(src, function () {
	                    Snap._.$(el.node, {
	                        width: this.offsetWidth,
	                        height: this.offsetHeight
	                    });
	                });
	            }
	            Snap._.$(el.node, set);
	        }
	        return el;
	    };
	    /*\
	     * Paper.ellipse
	     [ method ]
	     **
	     * Draws an ellipse
	     **
	     - x (number) x coordinate of the centre
	     - y (number) y coordinate of the centre
	     - rx (number) horizontal radius
	     - ry (number) vertical radius
	     = (object) the `ellipse` element
	     **
	     > Usage
	     | var c = paper.ellipse(50, 50, 40, 20);
	    \*/
	    proto.ellipse = function (cx, cy, rx, ry) {
	        var attr;
	        if (is(cx, "object") && cx == "[object Object]") {
	            attr = cx;
	        } else if (cx != null) {
	            attr ={
	                cx: cx,
	                cy: cy,
	                rx: rx,
	                ry: ry
	            };
	        }
	        return this.el("ellipse", attr);
	    };
	    // SIERRA Paper.path(): Unclear from the link what a Catmull-Rom curveto is, and why it would make life any easier.
	    /*\
	     * Paper.path
	     [ method ]
	     **
	     * Creates a `<path>` element using the given string as the path's definition
	     - pathString (string) #optional path string in SVG format
	     * Path string consists of one-letter commands, followed by comma seprarated arguments in numerical form. Example:
	     | "M10,20L30,40"
	     * This example features two commands: `M`, with arguments `(10, 20)` and `L` with arguments `(30, 40)`. Uppercase letter commands express coordinates in absolute terms, while lowercase commands express them in relative terms from the most recently declared coordinates.
	     *
	     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a> or <a href="https://developer.mozilla.org/en/SVG/Tutorial/Paths">article about path strings at MDN</a>.</p>
	     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
	     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
	     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
	     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
	     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
	     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
	     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
	     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
	     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
	     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
	     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
	     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
	     * * _Catmull-Rom curveto_ is a not standard SVG command and added to make life easier.
	     * Note: there is a special case when a path consists of only three commands: `M10,10R…z`. In this case the path connects back to its starting point.
	     > Usage
	     | var c = paper.path("M10 10L90 90");
	     | // draw a diagonal line:
	     | // move to 10,10, line to 90,90
	    \*/
	    proto.path = function (d) {
	        var attr;
	        if (is(d, "object") && !is(d, "array")) {
	            attr = d;
	        } else if (d) {
	            attr = {d: d};
	        }
	        return this.el("path", attr);
	    };
	    /*\
	     * Paper.g
	     [ method ]
	     **
	     * Creates a group element
	     **
	     - varargs (…) #optional elements to nest within the group
	     = (object) the `g` element
	     **
	     > Usage
	     | var c1 = paper.circle(),
	     |     c2 = paper.rect(),
	     |     g = paper.g(c2, c1); // note that the order of elements is different
	     * or
	     | var c1 = paper.circle(),
	     |     c2 = paper.rect(),
	     |     g = paper.g();
	     | g.add(c2, c1);
	    \*/
	    /*\
	     * Paper.group
	     [ method ]
	     **
	     * See @Paper.g
	    \*/
	    proto.group = proto.g = function (first) {
	        var attr,
	            el = this.el("g");
	        if (arguments.length == 1 && first && !first.type) {
	            el.attr(first);
	        } else if (arguments.length) {
	            el.add(Array.prototype.slice.call(arguments, 0));
	        }
	        return el;
	    };
	    /*\
	     * Paper.svg
	     [ method ]
	     **
	     * Creates a nested SVG element.
	     - x (number) @optional X of the element
	     - y (number) @optional Y of the element
	     - width (number) @optional width of the element
	     - height (number) @optional height of the element
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     **
	     = (object) the `svg` element
	     **
	    \*/
	    proto.svg = function (x, y, width, height, vbx, vby, vbw, vbh) {
	        var attrs = {};
	        if (is(x, "object") && y == null) {
	            attrs = x;
	        } else {
	            if (x != null) {
	                attrs.x = x;
	            }
	            if (y != null) {
	                attrs.y = y;
	            }
	            if (width != null) {
	                attrs.width = width;
	            }
	            if (height != null) {
	                attrs.height = height;
	            }
	            if (vbx != null && vby != null && vbw != null && vbh != null) {
	                attrs.viewBox = [vbx, vby, vbw, vbh];
	            }
	        }
	        return this.el("svg", attrs);
	    };
	    /*\
	     * Paper.mask
	     [ method ]
	     **
	     * Equivalent in behaviour to @Paper.g, except it’s a mask.
	     **
	     = (object) the `mask` element
	     **
	    \*/
	    proto.mask = function (first) {
	        var attr,
	            el = this.el("mask");
	        if (arguments.length == 1 && first && !first.type) {
	            el.attr(first);
	        } else if (arguments.length) {
	            el.add(Array.prototype.slice.call(arguments, 0));
	        }
	        return el;
	    };
	    /*\
	     * Paper.ptrn
	     [ method ]
	     **
	     * Equivalent in behaviour to @Paper.g, except it’s a pattern.
	     - x (number) @optional X of the element
	     - y (number) @optional Y of the element
	     - width (number) @optional width of the element
	     - height (number) @optional height of the element
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     **
	     = (object) the `pattern` element
	     **
	    \*/
	    proto.ptrn = function (x, y, width, height, vx, vy, vw, vh) {
	        if (is(x, "object")) {
	            var attr = x;
	        } else {
	            attr = {patternUnits: "userSpaceOnUse"};
	            if (x) {
	                attr.x = x;
	            }
	            if (y) {
	                attr.y = y;
	            }
	            if (width != null) {
	                attr.width = width;
	            }
	            if (height != null) {
	                attr.height = height;
	            }
	            if (vx != null && vy != null && vw != null && vh != null) {
	                attr.viewBox = [vx, vy, vw, vh];
	            } else {
	                attr.viewBox = [x || 0, y || 0, width || 0, height || 0];
	            }
	        }
	        return this.el("pattern", attr);
	    };
	    /*\
	     * Paper.use
	     [ method ]
	     **
	     * Creates a <use> element.
	     - id (string) @optional id of element to link
	     * or
	     - id (Element) @optional element to link
	     **
	     = (object) the `use` element
	     **
	    \*/
	    proto.use = function (id) {
	        if (id != null) {
	            if (id instanceof Element) {
	                if (!id.attr("id")) {
	                    id.attr({id: Snap._.id(id)});
	                }
	                id = id.attr("id");
	            }
	            if (String(id).charAt() == "#") {
	                id = id.substring(1);
	            }
	            return this.el("use", {"xlink:href": "#" + id});
	        } else {
	            return Element.prototype.use.call(this);
	        }
	    };
	    /*\
	     * Paper.symbol
	     [ method ]
	     **
	     * Creates a <symbol> element.
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     = (object) the `symbol` element
	     **
	    \*/
	    proto.symbol = function (vx, vy, vw, vh) {
	        var attr = {};
	        if (vx != null && vy != null && vw != null && vh != null) {
	            attr.viewBox = [vx, vy, vw, vh];
	        }
	
	        return this.el("symbol", attr);
	    };
	    /*\
	     * Paper.text
	     [ method ]
	     **
	     * Draws a text string
	     **
	     - x (number) x coordinate position
	     - y (number) y coordinate position
	     - text (string|array) The text string to draw or array of strings to nest within separate `<tspan>` elements
	     = (object) the `text` element
	     **
	     > Usage
	     | var t1 = paper.text(50, 50, "Snap");
	     | var t2 = paper.text(50, 50, ["S","n","a","p"]);
	     | // Text path usage
	     | t1.attr({textpath: "M10,10L100,100"});
	     | // or
	     | var pth = paper.path("M10,10L100,100");
	     | t1.attr({textpath: pth});
	    \*/
	    proto.text = function (x, y, text) {
	        var attr = {};
	        if (is(x, "object")) {
	            attr = x;
	        } else if (x != null) {
	            attr = {
	                x: x,
	                y: y,
	                text: text || ""
	            };
	        }
	        return this.el("text", attr);
	    };
	    /*\
	     * Paper.line
	     [ method ]
	     **
	     * Draws a line
	     **
	     - x1 (number) x coordinate position of the start
	     - y1 (number) y coordinate position of the start
	     - x2 (number) x coordinate position of the end
	     - y2 (number) y coordinate position of the end
	     = (object) the `line` element
	     **
	     > Usage
	     | var t1 = paper.line(50, 50, 100, 100);
	    \*/
	    proto.line = function (x1, y1, x2, y2) {
	        var attr = {};
	        if (is(x1, "object")) {
	            attr = x1;
	        } else if (x1 != null) {
	            attr = {
	                x1: x1,
	                x2: x2,
	                y1: y1,
	                y2: y2
	            };
	        }
	        return this.el("line", attr);
	    };
	    /*\
	     * Paper.polyline
	     [ method ]
	     **
	     * Draws a polyline
	     **
	     - points (array) array of points
	     * or
	     - varargs (…) points
	     = (object) the `polyline` element
	     **
	     > Usage
	     | var p1 = paper.polyline([10, 10, 100, 100]);
	     | var p2 = paper.polyline(10, 10, 100, 100);
	    \*/
	    proto.polyline = function (points) {
	        if (arguments.length > 1) {
	            points = Array.prototype.slice.call(arguments, 0);
	        }
	        var attr = {};
	        if (is(points, "object") && !is(points, "array")) {
	            attr = points;
	        } else if (points != null) {
	            attr = {points: points};
	        }
	        return this.el("polyline", attr);
	    };
	    /*\
	     * Paper.polygon
	     [ method ]
	     **
	     * Draws a polygon. See @Paper.polyline
	    \*/
	    proto.polygon = function (points) {
	        if (arguments.length > 1) {
	            points = Array.prototype.slice.call(arguments, 0);
	        }
	        var attr = {};
	        if (is(points, "object") && !is(points, "array")) {
	            attr = points;
	        } else if (points != null) {
	            attr = {points: points};
	        }
	        return this.el("polygon", attr);
	    };
	    // gradients
	    (function () {
	        var $ = Snap._.$;
	        // gradients' helpers
	        /*\
	         * Element.stops
	         [ method ]
	         **
	         * Only for gradients!
	         * Returns array of gradient stops elements.
	         = (array) the stops array.
	        \*/
	        function Gstops() {
	            return this.selectAll("stop");
	        }
	        /*\
	         * Element.addStop
	         [ method ]
	         **
	         * Only for gradients!
	         * Adds another stop to the gradient.
	         - color (string) stops color
	         - offset (number) stops offset 0..100
	         = (object) gradient element
	        \*/
	        function GaddStop(color, offset) {
	            var stop = $("stop"),
	                attr = {
	                    offset: +offset + "%"
	                };
	            color = Snap.color(color);
	            attr["stop-color"] = color.hex;
	            if (color.opacity < 1) {
	                attr["stop-opacity"] = color.opacity;
	            }
	            $(stop, attr);
	            var stops = this.stops(),
	                inserted;
	            for (var i = 0; i < stops.length; i++) {
	                var stopOffset = parseFloat(stops[i].attr("offset"));
	                if (stopOffset > offset) {
	                    this.node.insertBefore(stop, stops[i].node);
	                    inserted = true;
	                    break;
	                }
	            }
	            if (!inserted) {
	                this.node.appendChild(stop);
	            }
	            return this;
	        }
	        function GgetBBox() {
	            if (this.type == "linearGradient") {
	                var x1 = $(this.node, "x1") || 0,
	                    x2 = $(this.node, "x2") || 1,
	                    y1 = $(this.node, "y1") || 0,
	                    y2 = $(this.node, "y2") || 0;
	                return Snap._.box(x1, y1, math.abs(x2 - x1), math.abs(y2 - y1));
	            } else {
	                var cx = this.node.cx || .5,
	                    cy = this.node.cy || .5,
	                    r = this.node.r || 0;
	                return Snap._.box(cx - r, cy - r, r * 2, r * 2);
	            }
	        }
	        /*\
	         * Element.setStops
	         [ method ]
	         **
	         * Only for gradients!
	         * Updates stops of the gradient based on passed gradient descriptor. See @Ppaer.gradient
	         - str (string) gradient descriptor part after `()`.
	         = (object) gradient element
	         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
	         | g.setStops("#fff-#000-#f00-#fc0");
	        \*/
	        function GsetStops(str) {
	            var grad = str,
	                stops = this.stops();
	            if (typeof str == "string") {
	                grad = eve("snap.util.grad.parse", null, "l(0,0,0,1)" + str).firstDefined().stops;
	            }
	            if (!Snap.is(grad, "array")) {
	                return;
	            }
	            for (var i = 0; i < stops.length; i++) {
	                if (grad[i]) {
	                    var color = Snap.color(grad[i].color),
	                        attr = {"offset": grad[i].offset + "%"};
	                    attr["stop-color"] = color.hex;
	                    if (color.opacity < 1) {
	                        attr["stop-opacity"] = color.opacity;
	                    }
	                    stops[i].attr(attr);
	                } else {
	                    stops[i].remove();
	                }
	            }
	            for (i = stops.length; i < grad.length; i++) {
	                this.addStop(grad[i].color, grad[i].offset);
	            }
	            return this;
	        }
	        function gradient(defs, str) {
	            var grad = eve("snap.util.grad.parse", null, str).firstDefined(),
	                el;
	            if (!grad) {
	                return null;
	            }
	            grad.params.unshift(defs);
	            if (grad.type.toLowerCase() == "l") {
	                el = gradientLinear.apply(0, grad.params);
	            } else {
	                el = gradientRadial.apply(0, grad.params);
	            }
	            if (grad.type != grad.type.toLowerCase()) {
	                $(el.node, {
	                    gradientUnits: "userSpaceOnUse"
	                });
	            }
	            var stops = grad.stops,
	                len = stops.length;
	            for (var i = 0; i < len; i++) {
	                var stop = stops[i];
	                el.addStop(stop.color, stop.offset);
	            }
	            return el;
	        }
	        function gradientLinear(defs, x1, y1, x2, y2) {
	            var el = Snap._.make("linearGradient", defs);
	            el.stops = Gstops;
	            el.addStop = GaddStop;
	            el.getBBox = GgetBBox;
	            el.setStops = GsetStops;
	            if (x1 != null) {
	                $(el.node, {
	                    x1: x1,
	                    y1: y1,
	                    x2: x2,
	                    y2: y2
	                });
	            }
	            return el;
	        }
	        function gradientRadial(defs, cx, cy, r, fx, fy) {
	            var el = Snap._.make("radialGradient", defs);
	            el.stops = Gstops;
	            el.addStop = GaddStop;
	            el.getBBox = GgetBBox;
	            if (cx != null) {
	                $(el.node, {
	                    cx: cx,
	                    cy: cy,
	                    r: r
	                });
	            }
	            if (fx != null && fy != null) {
	                $(el.node, {
	                    fx: fx,
	                    fy: fy
	                });
	            }
	            return el;
	        }
	        /*\
	         * Paper.gradient
	         [ method ]
	         **
	         * Creates a gradient element
	         **
	         - gradient (string) gradient descriptor
	         > Gradient Descriptor
	         * The gradient descriptor is an expression formatted as
	         * follows: `<type>(<coords>)<colors>`.  The `<type>` can be
	         * either linear or radial.  The uppercase `L` or `R` letters
	         * indicate absolute coordinates offset from the SVG surface.
	         * Lowercase `l` or `r` letters indicate coordinates
	         * calculated relative to the element to which the gradient is
	         * applied.  Coordinates specify a linear gradient vector as
	         * `x1`, `y1`, `x2`, `y2`, or a radial gradient as `cx`, `cy`,
	         * `r` and optional `fx`, `fy` specifying a focal point away
	         * from the center of the circle. Specify `<colors>` as a list
	         * of dash-separated CSS color values.  Each color may be
	         * followed by a custom offset value, separated with a colon
	         * character.
	         > Examples
	         * Linear gradient, relative from top-left corner to bottom-right
	         * corner, from black through red to white:
	         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
	         * Linear gradient, absolute from (0, 0) to (100, 100), from black
	         * through red at 25% to white:
	         | var g = paper.gradient("L(0, 0, 100, 100)#000-#f00:25-#fff");
	         * Radial gradient, relative from the center of the element with radius
	         * half the width, from black to white:
	         | var g = paper.gradient("r(0.5, 0.5, 0.5)#000-#fff");
	         * To apply the gradient:
	         | paper.circle(50, 50, 40).attr({
	         |     fill: g
	         | });
	         = (object) the `gradient` element
	        \*/
	        proto.gradient = function (str) {
	            return gradient(this.defs, str);
	        };
	        proto.gradientLinear = function (x1, y1, x2, y2) {
	            return gradientLinear(this.defs, x1, y1, x2, y2);
	        };
	        proto.gradientRadial = function (cx, cy, r, fx, fy) {
	            return gradientRadial(this.defs, cx, cy, r, fx, fy);
	        };
	        /*\
	         * Paper.toString
	         [ method ]
	         **
	         * Returns SVG code for the @Paper
	         = (string) SVG code for the @Paper
	        \*/
	        proto.toString = function () {
	            var doc = this.node.ownerDocument,
	                f = doc.createDocumentFragment(),
	                d = doc.createElement("div"),
	                svg = this.node.cloneNode(true),
	                res;
	            f.appendChild(d);
	            d.appendChild(svg);
	            Snap._.$(svg, {xmlns: "http://www.w3.org/2000/svg"});
	            res = d.innerHTML;
	            f.removeChild(f.firstChild);
	            return res;
	        };
	        /*\
	         * Paper.toDataURL
	         [ method ]
	         **
	         * Returns SVG code for the @Paper as Data URI string.
	         = (string) Data URI string
	        \*/
	        proto.toDataURL = function () {
	            if (window && window.btoa) {
	                return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
	            }
	        };
	        /*\
	         * Paper.clear
	         [ method ]
	         **
	         * Removes all child nodes of the paper, except <defs>.
	        \*/
	        proto.clear = function () {
	            var node = this.node.firstChild,
	                next;
	            while (node) {
	                next = node.nextSibling;
	                if (node.tagName != "defs") {
	                    node.parentNode.removeChild(node);
	                } else {
	                    proto.clear.call({node: node});
	                }
	                node = next;
	            }
	        };
	    }());
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        clone = Snap._.clone,
	        has = "hasOwnProperty",
	        p2s = /,?([a-z]),?/gi,
	        toFloat = parseFloat,
	        math = Math,
	        PI = math.PI,
	        mmin = math.min,
	        mmax = math.max,
	        pow = math.pow,
	        abs = math.abs;
	    function paths(ps) {
	        var p = paths.ps = paths.ps || {};
	        if (p[ps]) {
	            p[ps].sleep = 100;
	        } else {
	            p[ps] = {
	                sleep: 100
	            };
	        }
	        setTimeout(function () {
	            for (var key in p) if (p[has](key) && key != ps) {
	                p[key].sleep--;
	                !p[key].sleep && delete p[key];
	            }
	        });
	        return p[ps];
	    }
	    function box(x, y, width, height) {
	        if (x == null) {
	            x = y = width = height = 0;
	        }
	        if (y == null) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            x = x.x;
	        }
	        return {
	            x: x,
	            y: y,
	            width: width,
	            w: width,
	            height: height,
	            h: height,
	            x2: x + width,
	            y2: y + height,
	            cx: x + width / 2,
	            cy: y + height / 2,
	            r1: math.min(width, height) / 2,
	            r2: math.max(width, height) / 2,
	            r0: math.sqrt(width * width + height * height) / 2,
	            path: rectPath(x, y, width, height),
	            vb: [x, y, width, height].join(" ")
	        };
	    }
	    function toString() {
	        return this.join(",").replace(p2s, "$1");
	    }
	    function pathClone(pathArray) {
	        var res = clone(pathArray);
	        res.toString = toString;
	        return res;
	    }
	    function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
	        if (length == null) {
	            return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
	        } else {
	            return findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y,
	                getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
	        }
	    }
	    function getLengthFactory(istotal, subpath) {
	        function O(val) {
	            return +(+val).toFixed(3);
	        }
	        return Snap._.cacher(function (path, length, onlystart) {
	            if (path instanceof Element) {
	                path = path.attr("d");
	            }
	            path = path2curve(path);
	            var x, y, p, l, sp = "", subpaths = {}, point,
	                len = 0;
	            for (var i = 0, ii = path.length; i < ii; i++) {
	                p = path[i];
	                if (p[0] == "M") {
	                    x = +p[1];
	                    y = +p[2];
	                } else {
	                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	                    if (len + l > length) {
	                        if (subpath && !subpaths.start) {
	                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
	                            sp += [
	                                "C" + O(point.start.x),
	                                O(point.start.y),
	                                O(point.m.x),
	                                O(point.m.y),
	                                O(point.x),
	                                O(point.y)
	                            ];
	                            if (onlystart) {return sp;}
	                            subpaths.start = sp;
	                            sp = [
	                                "M" + O(point.x),
	                                O(point.y) + "C" + O(point.n.x),
	                                O(point.n.y),
	                                O(point.end.x),
	                                O(point.end.y),
	                                O(p[5]),
	                                O(p[6])
	                            ].join();
	                            len += l;
	                            x = +p[5];
	                            y = +p[6];
	                            continue;
	                        }
	                        if (!istotal && !subpath) {
	                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
	                            return point;
	                        }
	                    }
	                    len += l;
	                    x = +p[5];
	                    y = +p[6];
	                }
	                sp += p.shift() + p;
	            }
	            subpaths.end = sp;
	            point = istotal ? len : subpath ? subpaths : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
	            return point;
	        }, null, Snap._.clone);
	    }
	    var getTotalLength = getLengthFactory(1),
	        getPointAtLength = getLengthFactory(),
	        getSubpathsAtLength = getLengthFactory(0, 1);
	    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	        var t1 = 1 - t,
	            t13 = pow(t1, 3),
	            t12 = pow(t1, 2),
	            t2 = t * t,
	            t3 = t2 * t,
	            x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
	            y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
	            mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
	            my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
	            nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
	            ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
	            ax = t1 * p1x + t * c1x,
	            ay = t1 * p1y + t * c1y,
	            cx = t1 * c2x + t * p2x,
	            cy = t1 * c2y + t * p2y,
	            alpha = 90 - math.atan2(mx - nx, my - ny) * 180 / PI;
	        // (mx > nx || my < ny) && (alpha += 180);
	        return {
	            x: x,
	            y: y,
	            m: {x: mx, y: my},
	            n: {x: nx, y: ny},
	            start: {x: ax, y: ay},
	            end: {x: cx, y: cy},
	            alpha: alpha
	        };
	    }
	    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
	        if (!Snap.is(p1x, "array")) {
	            p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
	        }
	        var bbox = curveDim.apply(null, p1x);
	        return box(
	            bbox.min.x,
	            bbox.min.y,
	            bbox.max.x - bbox.min.x,
	            bbox.max.y - bbox.min.y
	        );
	    }
	    function isPointInsideBBox(bbox, x, y) {
	        return  x >= bbox.x &&
	                x <= bbox.x + bbox.width &&
	                y >= bbox.y &&
	                y <= bbox.y + bbox.height;
	    }
	    function isBBoxIntersect(bbox1, bbox2) {
	        bbox1 = box(bbox1);
	        bbox2 = box(bbox2);
	        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y)
	            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y)
	            || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2)
	            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2)
	            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y)
	            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y)
	            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2)
	            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2)
	            || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x
	                || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x)
	            && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y
	                || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
	    }
	    function base3(t, p1, p2, p3, p4) {
	        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
	            t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
	        return t * t2 - 3 * p1 + 3 * p2;
	    }
	    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
	        if (z == null) {
	            z = 1;
	        }
	        z = z > 1 ? 1 : z < 0 ? 0 : z;
	        var z2 = z / 2,
	            n = 12,
	            Tvalues = [-.1252,.1252,-.3678,.3678,-.5873,.5873,-.7699,.7699,-.9041,.9041,-.9816,.9816],
	            Cvalues = [0.2491,0.2491,0.2335,0.2335,0.2032,0.2032,0.1601,0.1601,0.1069,0.1069,0.0472,0.0472],
	            sum = 0;
	        for (var i = 0; i < n; i++) {
	            var ct = z2 * Tvalues[i] + z2,
	                xbase = base3(ct, x1, x2, x3, x4),
	                ybase = base3(ct, y1, y2, y3, y4),
	                comb = xbase * xbase + ybase * ybase;
	            sum += Cvalues[i] * math.sqrt(comb);
	        }
	        return z2 * sum;
	    }
	    function getTotLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
	        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
	            return;
	        }
	        var t = 1,
	            step = t / 2,
	            t2 = t - step,
	            l,
	            e = .01;
	        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	        while (abs(l - ll) > e) {
	            step /= 2;
	            t2 += (l < ll ? 1 : -1) * step;
	            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	        }
	        return t2;
	    }
	    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
	        if (
	            mmax(x1, x2) < mmin(x3, x4) ||
	            mmin(x1, x2) > mmax(x3, x4) ||
	            mmax(y1, y2) < mmin(y3, y4) ||
	            mmin(y1, y2) > mmax(y3, y4)
	        ) {
	            return;
	        }
	        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
	            ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
	            denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
	
	        if (!denominator) {
	            return;
	        }
	        var px = nx / denominator,
	            py = ny / denominator,
	            px2 = +px.toFixed(2),
	            py2 = +py.toFixed(2);
	        if (
	            px2 < +mmin(x1, x2).toFixed(2) ||
	            px2 > +mmax(x1, x2).toFixed(2) ||
	            px2 < +mmin(x3, x4).toFixed(2) ||
	            px2 > +mmax(x3, x4).toFixed(2) ||
	            py2 < +mmin(y1, y2).toFixed(2) ||
	            py2 > +mmax(y1, y2).toFixed(2) ||
	            py2 < +mmin(y3, y4).toFixed(2) ||
	            py2 > +mmax(y3, y4).toFixed(2)
	        ) {
	            return;
	        }
	        return {x: px, y: py};
	    }
	    function inter(bez1, bez2) {
	        return interHelper(bez1, bez2);
	    }
	    function interCount(bez1, bez2) {
	        return interHelper(bez1, bez2, 1);
	    }
	    function interHelper(bez1, bez2, justCount) {
	        var bbox1 = bezierBBox(bez1),
	            bbox2 = bezierBBox(bez2);
	        if (!isBBoxIntersect(bbox1, bbox2)) {
	            return justCount ? 0 : [];
	        }
	        var l1 = bezlen.apply(0, bez1),
	            l2 = bezlen.apply(0, bez2),
	            n1 = ~~(l1 / 8),
	            n2 = ~~(l2 / 8),
	            dots1 = [],
	            dots2 = [],
	            xy = {},
	            res = justCount ? 0 : [];
	        for (var i = 0; i < n1 + 1; i++) {
	            var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
	            dots1.push({x: p.x, y: p.y, t: i / n1});
	        }
	        for (i = 0; i < n2 + 1; i++) {
	            p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
	            dots2.push({x: p.x, y: p.y, t: i / n2});
	        }
	        for (i = 0; i < n1; i++) {
	            for (var j = 0; j < n2; j++) {
	                var di = dots1[i],
	                    di1 = dots1[i + 1],
	                    dj = dots2[j],
	                    dj1 = dots2[j + 1],
	                    ci = abs(di1.x - di.x) < .001 ? "y" : "x",
	                    cj = abs(dj1.x - dj.x) < .001 ? "y" : "x",
	                    is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
	                if (is) {
	                    if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) {
	                        continue;
	                    }
	                    xy[is.x.toFixed(4)] = is.y.toFixed(4);
	                    var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
	                        t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
	                    if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
	                        if (justCount) {
	                            res++;
	                        } else {
	                            res.push({
	                                x: is.x,
	                                y: is.y,
	                                t1: t1,
	                                t2: t2
	                            });
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    }
	    function pathIntersection(path1, path2) {
	        return interPathHelper(path1, path2);
	    }
	    function pathIntersectionNumber(path1, path2) {
	        return interPathHelper(path1, path2, 1);
	    }
	    function interPathHelper(path1, path2, justCount) {
	        path1 = path2curve(path1);
	        path2 = path2curve(path2);
	        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2,
	            res = justCount ? 0 : [];
	        for (var i = 0, ii = path1.length; i < ii; i++) {
	            var pi = path1[i];
	            if (pi[0] == "M") {
	                x1 = x1m = pi[1];
	                y1 = y1m = pi[2];
	            } else {
	                if (pi[0] == "C") {
	                    bez1 = [x1, y1].concat(pi.slice(1));
	                    x1 = bez1[6];
	                    y1 = bez1[7];
	                } else {
	                    bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
	                    x1 = x1m;
	                    y1 = y1m;
	                }
	                for (var j = 0, jj = path2.length; j < jj; j++) {
	                    var pj = path2[j];
	                    if (pj[0] == "M") {
	                        x2 = x2m = pj[1];
	                        y2 = y2m = pj[2];
	                    } else {
	                        if (pj[0] == "C") {
	                            bez2 = [x2, y2].concat(pj.slice(1));
	                            x2 = bez2[6];
	                            y2 = bez2[7];
	                        } else {
	                            bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
	                            x2 = x2m;
	                            y2 = y2m;
	                        }
	                        var intr = interHelper(bez1, bez2, justCount);
	                        if (justCount) {
	                            res += intr;
	                        } else {
	                            for (var k = 0, kk = intr.length; k < kk; k++) {
	                                intr[k].segment1 = i;
	                                intr[k].segment2 = j;
	                                intr[k].bez1 = bez1;
	                                intr[k].bez2 = bez2;
	                            }
	                            res = res.concat(intr);
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    }
	    function isPointInsidePath(path, x, y) {
	        var bbox = pathBBox(path);
	        return isPointInsideBBox(bbox, x, y) &&
	               interPathHelper(path, [["M", x, y], ["H", bbox.x2 + 10]], 1) % 2 == 1;
	    }
	    function pathBBox(path) {
	        var pth = paths(path);
	        if (pth.bbox) {
	            return clone(pth.bbox);
	        }
	        if (!path) {
	            return box();
	        }
	        path = path2curve(path);
	        var x = 0,
	            y = 0,
	            X = [],
	            Y = [],
	            p;
	        for (var i = 0, ii = path.length; i < ii; i++) {
	            p = path[i];
	            if (p[0] == "M") {
	                x = p[1];
	                y = p[2];
	                X.push(x);
	                Y.push(y);
	            } else {
	                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	                X = X.concat(dim.min.x, dim.max.x);
	                Y = Y.concat(dim.min.y, dim.max.y);
	                x = p[5];
	                y = p[6];
	            }
	        }
	        var xmin = mmin.apply(0, X),
	            ymin = mmin.apply(0, Y),
	            xmax = mmax.apply(0, X),
	            ymax = mmax.apply(0, Y),
	            bb = box(xmin, ymin, xmax - xmin, ymax - ymin);
	        pth.bbox = clone(bb);
	        return bb;
	    }
	    function rectPath(x, y, w, h, r) {
	        if (r) {
	            return [
	                ["M", +x + +r, y],
	                ["l", w - r * 2, 0],
	                ["a", r, r, 0, 0, 1, r, r],
	                ["l", 0, h - r * 2],
	                ["a", r, r, 0, 0, 1, -r, r],
	                ["l", r * 2 - w, 0],
	                ["a", r, r, 0, 0, 1, -r, -r],
	                ["l", 0, r * 2 - h],
	                ["a", r, r, 0, 0, 1, r, -r],
	                ["z"]
	            ];
	        }
	        var res = [["M", x, y], ["l", w, 0], ["l", 0, h], ["l", -w, 0], ["z"]];
	        res.toString = toString;
	        return res;
	    }
	    function ellipsePath(x, y, rx, ry, a) {
	        if (a == null && ry == null) {
	            ry = rx;
	        }
	        x = +x;
	        y = +y;
	        rx = +rx;
	        ry = +ry;
	        if (a != null) {
	            var rad = Math.PI / 180,
	                x1 = x + rx * Math.cos(-ry * rad),
	                x2 = x + rx * Math.cos(-a * rad),
	                y1 = y + rx * Math.sin(-ry * rad),
	                y2 = y + rx * Math.sin(-a * rad),
	                res = [["M", x1, y1], ["A", rx, rx, 0, +(a - ry > 180), 0, x2, y2]];
	        } else {
	            res = [
	                ["M", x, y],
	                ["m", 0, -ry],
	                ["a", rx, ry, 0, 1, 1, 0, 2 * ry],
	                ["a", rx, ry, 0, 1, 1, 0, -2 * ry],
	                ["z"]
	            ];
	        }
	        res.toString = toString;
	        return res;
	    }
	    var unit2px = Snap._unit2px,
	        getPath = {
	        path: function (el) {
	            return el.attr("path");
	        },
	        circle: function (el) {
	            var attr = unit2px(el);
	            return ellipsePath(attr.cx, attr.cy, attr.r);
	        },
	        ellipse: function (el) {
	            var attr = unit2px(el);
	            return ellipsePath(attr.cx || 0, attr.cy || 0, attr.rx, attr.ry);
	        },
	        rect: function (el) {
	            var attr = unit2px(el);
	            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height, attr.rx, attr.ry);
	        },
	        image: function (el) {
	            var attr = unit2px(el);
	            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height);
	        },
	        line: function (el) {
	            return "M" + [el.attr("x1") || 0, el.attr("y1") || 0, el.attr("x2"), el.attr("y2")];
	        },
	        polyline: function (el) {
	            return "M" + el.attr("points");
	        },
	        polygon: function (el) {
	            return "M" + el.attr("points") + "z";
	        },
	        deflt: function (el) {
	            var bbox = el.node.getBBox();
	            return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
	        }
	    };
	    function pathToRelative(pathArray) {
	        var pth = paths(pathArray),
	            lowerCase = String.prototype.toLowerCase;
	        if (pth.rel) {
	            return pathClone(pth.rel);
	        }
	        if (!Snap.is(pathArray, "array") || !Snap.is(pathArray && pathArray[0], "array")) {
	            pathArray = Snap.parsePathString(pathArray);
	        }
	        var res = [],
	            x = 0,
	            y = 0,
	            mx = 0,
	            my = 0,
	            start = 0;
	        if (pathArray[0][0] == "M") {
	            x = pathArray[0][1];
	            y = pathArray[0][2];
	            mx = x;
	            my = y;
	            start++;
	            res.push(["M", x, y]);
	        }
	        for (var i = start, ii = pathArray.length; i < ii; i++) {
	            var r = res[i] = [],
	                pa = pathArray[i];
	            if (pa[0] != lowerCase.call(pa[0])) {
	                r[0] = lowerCase.call(pa[0]);
	                switch (r[0]) {
	                    case "a":
	                        r[1] = pa[1];
	                        r[2] = pa[2];
	                        r[3] = pa[3];
	                        r[4] = pa[4];
	                        r[5] = pa[5];
	                        r[6] = +(pa[6] - x).toFixed(3);
	                        r[7] = +(pa[7] - y).toFixed(3);
	                        break;
	                    case "v":
	                        r[1] = +(pa[1] - y).toFixed(3);
	                        break;
	                    case "m":
	                        mx = pa[1];
	                        my = pa[2];
	                    default:
	                        for (var j = 1, jj = pa.length; j < jj; j++) {
	                            r[j] = +(pa[j] - (j % 2 ? x : y)).toFixed(3);
	                        }
	                }
	            } else {
	                r = res[i] = [];
	                if (pa[0] == "m") {
	                    mx = pa[1] + x;
	                    my = pa[2] + y;
	                }
	                for (var k = 0, kk = pa.length; k < kk; k++) {
	                    res[i][k] = pa[k];
	                }
	            }
	            var len = res[i].length;
	            switch (res[i][0]) {
	                case "z":
	                    x = mx;
	                    y = my;
	                    break;
	                case "h":
	                    x += +res[i][len - 1];
	                    break;
	                case "v":
	                    y += +res[i][len - 1];
	                    break;
	                default:
	                    x += +res[i][len - 2];
	                    y += +res[i][len - 1];
	            }
	        }
	        res.toString = toString;
	        pth.rel = pathClone(res);
	        return res;
	    }
	    function pathToAbsolute(pathArray) {
	        var pth = paths(pathArray);
	        if (pth.abs) {
	            return pathClone(pth.abs);
	        }
	        if (!is(pathArray, "array") || !is(pathArray && pathArray[0], "array")) { // rough assumption
	            pathArray = Snap.parsePathString(pathArray);
	        }
	        if (!pathArray || !pathArray.length) {
	            return [["M", 0, 0]];
	        }
	        var res = [],
	            x = 0,
	            y = 0,
	            mx = 0,
	            my = 0,
	            start = 0,
	            pa0;
	        if (pathArray[0][0] == "M") {
	            x = +pathArray[0][1];
	            y = +pathArray[0][2];
	            mx = x;
	            my = y;
	            start++;
	            res[0] = ["M", x, y];
	        }
	        var crz = pathArray.length == 3 &&
	            pathArray[0][0] == "M" &&
	            pathArray[1][0].toUpperCase() == "R" &&
	            pathArray[2][0].toUpperCase() == "Z";
	        for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
	            res.push(r = []);
	            pa = pathArray[i];
	            pa0 = pa[0];
	            if (pa0 != pa0.toUpperCase()) {
	                r[0] = pa0.toUpperCase();
	                switch (r[0]) {
	                    case "A":
	                        r[1] = pa[1];
	                        r[2] = pa[2];
	                        r[3] = pa[3];
	                        r[4] = pa[4];
	                        r[5] = pa[5];
	                        r[6] = +pa[6] + x;
	                        r[7] = +pa[7] + y;
	                        break;
	                    case "V":
	                        r[1] = +pa[1] + y;
	                        break;
	                    case "H":
	                        r[1] = +pa[1] + x;
	                        break;
	                    case "R":
	                        var dots = [x, y].concat(pa.slice(1));
	                        for (var j = 2, jj = dots.length; j < jj; j++) {
	                            dots[j] = +dots[j] + x;
	                            dots[++j] = +dots[j] + y;
	                        }
	                        res.pop();
	                        res = res.concat(catmullRom2bezier(dots, crz));
	                        break;
	                    case "O":
	                        res.pop();
	                        dots = ellipsePath(x, y, pa[1], pa[2]);
	                        dots.push(dots[0]);
	                        res = res.concat(dots);
	                        break;
	                    case "U":
	                        res.pop();
	                        res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
	                        r = ["U"].concat(res[res.length - 1].slice(-2));
	                        break;
	                    case "M":
	                        mx = +pa[1] + x;
	                        my = +pa[2] + y;
	                    default:
	                        for (j = 1, jj = pa.length; j < jj; j++) {
	                            r[j] = +pa[j] + (j % 2 ? x : y);
	                        }
	                }
	            } else if (pa0 == "R") {
	                dots = [x, y].concat(pa.slice(1));
	                res.pop();
	                res = res.concat(catmullRom2bezier(dots, crz));
	                r = ["R"].concat(pa.slice(-2));
	            } else if (pa0 == "O") {
	                res.pop();
	                dots = ellipsePath(x, y, pa[1], pa[2]);
	                dots.push(dots[0]);
	                res = res.concat(dots);
	            } else if (pa0 == "U") {
	                res.pop();
	                res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
	                r = ["U"].concat(res[res.length - 1].slice(-2));
	            } else {
	                for (var k = 0, kk = pa.length; k < kk; k++) {
	                    r[k] = pa[k];
	                }
	            }
	            pa0 = pa0.toUpperCase();
	            if (pa0 != "O") {
	                switch (r[0]) {
	                    case "Z":
	                        x = +mx;
	                        y = +my;
	                        break;
	                    case "H":
	                        x = r[1];
	                        break;
	                    case "V":
	                        y = r[1];
	                        break;
	                    case "M":
	                        mx = r[r.length - 2];
	                        my = r[r.length - 1];
	                    default:
	                        x = r[r.length - 2];
	                        y = r[r.length - 1];
	                }
	            }
	        }
	        res.toString = toString;
	        pth.abs = pathClone(res);
	        return res;
	    }
	    function l2c(x1, y1, x2, y2) {
	        return [x1, y1, x2, y2, x2, y2];
	    }
	    function q2c(x1, y1, ax, ay, x2, y2) {
	        var _13 = 1 / 3,
	            _23 = 2 / 3;
	        return [
	                _13 * x1 + _23 * ax,
	                _13 * y1 + _23 * ay,
	                _13 * x2 + _23 * ax,
	                _13 * y2 + _23 * ay,
	                x2,
	                y2
	            ];
	    }
	    function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
	        // for more information of where this math came from visit:
	        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
	        var _120 = PI * 120 / 180,
	            rad = PI / 180 * (+angle || 0),
	            res = [],
	            xy,
	            rotate = Snap._.cacher(function (x, y, rad) {
	                var X = x * math.cos(rad) - y * math.sin(rad),
	                    Y = x * math.sin(rad) + y * math.cos(rad);
	                return {x: X, y: Y};
	            });
	        if (!rx || !ry) {
	            return [x1, y1, x2, y2, x2, y2];
	        }
	        if (!recursive) {
	            xy = rotate(x1, y1, -rad);
	            x1 = xy.x;
	            y1 = xy.y;
	            xy = rotate(x2, y2, -rad);
	            x2 = xy.x;
	            y2 = xy.y;
	            var cos = math.cos(PI / 180 * angle),
	                sin = math.sin(PI / 180 * angle),
	                x = (x1 - x2) / 2,
	                y = (y1 - y2) / 2;
	            var h = x * x / (rx * rx) + y * y / (ry * ry);
	            if (h > 1) {
	                h = math.sqrt(h);
	                rx = h * rx;
	                ry = h * ry;
	            }
	            var rx2 = rx * rx,
	                ry2 = ry * ry,
	                k = (large_arc_flag == sweep_flag ? -1 : 1) *
	                    math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
	                cx = k * rx * y / ry + (x1 + x2) / 2,
	                cy = k * -ry * x / rx + (y1 + y2) / 2,
	                f1 = math.asin(((y1 - cy) / ry).toFixed(9)),
	                f2 = math.asin(((y2 - cy) / ry).toFixed(9));
	
	            f1 = x1 < cx ? PI - f1 : f1;
	            f2 = x2 < cx ? PI - f2 : f2;
	            f1 < 0 && (f1 = PI * 2 + f1);
	            f2 < 0 && (f2 = PI * 2 + f2);
	            if (sweep_flag && f1 > f2) {
	                f1 = f1 - PI * 2;
	            }
	            if (!sweep_flag && f2 > f1) {
	                f2 = f2 - PI * 2;
	            }
	        } else {
	            f1 = recursive[0];
	            f2 = recursive[1];
	            cx = recursive[2];
	            cy = recursive[3];
	        }
	        var df = f2 - f1;
	        if (abs(df) > _120) {
	            var f2old = f2,
	                x2old = x2,
	                y2old = y2;
	            f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
	            x2 = cx + rx * math.cos(f2);
	            y2 = cy + ry * math.sin(f2);
	            res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
	        }
	        df = f2 - f1;
	        var c1 = math.cos(f1),
	            s1 = math.sin(f1),
	            c2 = math.cos(f2),
	            s2 = math.sin(f2),
	            t = math.tan(df / 4),
	            hx = 4 / 3 * rx * t,
	            hy = 4 / 3 * ry * t,
	            m1 = [x1, y1],
	            m2 = [x1 + hx * s1, y1 - hy * c1],
	            m3 = [x2 + hx * s2, y2 - hy * c2],
	            m4 = [x2, y2];
	        m2[0] = 2 * m1[0] - m2[0];
	        m2[1] = 2 * m1[1] - m2[1];
	        if (recursive) {
	            return [m2, m3, m4].concat(res);
	        } else {
	            res = [m2, m3, m4].concat(res).join().split(",");
	            var newres = [];
	            for (var i = 0, ii = res.length; i < ii; i++) {
	                newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
	            }
	            return newres;
	        }
	    }
	    function findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	        var t1 = 1 - t;
	        return {
	            x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
	            y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
	        };
	    }
	
	    // Returns bounding box of cubic bezier curve.
	    // Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
	    // Original version: NISHIO Hirokazu
	    // Modifications: https://github.com/timo22345
	    function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
	        var tvalues = [],
	            bounds = [[], []],
	            a, b, c, t, t1, t2, b2ac, sqrtb2ac;
	        for (var i = 0; i < 2; ++i) {
	            if (i == 0) {
	                b = 6 * x0 - 12 * x1 + 6 * x2;
	                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
	                c = 3 * x1 - 3 * x0;
	            } else {
	                b = 6 * y0 - 12 * y1 + 6 * y2;
	                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
	                c = 3 * y1 - 3 * y0;
	            }
	            if (abs(a) < 1e-12) {
	                if (abs(b) < 1e-12) {
	                    continue;
	                }
	                t = -c / b;
	                if (0 < t && t < 1) {
	                    tvalues.push(t);
	                }
	                continue;
	            }
	            b2ac = b * b - 4 * c * a;
	            sqrtb2ac = math.sqrt(b2ac);
	            if (b2ac < 0) {
	                continue;
	            }
	            t1 = (-b + sqrtb2ac) / (2 * a);
	            if (0 < t1 && t1 < 1) {
	                tvalues.push(t1);
	            }
	            t2 = (-b - sqrtb2ac) / (2 * a);
	            if (0 < t2 && t2 < 1) {
	                tvalues.push(t2);
	            }
	        }
	
	        var x, y, j = tvalues.length,
	            jlen = j,
	            mt;
	        while (j--) {
	            t = tvalues[j];
	            mt = 1 - t;
	            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
	            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
	        }
	
	        bounds[0][jlen] = x0;
	        bounds[1][jlen] = y0;
	        bounds[0][jlen + 1] = x3;
	        bounds[1][jlen + 1] = y3;
	        bounds[0].length = bounds[1].length = jlen + 2;
	
	
	        return {
	          min: {x: mmin.apply(0, bounds[0]), y: mmin.apply(0, bounds[1])},
	          max: {x: mmax.apply(0, bounds[0]), y: mmax.apply(0, bounds[1])}
	        };
	    }
	
	    function path2curve(path, path2) {
	        var pth = !path2 && paths(path);
	        if (!path2 && pth.curve) {
	            return pathClone(pth.curve);
	        }
	        var p = pathToAbsolute(path),
	            p2 = path2 && pathToAbsolute(path2),
	            attrs = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
	            attrs2 = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
	            processPath = function (path, d, pcom) {
	                var nx, ny;
	                if (!path) {
	                    return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
	                }
	                !(path[0] in {T: 1, Q: 1}) && (d.qx = d.qy = null);
	                switch (path[0]) {
	                    case "M":
	                        d.X = path[1];
	                        d.Y = path[2];
	                        break;
	                    case "A":
	                        path = ["C"].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
	                        break;
	                    case "S":
	                        if (pcom == "C" || pcom == "S") { // In "S" case we have to take into account, if the previous command is C/S.
	                            nx = d.x * 2 - d.bx;          // And reflect the previous
	                            ny = d.y * 2 - d.by;          // command's control point relative to the current point.
	                        }
	                        else {                            // or some else or nothing
	                            nx = d.x;
	                            ny = d.y;
	                        }
	                        path = ["C", nx, ny].concat(path.slice(1));
	                        break;
	                    case "T":
	                        if (pcom == "Q" || pcom == "T") { // In "T" case we have to take into account, if the previous command is Q/T.
	                            d.qx = d.x * 2 - d.qx;        // And make a reflection similar
	                            d.qy = d.y * 2 - d.qy;        // to case "S".
	                        }
	                        else {                            // or something else or nothing
	                            d.qx = d.x;
	                            d.qy = d.y;
	                        }
	                        path = ["C"].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
	                        break;
	                    case "Q":
	                        d.qx = path[1];
	                        d.qy = path[2];
	                        path = ["C"].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
	                        break;
	                    case "L":
	                        path = ["C"].concat(l2c(d.x, d.y, path[1], path[2]));
	                        break;
	                    case "H":
	                        path = ["C"].concat(l2c(d.x, d.y, path[1], d.y));
	                        break;
	                    case "V":
	                        path = ["C"].concat(l2c(d.x, d.y, d.x, path[1]));
	                        break;
	                    case "Z":
	                        path = ["C"].concat(l2c(d.x, d.y, d.X, d.Y));
	                        break;
	                }
	                return path;
	            },
	            fixArc = function (pp, i) {
	                if (pp[i].length > 7) {
	                    pp[i].shift();
	                    var pi = pp[i];
	                    while (pi.length) {
	                        pcoms1[i] = "A"; // if created multiple C:s, their original seg is saved
	                        p2 && (pcoms2[i] = "A"); // the same as above
	                        pp.splice(i++, 0, ["C"].concat(pi.splice(0, 6)));
	                    }
	                    pp.splice(i, 1);
	                    ii = mmax(p.length, p2 && p2.length || 0);
	                }
	            },
	            fixM = function (path1, path2, a1, a2, i) {
	                if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
	                    path2.splice(i, 0, ["M", a2.x, a2.y]);
	                    a1.bx = 0;
	                    a1.by = 0;
	                    a1.x = path1[i][1];
	                    a1.y = path1[i][2];
	                    ii = mmax(p.length, p2 && p2.length || 0);
	                }
	            },
	            pcoms1 = [], // path commands of original path p
	            pcoms2 = [], // path commands of original path p2
	            pfirst = "", // temporary holder for original path command
	            pcom = ""; // holder for previous path command of original path
	        for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
	            p[i] && (pfirst = p[i][0]); // save current path command
	
	            if (pfirst != "C") // C is not saved yet, because it may be result of conversion
	            {
	                pcoms1[i] = pfirst; // Save current path command
	                i && ( pcom = pcoms1[i - 1]); // Get previous path command pcom
	            }
	            p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath
	
	            if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
	            // which may produce multiple C:s
	            // so we have to make sure that C is also C in original path
	
	            fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1
	
	            if (p2) { // the same procedures is done to p2
	                p2[i] && (pfirst = p2[i][0]);
	                if (pfirst != "C") {
	                    pcoms2[i] = pfirst;
	                    i && (pcom = pcoms2[i - 1]);
	                }
	                p2[i] = processPath(p2[i], attrs2, pcom);
	
	                if (pcoms2[i] != "A" && pfirst == "C") {
	                    pcoms2[i] = "C";
	                }
	
	                fixArc(p2, i);
	            }
	            fixM(p, p2, attrs, attrs2, i);
	            fixM(p2, p, attrs2, attrs, i);
	            var seg = p[i],
	                seg2 = p2 && p2[i],
	                seglen = seg.length,
	                seg2len = p2 && seg2.length;
	            attrs.x = seg[seglen - 2];
	            attrs.y = seg[seglen - 1];
	            attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
	            attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
	            attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
	            attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
	            attrs2.x = p2 && seg2[seg2len - 2];
	            attrs2.y = p2 && seg2[seg2len - 1];
	        }
	        if (!p2) {
	            pth.curve = pathClone(p);
	        }
	        return p2 ? [p, p2] : p;
	    }
	    function mapPath(path, matrix) {
	        if (!matrix) {
	            return path;
	        }
	        var x, y, i, j, ii, jj, pathi;
	        path = path2curve(path);
	        for (i = 0, ii = path.length; i < ii; i++) {
	            pathi = path[i];
	            for (j = 1, jj = pathi.length; j < jj; j += 2) {
	                x = matrix.x(pathi[j], pathi[j + 1]);
	                y = matrix.y(pathi[j], pathi[j + 1]);
	                pathi[j] = x;
	                pathi[j + 1] = y;
	            }
	        }
	        return path;
	    }
	
	    // http://schepers.cc/getting-to-the-point
	    function catmullRom2bezier(crp, z) {
	        var d = [];
	        for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
	            var p = [
	                        {x: +crp[i - 2], y: +crp[i - 1]},
	                        {x: +crp[i],     y: +crp[i + 1]},
	                        {x: +crp[i + 2], y: +crp[i + 3]},
	                        {x: +crp[i + 4], y: +crp[i + 5]}
	                    ];
	            if (z) {
	                if (!i) {
	                    p[0] = {x: +crp[iLen - 2], y: +crp[iLen - 1]};
	                } else if (iLen - 4 == i) {
	                    p[3] = {x: +crp[0], y: +crp[1]};
	                } else if (iLen - 2 == i) {
	                    p[2] = {x: +crp[0], y: +crp[1]};
	                    p[3] = {x: +crp[2], y: +crp[3]};
	                }
	            } else {
	                if (iLen - 4 == i) {
	                    p[3] = p[2];
	                } else if (!i) {
	                    p[0] = {x: +crp[i], y: +crp[i + 1]};
	                }
	            }
	            d.push(["C",
	                  (-p[0].x + 6 * p[1].x + p[2].x) / 6,
	                  (-p[0].y + 6 * p[1].y + p[2].y) / 6,
	                  (p[1].x + 6 * p[2].x - p[3].x) / 6,
	                  (p[1].y + 6*p[2].y - p[3].y) / 6,
	                  p[2].x,
	                  p[2].y
	            ]);
	        }
	
	        return d;
	    }
	
	    // export
	    Snap.path = paths;
	
	    /*\
	     * Snap.path.getTotalLength
	     [ method ]
	     **
	     * Returns the length of the given path in pixels
	     **
	     - path (string) SVG path string
	     **
	     = (number) length
	    \*/
	    Snap.path.getTotalLength = getTotalLength;
	    /*\
	     * Snap.path.getPointAtLength
	     [ method ]
	     **
	     * Returns the coordinates of the point located at the given length along the given path
	     **
	     - path (string) SVG path string
	     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
	     **
	     = (object) representation of the point:
	     o {
	     o     x: (number) x coordinate,
	     o     y: (number) y coordinate,
	     o     alpha: (number) angle of derivative
	     o }
	    \*/
	    Snap.path.getPointAtLength = getPointAtLength;
	    /*\
	     * Snap.path.getSubpath
	     [ method ]
	     **
	     * Returns the subpath of a given path between given start and end lengths
	     **
	     - path (string) SVG path string
	     - from (number) length, in pixels, from the start of the path to the start of the segment
	     - to (number) length, in pixels, from the start of the path to the end of the segment
	     **
	     = (string) path string definition for the segment
	    \*/
	    Snap.path.getSubpath = function (path, from, to) {
	        if (this.getTotalLength(path) - to < 1e-6) {
	            return getSubpathsAtLength(path, from).end;
	        }
	        var a = getSubpathsAtLength(path, to, 1);
	        return from ? getSubpathsAtLength(a, from).end : a;
	    };
	    /*\
	     * Element.getTotalLength
	     [ method ]
	     **
	     * Returns the length of the path in pixels (only works for `path` elements)
	     = (number) length
	    \*/
	    elproto.getTotalLength = function () {
	        if (this.node.getTotalLength) {
	            return this.node.getTotalLength();
	        }
	    };
	    // SIERRA Element.getPointAtLength()/Element.getTotalLength(): If a <path> is broken into different segments, is the jump distance to the new coordinates set by the _M_ or _m_ commands calculated as part of the path's total length?
	    /*\
	     * Element.getPointAtLength
	     [ method ]
	     **
	     * Returns coordinates of the point located at the given length on the given path (only works for `path` elements)
	     **
	     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
	     **
	     = (object) representation of the point:
	     o {
	     o     x: (number) x coordinate,
	     o     y: (number) y coordinate,
	     o     alpha: (number) angle of derivative
	     o }
	    \*/
	    elproto.getPointAtLength = function (length) {
	        return getPointAtLength(this.attr("d"), length);
	    };
	    // SIERRA Element.getSubpath(): Similar to the problem for Element.getPointAtLength(). Unclear how this would work for a segmented path. Overall, the concept of _subpath_ and what I'm calling a _segment_ (series of non-_M_ or _Z_ commands) is unclear.
	    /*\
	     * Element.getSubpath
	     [ method ]
	     **
	     * Returns subpath of a given element from given start and end lengths (only works for `path` elements)
	     **
	     - from (number) length, in pixels, from the start of the path to the start of the segment
	     - to (number) length, in pixels, from the start of the path to the end of the segment
	     **
	     = (string) path string definition for the segment
	    \*/
	    elproto.getSubpath = function (from, to) {
	        return Snap.path.getSubpath(this.attr("d"), from, to);
	    };
	    Snap._.box = box;
	    /*\
	     * Snap.path.findDotsAtSegment
	     [ method ]
	     **
	     * Utility method
	     **
	     * Finds dot coordinates on the given cubic beziér curve at the given t
	     - p1x (number) x of the first point of the curve
	     - p1y (number) y of the first point of the curve
	     - c1x (number) x of the first anchor of the curve
	     - c1y (number) y of the first anchor of the curve
	     - c2x (number) x of the second anchor of the curve
	     - c2y (number) y of the second anchor of the curve
	     - p2x (number) x of the second point of the curve
	     - p2y (number) y of the second point of the curve
	     - t (number) position on the curve (0..1)
	     = (object) point information in format:
	     o {
	     o     x: (number) x coordinate of the point,
	     o     y: (number) y coordinate of the point,
	     o     m: {
	     o         x: (number) x coordinate of the left anchor,
	     o         y: (number) y coordinate of the left anchor
	     o     },
	     o     n: {
	     o         x: (number) x coordinate of the right anchor,
	     o         y: (number) y coordinate of the right anchor
	     o     },
	     o     start: {
	     o         x: (number) x coordinate of the start of the curve,
	     o         y: (number) y coordinate of the start of the curve
	     o     },
	     o     end: {
	     o         x: (number) x coordinate of the end of the curve,
	     o         y: (number) y coordinate of the end of the curve
	     o     },
	     o     alpha: (number) angle of the curve derivative at the point
	     o }
	    \*/
	    Snap.path.findDotsAtSegment = findDotsAtSegment;
	    /*\
	     * Snap.path.bezierBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns the bounding box of a given cubic beziér curve
	     - p1x (number) x of the first point of the curve
	     - p1y (number) y of the first point of the curve
	     - c1x (number) x of the first anchor of the curve
	     - c1y (number) y of the first anchor of the curve
	     - c2x (number) x of the second anchor of the curve
	     - c2y (number) y of the second anchor of the curve
	     - p2x (number) x of the second point of the curve
	     - p2y (number) y of the second point of the curve
	     * or
	     - bez (array) array of six points for beziér curve
	     = (object) bounding box
	     o {
	     o     x: (number) x coordinate of the left top point of the box,
	     o     y: (number) y coordinate of the left top point of the box,
	     o     x2: (number) x coordinate of the right bottom point of the box,
	     o     y2: (number) y coordinate of the right bottom point of the box,
	     o     width: (number) width of the box,
	     o     height: (number) height of the box
	     o }
	    \*/
	    Snap.path.bezierBBox = bezierBBox;
	    /*\
	     * Snap.path.isPointInsideBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if given point is inside bounding box
	     - bbox (string) bounding box
	     - x (string) x coordinate of the point
	     - y (string) y coordinate of the point
	     = (boolean) `true` if point is inside
	    \*/
	    Snap.path.isPointInsideBBox = isPointInsideBBox;
	    Snap.closest = function (x, y, X, Y) {
	        var r = 100,
	            b = box(x - r / 2, y - r / 2, r, r),
	            inside = [],
	            getter = X[0].hasOwnProperty("x") ? function (i) {
	                return {
	                    x: X[i].x,
	                    y: X[i].y
	                };
	            } : function (i) {
	                return {
	                    x: X[i],
	                    y: Y[i]
	                };
	            },
	            found = 0;
	        while (r <= 1e6 && !found) {
	            for (var i = 0, ii = X.length; i < ii; i++) {
	                var xy = getter(i);
	                if (isPointInsideBBox(b, xy.x, xy.y)) {
	                    found++;
	                    inside.push(xy);
	                    break;
	                }
	            }
	            if (!found) {
	                r *= 2;
	                b = box(x - r / 2, y - r / 2, r, r)
	            }
	        }
	        if (r == 1e6) {
	            return;
	        }
	        var len = Infinity,
	            res;
	        for (i = 0, ii = inside.length; i < ii; i++) {
	            var l = Snap.len(x, y, inside[i].x, inside[i].y);
	            if (len > l) {
	                len = l;
	                inside[i].len = l;
	                res = inside[i];
	            }
	        }
	        return res;
	    };
	    /*\
	     * Snap.path.isBBoxIntersect
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if two bounding boxes intersect
	     - bbox1 (string) first bounding box
	     - bbox2 (string) second bounding box
	     = (boolean) `true` if bounding boxes intersect
	    \*/
	    Snap.path.isBBoxIntersect = isBBoxIntersect;
	    /*\
	     * Snap.path.intersection
	     [ method ]
	     **
	     * Utility method
	     **
	     * Finds intersections of two paths
	     - path1 (string) path string
	     - path2 (string) path string
	     = (array) dots of intersection
	     o [
	     o     {
	     o         x: (number) x coordinate of the point,
	     o         y: (number) y coordinate of the point,
	     o         t1: (number) t value for segment of path1,
	     o         t2: (number) t value for segment of path2,
	     o         segment1: (number) order number for segment of path1,
	     o         segment2: (number) order number for segment of path2,
	     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1,
	     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
	     o     }
	     o ]
	    \*/
	    Snap.path.intersection = pathIntersection;
	    Snap.path.intersectionNumber = pathIntersectionNumber;
	    /*\
	     * Snap.path.isPointInside
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if given point is inside a given closed path.
	     *
	     * Note: fill mode doesn’t affect the result of this method.
	     - path (string) path string
	     - x (number) x of the point
	     - y (number) y of the point
	     = (boolean) `true` if point is inside the path
	    \*/
	    Snap.path.isPointInside = isPointInsidePath;
	    /*\
	     * Snap.path.getBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns the bounding box of a given path
	     - path (string) path string
	     = (object) bounding box
	     o {
	     o     x: (number) x coordinate of the left top point of the box,
	     o     y: (number) y coordinate of the left top point of the box,
	     o     x2: (number) x coordinate of the right bottom point of the box,
	     o     y2: (number) y coordinate of the right bottom point of the box,
	     o     width: (number) width of the box,
	     o     height: (number) height of the box
	     o }
	    \*/
	    Snap.path.getBBox = pathBBox;
	    Snap.path.get = getPath;
	    /*\
	     * Snap.path.toRelative
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path coordinates into relative values
	     - path (string) path string
	     = (array) path string
	    \*/
	    Snap.path.toRelative = pathToRelative;
	    /*\
	     * Snap.path.toAbsolute
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path coordinates into absolute values
	     - path (string) path string
	     = (array) path string
	    \*/
	    Snap.path.toAbsolute = pathToAbsolute;
	    /*\
	     * Snap.path.toCubic
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path to a new path where all segments are cubic beziér curves
	     - pathString (string|array) path string or array of segments
	     = (array) array of segments
	    \*/
	    Snap.path.toCubic = path2curve;
	    /*\
	     * Snap.path.map
	     [ method ]
	     **
	     * Transform the path string with the given matrix
	     - path (string) path string
	     - matrix (object) see @Matrix
	     = (string) transformed path string
	    \*/
	    Snap.path.map = mapPath;
	    Snap.path.toString = toString;
	    Snap.path.clone = pathClone;
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var mmax = Math.max,
	        mmin = Math.min;
	
	    // Set
	    var Set = function (items) {
	        this.items = [];
		this.bindings = {};
	        this.length = 0;
	        this.type = "set";
	        if (items) {
	            for (var i = 0, ii = items.length; i < ii; i++) {
	                if (items[i]) {
	                    this[this.items.length] = this.items[this.items.length] = items[i];
	                    this.length++;
	                }
	            }
	        }
	    },
	    setproto = Set.prototype;
	    /*\
	     * Set.push
	     [ method ]
	     **
	     * Adds each argument to the current set
	     = (object) original element
	    \*/
	    setproto.push = function () {
	        var item,
	            len;
	        for (var i = 0, ii = arguments.length; i < ii; i++) {
	            item = arguments[i];
	            if (item) {
	                len = this.items.length;
	                this[len] = this.items[len] = item;
	                this.length++;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Set.pop
	     [ method ]
	     **
	     * Removes last element and returns it
	     = (object) element
	    \*/
	    setproto.pop = function () {
	        this.length && delete this[this.length--];
	        return this.items.pop();
	    };
	    /*\
	     * Set.forEach
	     [ method ]
	     **
	     * Executes given function for each element in the set
	     *
	     * If the function returns `false`, the loop stops running.
	     **
	     - callback (function) function to run
	     - thisArg (object) context object for the callback
	     = (object) Set object
	    \*/
	    setproto.forEach = function (callback, thisArg) {
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            if (callback.call(thisArg, this.items[i], i) === false) {
	                return this;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Set.animate
	     [ method ]
	     **
	     * Animates each element in set in sync.
	     *
	     **
	     - attrs (object) key-value pairs of destination attributes
	     - duration (number) duration of the animation in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function that executes when the animation ends
	     * or
	     - animation (array) array of animation parameter for each element in set in format `[attrs, duration, easing, callback]`
	     > Usage
	     | // animate all elements in set to radius 10
	     | set.animate({r: 10}, 500, mina.easein);
	     | // or
	     | // animate first element to radius 10, but second to radius 20 and in different time
	     | set.animate([{r: 10}, 500, mina.easein], [{r: 20}, 1500, mina.easein]);
	     = (Element) the current element
	    \*/
	    setproto.animate = function (attrs, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        if (attrs instanceof Snap._.Animation) {
	            callback = attrs.callback;
	            easing = attrs.easing;
	            ms = easing.dur;
	            attrs = attrs.attr;
	        }
	        var args = arguments;
	        if (Snap.is(attrs, "array") && Snap.is(args[args.length - 1], "array")) {
	            var each = true;
	        }
	        var begin,
	            handler = function () {
	                if (begin) {
	                    this.b = begin;
	                } else {
	                    begin = this.b;
	                }
	            },
	            cb = 0,
	            set = this,
	            callbacker = callback && function () {
	                if (++cb == set.length) {
	                    callback.call(this);
	                }
	            };
	        return this.forEach(function (el, i) {
	            eve.once("snap.animcreated." + el.id, handler);
	            if (each) {
	                args[i] && el.animate.apply(el, args[i]);
	            } else {
	                el.animate(attrs, ms, easing, callbacker);
	            }
	        });
	    };
	    /*\
	     * Set.remove
	     [ method ]
	     **
	     * Removes all children of the set.
	     *
	     = (object) Set object
	    \*/
	    setproto.remove = function () {
	        while (this.length) {
	            this.pop().remove();
	        }
	        return this;
	    };
	    /*\
	     * Set.bind
	     [ method ]
	     **
	     * Specifies how to handle a specific attribute when applied
	     * to a set.
	     *
	     **
	     - attr (string) attribute name
	     - callback (function) function to run
	     * or
	     - attr (string) attribute name
	     - element (Element) specific element in the set to apply the attribute to
	     * or
	     - attr (string) attribute name
	     - element (Element) specific element in the set to apply the attribute to
	     - eattr (string) attribute on the element to bind the attribute to
	     = (object) Set object
	    \*/
	    setproto.bind = function (attr, a, b) {
	        var data = {};
	        if (typeof a == "function") {
	            this.bindings[attr] = a;
	        } else {
	            var aname = b || attr;
	            this.bindings[attr] = function (v) {
	                data[aname] = v;
	                a.attr(data);
	            };
	        }
	        return this;
	    };
	    /*\
	     * Set.attr
	     [ method ]
	     **
	     * Equivalent of @Element.attr.
	     = (object) Set object
	    \*/
	    setproto.attr = function (value) {
	        var unbound = {};
	        for (var k in value) {
	            if (this.bindings[k]) {
	                this.bindings[k](value[k]);
	            } else {
	                unbound[k] = value[k];
	            }
	        }
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            this.items[i].attr(unbound);
	        }
	        return this;
	    };
	    /*\
	     * Set.clear
	     [ method ]
	     **
	     * Removes all elements from the set
	    \*/
	    setproto.clear = function () {
	        while (this.length) {
	            this.pop();
	        }
	    };
	    /*\
	     * Set.splice
	     [ method ]
	     **
	     * Removes range of elements from the set
	     **
	     - index (number) position of the deletion
	     - count (number) number of element to remove
	     - insertion… (object) #optional elements to insert
	     = (object) set elements that were deleted
	    \*/
	    setproto.splice = function (index, count, insertion) {
	        index = index < 0 ? mmax(this.length + index, 0) : index;
	        count = mmax(0, mmin(this.length - index, count));
	        var tail = [],
	            todel = [],
	            args = [],
	            i;
	        for (i = 2; i < arguments.length; i++) {
	            args.push(arguments[i]);
	        }
	        for (i = 0; i < count; i++) {
	            todel.push(this[index + i]);
	        }
	        for (; i < this.length - index; i++) {
	            tail.push(this[index + i]);
	        }
	        var arglen = args.length;
	        for (i = 0; i < arglen + tail.length; i++) {
	            this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
	        }
	        i = this.items.length = this.length -= count - arglen;
	        while (this[i]) {
	            delete this[i++];
	        }
	        return new Set(todel);
	    };
	    /*\
	     * Set.exclude
	     [ method ]
	     **
	     * Removes given element from the set
	     **
	     - element (object) element to remove
	     = (boolean) `true` if object was found and removed from the set
	    \*/
	    setproto.exclude = function (el) {
	        for (var i = 0, ii = this.length; i < ii; i++) if (this[i] == el) {
	            this.splice(i, 1);
	            return true;
	        }
	        return false;
	    };
	    /*\
	     * Set.insertAfter
	     [ method ]
	     **
	     * Inserts set elements after given element.
	     **
	     - element (object) set will be inserted after this element
	     = (object) Set object
	    \*/
	    setproto.insertAfter = function (el) {
	        var i = this.items.length;
	        while (i--) {
	            this.items[i].insertAfter(el);
	        }
	        return this;
	    };
	    /*\
	     * Set.getBBox
	     [ method ]
	     **
	     * Union of all bboxes of the set. See @Element.getBBox.
	     = (object) bounding box descriptor. See @Element.getBBox.
	    \*/
	    setproto.getBBox = function () {
	        var x = [],
	            y = [],
	            x2 = [],
	            y2 = [];
	        for (var i = this.items.length; i--;) if (!this.items[i].removed) {
	            var box = this.items[i].getBBox();
	            x.push(box.x);
	            y.push(box.y);
	            x2.push(box.x + box.width);
	            y2.push(box.y + box.height);
	        }
	        x = mmin.apply(0, x);
	        y = mmin.apply(0, y);
	        x2 = mmax.apply(0, x2);
	        y2 = mmax.apply(0, y2);
	        return {
	            x: x,
	            y: y,
	            x2: x2,
	            y2: y2,
	            width: x2 - x,
	            height: y2 - y,
	            cx: x + (x2 - x) / 2,
	            cy: y + (y2 - y) / 2
	        };
	    };
	    /*\
	     * Set.insertAfter
	     [ method ]
	     **
	     * Creates a clone of the set.
	     **
	     = (object) New Set object
	    \*/
	    setproto.clone = function (s) {
	        s = new Set;
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            s.push(this.items[i].clone());
	        }
	        return s;
	    };
	    setproto.toString = function () {
	        return "Snap\u2018s set";
	    };
	    setproto.type = "set";
	    // export
	    /*\
	     * Snap.Set
	     [ property ]
	     **
	     * Set constructor.
	    \*/
	    Snap.Set = Set;
	    /*\
	     * Snap.set
	     [ method ]
	     **
	     * Creates a set and fills it with list of arguments.
	     **
	     = (object) New Set object
	     | var r = paper.rect(0, 0, 10, 10),
	     |     s1 = Snap.set(), // empty set
	     |     s2 = Snap.set(r, paper.circle(100, 100, 20)); // prefilled set
	    \*/
	    Snap.set = function () {
	        var set = new Set;
	        if (arguments.length) {
	            set.push.apply(set, Array.prototype.slice.call(arguments, 0));
	        }
	        return set;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var names = {},
	        reUnit = /[%a-z]+$/i,
	        Str = String;
	    names.stroke = names.fill = "colour";
	    function getEmpty(item) {
	        var l = item[0];
	        switch (l.toLowerCase()) {
	            case "t": return [l, 0, 0];
	            case "m": return [l, 1, 0, 0, 1, 0, 0];
	            case "r": if (item.length == 4) {
	                return [l, 0, item[2], item[3]];
	            } else {
	                return [l, 0];
	            }
	            case "s": if (item.length == 5) {
	                return [l, 1, 1, item[3], item[4]];
	            } else if (item.length == 3) {
	                return [l, 1, 1];
	            } else {
	                return [l, 1];
	            }
	        }
	    }
	    function equaliseTransform(t1, t2, getBBox) {
	        t1 = t1 || new Snap.Matrix;
	        t2 = t2 || new Snap.Matrix;
	        t1 = Snap.parseTransformString(t1.toTransformString()) || [];
	        t2 = Snap.parseTransformString(t2.toTransformString()) || [];
	        var maxlength = Math.max(t1.length, t2.length),
	            from = [],
	            to = [],
	            i = 0, j, jj,
	            tt1, tt2;
	        for (; i < maxlength; i++) {
	            tt1 = t1[i] || getEmpty(t2[i]);
	            tt2 = t2[i] || getEmpty(tt1);
	            if (tt1[0] != tt2[0] ||
	                tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3]) ||
	                tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4])
	                ) {
	                    t1 = Snap._.transform2matrix(t1, getBBox());
	                    t2 = Snap._.transform2matrix(t2, getBBox());
	                    from = [["m", t1.a, t1.b, t1.c, t1.d, t1.e, t1.f]];
	                    to = [["m", t2.a, t2.b, t2.c, t2.d, t2.e, t2.f]];
	                    break;
	            }
	            from[i] = [];
	            to[i] = [];
	            for (j = 0, jj = Math.max(tt1.length, tt2.length); j < jj; j++) {
	                j in tt1 && (from[i][j] = tt1[j]);
	                j in tt2 && (to[i][j] = tt2[j]);
	            }
	        }
	        return {
	            from: path2array(from),
	            to: path2array(to),
	            f: getPath(from)
	        };
	    }
	    function getNumber(val) {
	        return val;
	    }
	    function getUnit(unit) {
	        return function (val) {
	            return +val.toFixed(3) + unit;
	        };
	    }
	    function getViewBox(val) {
	        return val.join(" ");
	    }
	    function getColour(clr) {
	        return Snap.rgb(clr[0], clr[1], clr[2], clr[3]);
	    }
	    function getPath(path) {
	        var k = 0, i, ii, j, jj, out, a, b = [];
	        for (i = 0, ii = path.length; i < ii; i++) {
	            out = "[";
	            a = ['"' + path[i][0] + '"'];
	            for (j = 1, jj = path[i].length; j < jj; j++) {
	                a[j] = "val[" + k++ + "]";
	            }
	            out += a + "]";
	            b[i] = out;
	        }
	        return Function("val", "return Snap.path.toString.call([" + b + "])");
	    }
	    function path2array(path) {
	        var out = [];
	        for (var i = 0, ii = path.length; i < ii; i++) {
	            for (var j = 1, jj = path[i].length; j < jj; j++) {
	                out.push(path[i][j]);
	            }
	        }
	        return out;
	    }
	    function isNumeric(obj) {
	        return isFinite(obj);
	    }
	    function arrayEqual(arr1, arr2) {
	        if (!Snap.is(arr1, "array") || !Snap.is(arr2, "array")) {
	            return false;
	        }
	        return arr1.toString() == arr2.toString();
	    }
	    Element.prototype.equal = function (name, b) {
	        return eve("snap.util.equal", this, name, b).firstDefined();
	    };
	    eve.on("snap.util.equal", function (name, b) {
	        var A, B, a = Str(this.attr(name) || ""),
	            el = this;
	        if (names[name] == "colour") {
	            A = Snap.color(a);
	            B = Snap.color(b);
	            return {
	                from: [A.r, A.g, A.b, A.opacity],
	                to: [B.r, B.g, B.b, B.opacity],
	                f: getColour
	            };
	        }
	        if (name == "viewBox") {
	            A = this.attr(name).vb.split(" ").map(Number);
	            B = b.split(" ").map(Number);
	            return {
	                from: A,
	                to: B,
	                f: getViewBox
	            };
	        }
	        if (name == "transform" || name == "gradientTransform" || name == "patternTransform") {
	            if (typeof b == "string") {
	                b = Str(b).replace(/\.{3}|\u2026/g, a);
	            }
	            a = this.matrix;
	            if (!Snap._.rgTransform.test(b)) {
	                b = Snap._.transform2matrix(Snap._.svgTransform2string(b), this.getBBox());
	            } else {
	                b = Snap._.transform2matrix(b, this.getBBox());
	            }
	            return equaliseTransform(a, b, function () {
	                return el.getBBox(1);
	            });
	        }
	        if (name == "d" || name == "path") {
	            A = Snap.path.toCubic(a, b);
	            return {
	                from: path2array(A[0]),
	                to: path2array(A[1]),
	                f: getPath(A[0])
	            };
	        }
	        if (name == "points") {
	            A = Str(a).split(Snap._.separator);
	            B = Str(b).split(Snap._.separator);
	            return {
	                from: A,
	                to: B,
	                f: function (val) { return val; }
	            };
	        }
	        if (isNumeric(a) && isNumeric(b)) {
	            return {
	                from: parseFloat(a),
	                to: parseFloat(b),
	                f: getNumber
	            };
	        }
	        var aUnit = a.match(reUnit),
	            bUnit = Str(b).match(reUnit);
	        if (aUnit && arrayEqual(aUnit, bUnit)) {
	            return {
	                from: parseFloat(a),
	                to: parseFloat(b),
	                f: getUnit(aUnit)
	            };
	        } else {
	            return {
	                from: this.asPX(name),
	                to: this.asPX(name, b),
	                f: getNumber
	            };
	        }
	    });
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	// 
	// http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	    has = "hasOwnProperty",
	    supportsTouch = "createTouch" in glob.doc,
	    events = [
	        "click", "dblclick", "mousedown", "mousemove", "mouseout",
	        "mouseover", "mouseup", "touchstart", "touchmove", "touchend",
	        "touchcancel"
	    ],
	    touchMap = {
	        mousedown: "touchstart",
	        mousemove: "touchmove",
	        mouseup: "touchend"
	    },
	    getScroll = function (xy, el) {
	        var name = xy == "y" ? "scrollTop" : "scrollLeft",
	            doc = el && el.node ? el.node.ownerDocument : glob.doc;
	        return doc[name in doc.documentElement ? "documentElement" : "body"][name];
	    },
	    preventDefault = function () {
	        this.returnValue = false;
	    },
	    preventTouch = function () {
	        return this.originalEvent.preventDefault();
	    },
	    stopPropagation = function () {
	        this.cancelBubble = true;
	    },
	    stopTouch = function () {
	        return this.originalEvent.stopPropagation();
	    },
	    addEvent = function (obj, type, fn, element) {
	        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type,
	            f = function (e) {
	                var scrollY = getScroll("y", element),
	                    scrollX = getScroll("x", element);
	                if (supportsTouch && touchMap[has](type)) {
	                    for (var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++) {
	                        if (e.targetTouches[i].target == obj || obj.contains(e.targetTouches[i].target)) {
	                            var olde = e;
	                            e = e.targetTouches[i];
	                            e.originalEvent = olde;
	                            e.preventDefault = preventTouch;
	                            e.stopPropagation = stopTouch;
	                            break;
	                        }
	                    }
	                }
	                var x = e.clientX + scrollX,
	                    y = e.clientY + scrollY;
	                return fn.call(element, e, x, y);
	            };
	
	        if (type !== realName) {
	            obj.addEventListener(type, f, false);
	        }
	
	        obj.addEventListener(realName, f, false);
	
	        return function () {
	            if (type !== realName) {
	                obj.removeEventListener(type, f, false);
	            }
	
	            obj.removeEventListener(realName, f, false);
	            return true;
	        };
	    },
	    drag = [],
	    dragMove = function (e) {
	        var x = e.clientX,
	            y = e.clientY,
	            scrollY = getScroll("y"),
	            scrollX = getScroll("x"),
	            dragi,
	            j = drag.length;
	        while (j--) {
	            dragi = drag[j];
	            if (supportsTouch) {
	                var i = e.touches && e.touches.length,
	                    touch;
	                while (i--) {
	                    touch = e.touches[i];
	                    if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
	                        x = touch.clientX;
	                        y = touch.clientY;
	                        (e.originalEvent ? e.originalEvent : e).preventDefault();
	                        break;
	                    }
	                }
	            } else {
	                e.preventDefault();
	            }
	            var node = dragi.el.node,
	                o,
	                next = node.nextSibling,
	                parent = node.parentNode,
	                display = node.style.display;
	            // glob.win.opera && parent.removeChild(node);
	            // node.style.display = "none";
	            // o = dragi.el.paper.getElementByPoint(x, y);
	            // node.style.display = display;
	            // glob.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
	            // o && eve("snap.drag.over." + dragi.el.id, dragi.el, o);
	            x += scrollX;
	            y += scrollY;
	            eve("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
	        }
	    },
	    dragUp = function (e) {
	        Snap.unmousemove(dragMove).unmouseup(dragUp);
	        var i = drag.length,
	            dragi;
	        while (i--) {
	            dragi = drag[i];
	            dragi.el._drag = {};
	            eve("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
	            eve.off("snap.drag.*." + dragi.el.id);
	        }
	        drag = [];
	    };
	    /*\
	     * Element.click
	     [ method ]
	     **
	     * Adds a click event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unclick
	     [ method ]
	     **
	     * Removes a click event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.dblclick
	     [ method ]
	     **
	     * Adds a double click event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.undblclick
	     [ method ]
	     **
	     * Removes a double click event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mousedown
	     [ method ]
	     **
	     * Adds a mousedown event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmousedown
	     [ method ]
	     **
	     * Removes a mousedown event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mousemove
	     [ method ]
	     **
	     * Adds a mousemove event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmousemove
	     [ method ]
	     **
	     * Removes a mousemove event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseout
	     [ method ]
	     **
	     * Adds a mouseout event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseout
	     [ method ]
	     **
	     * Removes a mouseout event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseover
	     [ method ]
	     **
	     * Adds a mouseover event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseover
	     [ method ]
	     **
	     * Removes a mouseover event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseup
	     [ method ]
	     **
	     * Adds a mouseup event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseup
	     [ method ]
	     **
	     * Removes a mouseup event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchstart
	     [ method ]
	     **
	     * Adds a touchstart event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchstart
	     [ method ]
	     **
	     * Removes a touchstart event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchmove
	     [ method ]
	     **
	     * Adds a touchmove event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchmove
	     [ method ]
	     **
	     * Removes a touchmove event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchend
	     [ method ]
	     **
	     * Adds a touchend event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchend
	     [ method ]
	     **
	     * Removes a touchend event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchcancel
	     [ method ]
	     **
	     * Adds a touchcancel event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchcancel
	     [ method ]
	     **
	     * Removes a touchcancel event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    for (var i = events.length; i--;) {
	        (function (eventName) {
	            Snap[eventName] = elproto[eventName] = function (fn, scope) {
	                if (Snap.is(fn, "function")) {
	                    this.events = this.events || [];
	                    this.events.push({
	                        name: eventName,
	                        f: fn,
	                        unbind: addEvent(this.node || document, eventName, fn, scope || this)
	                    });
	                } else {
	                    for (var i = 0, ii = this.events.length; i < ii; i++) if (this.events[i].name == eventName) {
	                        try {
	                            this.events[i].f.call(this);
	                        } catch (e) {}
	                    }
	                }
	                return this;
	            };
	            Snap["un" + eventName] =
	            elproto["un" + eventName] = function (fn) {
	                var events = this.events || [],
	                    l = events.length;
	                while (l--) if (events[l].name == eventName &&
	                               (events[l].f == fn || !fn)) {
	                    events[l].unbind();
	                    events.splice(l, 1);
	                    !events.length && delete this.events;
	                    return this;
	                }
	                return this;
	            };
	        })(events[i]);
	    }
	    /*\
	     * Element.hover
	     [ method ]
	     **
	     * Adds hover event handlers to the element
	     - f_in (function) handler for hover in
	     - f_out (function) handler for hover out
	     - icontext (object) #optional context for hover in handler
	     - ocontext (object) #optional context for hover out handler
	     = (object) @Element
	    \*/
	    elproto.hover = function (f_in, f_out, scope_in, scope_out) {
	        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
	    };
	    /*\
	     * Element.unhover
	     [ method ]
	     **
	     * Removes hover event handlers from the element
	     - f_in (function) handler for hover in
	     - f_out (function) handler for hover out
	     = (object) @Element
	    \*/
	    elproto.unhover = function (f_in, f_out) {
	        return this.unmouseover(f_in).unmouseout(f_out);
	    };
	    var draggable = [];
	    // SIERRA unclear what _context_ refers to for starting, ending, moving the drag gesture.
	    // SIERRA Element.drag(): _x position of the mouse_: Where are the x/y values offset from?
	    // SIERRA Element.drag(): much of this member's doc appears to be duplicated for some reason.
	    // SIERRA Unclear about this sentence: _Additionally following drag events will be triggered: drag.start.<id> on start, drag.end.<id> on end and drag.move.<id> on every move._ Is there a global _drag_ object to which you can assign handlers keyed by an element's ID?
	    /*\
	     * Element.drag
	     [ method ]
	     **
	     * Adds event handlers for an element's drag gesture
	     **
	     - onmove (function) handler for moving
	     - onstart (function) handler for drag start
	     - onend (function) handler for drag end
	     - mcontext (object) #optional context for moving handler
	     - scontext (object) #optional context for drag start handler
	     - econtext (object) #optional context for drag end handler
	     * Additionaly following `drag` events are triggered: `drag.start.<id>` on start, 
	     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element is dragged over another element 
	     * `drag.over.<id>` fires as well.
	     *
	     * Start event and start handler are called in specified context or in context of the element with following parameters:
	     o x (number) x position of the mouse
	     o y (number) y position of the mouse
	     o event (object) DOM event object
	     * Move event and move handler are called in specified context or in context of the element with following parameters:
	     o dx (number) shift by x from the start point
	     o dy (number) shift by y from the start point
	     o x (number) x position of the mouse
	     o y (number) y position of the mouse
	     o event (object) DOM event object
	     * End event and end handler are called in specified context or in context of the element with following parameters:
	     o event (object) DOM event object
	     = (object) @Element
	    \*/
	    elproto.drag = function (onmove, onstart, onend, move_scope, start_scope, end_scope) {
	        var el = this;
	        if (!arguments.length) {
	            var origTransform;
	            return el.drag(function (dx, dy) {
	                this.attr({
	                    transform: origTransform + (origTransform ? "T" : "t") + [dx, dy]
	                });
	            }, function () {
	                origTransform = this.transform().local;
	            });
	        }
	        function start(e, x, y) {
	            (e.originalEvent || e).preventDefault();
	            el._drag.x = x;
	            el._drag.y = y;
	            el._drag.id = e.identifier;
	            !drag.length && Snap.mousemove(dragMove).mouseup(dragUp);
	            drag.push({el: el, move_scope: move_scope, start_scope: start_scope, end_scope: end_scope});
	            onstart && eve.on("snap.drag.start." + el.id, onstart);
	            onmove && eve.on("snap.drag.move." + el.id, onmove);
	            onend && eve.on("snap.drag.end." + el.id, onend);
	            eve("snap.drag.start." + el.id, start_scope || move_scope || el, x, y, e);
	        }
	        function init(e, x, y) {
	            eve("snap.draginit." + el.id, el, e, x, y);
	        }
	        eve.on("snap.draginit." + el.id, start);
	        el._drag = {};
	        draggable.push({el: el, start: start, init: init});
	        el.mousedown(init);
	        return el;
	    };
	    /*
	     * Element.onDragOver
	     [ method ]
	     **
	     * Shortcut to assign event handler for `drag.over.<id>` event, where `id` is the element's `id` (see @Element.id)
	     - f (function) handler for event, first argument would be the element you are dragging over
	    \*/
	    // elproto.onDragOver = function (f) {
	    //     f ? eve.on("snap.drag.over." + this.id, f) : eve.unbind("snap.drag.over." + this.id);
	    // };
	    /*\
	     * Element.undrag
	     [ method ]
	     **
	     * Removes all drag event handlers from the given element
	    \*/
	    elproto.undrag = function () {
	        var i = draggable.length;
	        while (i--) if (draggable[i].el == this) {
	            this.unmousedown(draggable[i].init);
	            draggable.splice(i, 1);
	            eve.unbind("snap.drag.*." + this.id);
	            eve.unbind("snap.draginit." + this.id);
	        }
	        !draggable.length && Snap.unmousemove(dragMove).unmouseup(dragUp);
	        return this;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	        pproto = Paper.prototype,
	        rgurl = /^\s*url\((.+)\)/,
	        Str = String,
	        $ = Snap._.$;
	    Snap.filter = {};
	    /*\
	     * Paper.filter
	     [ method ]
	     **
	     * Creates a `<filter>` element
	     **
	     - filstr (string) SVG fragment of filter provided as a string
	     = (object) @Element
	     * Note: It is recommended to use filters embedded into the page inside an empty SVG element.
	     > Usage
	     | var f = paper.filter('<feGaussianBlur stdDeviation="2"/>'),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    pproto.filter = function (filstr) {
	        var paper = this;
	        if (paper.type != "svg") {
	            paper = paper.paper;
	        }
	        var f = Snap.parse(Str(filstr)),
	            id = Snap._.id(),
	            width = paper.node.offsetWidth,
	            height = paper.node.offsetHeight,
	            filter = $("filter");
	        $(filter, {
	            id: id,
	            filterUnits: "userSpaceOnUse"
	        });
	        filter.appendChild(f.node);
	        paper.defs.appendChild(filter);
	        return new Element(filter);
	    };
	
	    eve.on("snap.util.getattr.filter", function () {
	        eve.stop();
	        var p = $(this.node, "filter");
	        if (p) {
	            var match = Str(p).match(rgurl);
	            return match && Snap.select(match[1]);
	        }
	    });
	    eve.on("snap.util.attr.filter", function (value) {
	        if (value instanceof Element && value.type == "filter") {
	            eve.stop();
	            var id = value.node.id;
	            if (!id) {
	                $(value.node, {id: value.id});
	                id = value.id;
	            }
	            $(this.node, {
	                filter: Snap.url(id)
	            });
	        }
	        if (!value || value == "none") {
	            eve.stop();
	            this.node.removeAttribute("filter");
	        }
	    });
	    /*\
	     * Snap.filter.blur
	     [ method ]
	     **
	     * Returns an SVG markup string for the blur filter
	     **
	     - x (number) amount of horizontal blur, in pixels
	     - y (number) #optional amount of vertical blur, in pixels
	     = (string) filter representation
	     > Usage
	     | var f = paper.filter(Snap.filter.blur(5, 10)),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    Snap.filter.blur = function (x, y) {
	        if (x == null) {
	            x = 2;
	        }
	        var def = y == null ? x : [x, y];
	        return Snap.format('\<feGaussianBlur stdDeviation="{def}"/>', {
	            def: def
	        });
	    };
	    Snap.filter.blur.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.shadow
	     [ method ]
	     **
	     * Returns an SVG markup string for the shadow filter
	     **
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - blur (number) #optional amount of blur
	     - color (string) #optional color of the shadow
	     - opacity (number) #optional `0..1` opacity of the shadow
	     * or
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - color (string) #optional color of the shadow
	     - opacity (number) #optional `0..1` opacity of the shadow
	     * which makes blur default to `4`. Or
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - opacity (number) #optional `0..1` opacity of the shadow
	     = (string) filter representation
	     > Usage
	     | var f = paper.filter(Snap.filter.shadow(0, 2, .3)),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    Snap.filter.shadow = function (dx, dy, blur, color, opacity) {
	        if (opacity == null) {
	            if (color == null) {
	                opacity = blur;
	                blur = 4;
	                color = "#000";
	            } else {
	                opacity = color;
	                color = blur;
	                blur = 4;
	            }
	        }
	        if (blur == null) {
	            blur = 4;
	        }
	        if (opacity == null) {
	            opacity = 1;
	        }
	        if (dx == null) {
	            dx = 0;
	            dy = 2;
	        }
	        if (dy == null) {
	            dy = dx;
	        }
	        color = Snap.color(color);
	        return Snap.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
	            color: color,
	            dx: dx,
	            dy: dy,
	            blur: blur,
	            opacity: opacity
	        });
	    };
	    Snap.filter.shadow.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.grayscale
	     [ method ]
	     **
	     * Returns an SVG markup string for the grayscale filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.grayscale = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
	            a: 0.2126 + 0.7874 * (1 - amount),
	            b: 0.7152 - 0.7152 * (1 - amount),
	            c: 0.0722 - 0.0722 * (1 - amount),
	            d: 0.2126 - 0.2126 * (1 - amount),
	            e: 0.7152 + 0.2848 * (1 - amount),
	            f: 0.0722 - 0.0722 * (1 - amount),
	            g: 0.2126 - 0.2126 * (1 - amount),
	            h: 0.0722 + 0.9278 * (1 - amount)
	        });
	    };
	    Snap.filter.grayscale.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.sepia
	     [ method ]
	     **
	     * Returns an SVG markup string for the sepia filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.sepia = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
	            a: 0.393 + 0.607 * (1 - amount),
	            b: 0.769 - 0.769 * (1 - amount),
	            c: 0.189 - 0.189 * (1 - amount),
	            d: 0.349 - 0.349 * (1 - amount),
	            e: 0.686 + 0.314 * (1 - amount),
	            f: 0.168 - 0.168 * (1 - amount),
	            g: 0.272 - 0.272 * (1 - amount),
	            h: 0.534 - 0.534 * (1 - amount),
	            i: 0.131 + 0.869 * (1 - amount)
	        });
	    };
	    Snap.filter.sepia.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.saturate
	     [ method ]
	     **
	     * Returns an SVG markup string for the saturate filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.saturate = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="saturate" values="{amount}"/>', {
	            amount: 1 - amount
	        });
	    };
	    Snap.filter.saturate.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.hueRotate
	     [ method ]
	     **
	     * Returns an SVG markup string for the hue-rotate filter
	     **
	     - angle (number) angle of rotation
	     = (string) filter representation
	    \*/
	    Snap.filter.hueRotate = function (angle) {
	        angle = angle || 0;
	        return Snap.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
	            angle: angle
	        });
	    };
	    Snap.filter.hueRotate.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.invert
	     [ method ]
	     **
	     * Returns an SVG markup string for the invert filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.invert = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	//        <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB"/>
	        return Snap.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
	            amount: amount,
	            amount2: 1 - amount
	        });
	    };
	    Snap.filter.invert.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.brightness
	     [ method ]
	     **
	     * Returns an SVG markup string for the brightness filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.brightness = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
	            amount: amount
	        });
	    };
	    Snap.filter.brightness.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.contrast
	     [ method ]
	     **
	     * Returns an SVG markup string for the contrast filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.contrast = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
	            amount: amount,
	            amount2: .5 - amount / 2
	        });
	    };
	    Snap.filter.contrast.toString = function () {
	        return this();
	    };
	});
	
	// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var box = Snap._.box,
	        is = Snap.is,
	        firstLetter = /^[^a-z]*([tbmlrc])/i,
	        toString = function () {
	            return "T" + this.dx + "," + this.dy;
	        };
	    /*\
	     * Element.getAlign
	     [ method ]
	     **
	     * Returns shift needed to align the element relatively to given element.
	     * If no elements specified, parent `<svg>` container will be used.
	     - el (object) @optional alignment element
	     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
	     = (object|string) Object in format `{dx: , dy: }` also has a string representation as a transformation string
	     > Usage
	     | el.transform(el.getAlign(el2, "top"));
	     * or
	     | var dy = el.getAlign(el2, "top").dy;
	    \*/
	    Element.prototype.getAlign = function (el, way) {
	        if (way == null && is(el, "string")) {
	            way = el;
	            el = null;
	        }
	        el = el || this.paper;
	        var bx = el.getBBox ? el.getBBox() : box(el),
	            bb = this.getBBox(),
	            out = {};
	        way = way && way.match(firstLetter);
	        way = way ? way[1].toLowerCase() : "c";
	        switch (way) {
	            case "t":
	                out.dx = 0;
	                out.dy = bx.y - bb.y;
	            break;
	            case "b":
	                out.dx = 0;
	                out.dy = bx.y2 - bb.y2;
	            break;
	            case "m":
	                out.dx = 0;
	                out.dy = bx.cy - bb.cy;
	            break;
	            case "l":
	                out.dx = bx.x - bb.x;
	                out.dy = 0;
	            break;
	            case "r":
	                out.dx = bx.x2 - bb.x2;
	                out.dy = 0;
	            break;
	            default:
	                out.dx = bx.cx - bb.cx;
	                out.dy = 0;
	            break;
	        }
	        out.toString = toString;
	        return out;
	    };
	    /*\
	     * Element.align
	     [ method ]
	     **
	     * Aligns the element relatively to given one via transformation.
	     * If no elements specified, parent `<svg>` container will be used.
	     - el (object) @optional alignment element
	     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
	     = (object) this element
	     > Usage
	     | el.align(el2, "top");
	     * or
	     | el.align("middle");
	    \*/
	    Element.prototype.align = function (el, way) {
	        return this.transform("..." + this.getAlign(el, way));
	    };
	});
	
	// Copyright (c) 2016 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        Str = String,
	        has = "hasOwnProperty";
	    function slice(from, to, f) {
	        return function (arr) {
	            var res = arr.slice(from, to);
	            if (res.length == 1) {
	                res = res[0];
	            }
	            return f ? f(res) : res;
	        };
	    }
	    var Animation = function (attr, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        this.attr = attr;
	        this.dur = ms;
	        easing && (this.easing = easing);
	        callback && (this.callback = callback);
	    };
	    Snap._.Animation = Animation;
	    /*\
	     * Snap.animation
	     [ method ]
	     **
	     * Creates an animation object
	     **
	     - attr (object) attributes of final destination
	     - duration (number) duration of the animation, in milliseconds
	     - easing (function) #optional one of easing functions of @mina or custom one
	     - callback (function) #optional callback function that fires when animation ends
	     = (object) animation object
	    \*/
	    Snap.animation = function (attr, ms, easing, callback) {
	        return new Animation(attr, ms, easing, callback);
	    };
	    /*\
	     * Element.inAnim
	     [ method ]
	     **
	     * Returns a set of animations that may be able to manipulate the current element
	     **
	     = (object) in format:
	     o {
	     o     anim (object) animation object,
	     o     mina (object) @mina object,
	     o     curStatus (number) 0..1 — status of the animation: 0 — just started, 1 — just finished,
	     o     status (function) gets or sets the status of the animation,
	     o     stop (function) stops the animation
	     o }
	    \*/
	    elproto.inAnim = function () {
	        var el = this,
	            res = [];
	        for (var id in el.anims) if (el.anims[has](id)) {
	            (function (a) {
	                res.push({
	                    anim: new Animation(a._attrs, a.dur, a.easing, a._callback),
	                    mina: a,
	                    curStatus: a.status(),
	                    status: function (val) {
	                        return a.status(val);
	                    },
	                    stop: function () {
	                        a.stop();
	                    }
	                });
	            }(el.anims[id]));
	        }
	        return res;
	    };
	    /*\
	     * Snap.animate
	     [ method ]
	     **
	     * Runs generic animation of one number into another with a caring function
	     **
	     - from (number|array) number or array of numbers
	     - to (number|array) number or array of numbers
	     - setter (function) caring function that accepts one number argument
	     - duration (number) duration, in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function to execute when animation ends
	     = (object) animation object in @mina format
	     o {
	     o     id (string) animation id, consider it read-only,
	     o     duration (function) gets or sets the duration of the animation,
	     o     easing (function) easing,
	     o     speed (function) gets or sets the speed of the animation,
	     o     status (function) gets or sets the status of the animation,
	     o     stop (function) stops the animation
	     o }
	     | var rect = Snap().rect(0, 0, 10, 10);
	     | Snap.animate(0, 10, function (val) {
	     |     rect.attr({
	     |         x: val
	     |     });
	     | }, 1000);
	     | // in given context is equivalent to
	     | rect.animate({x: 10}, 1000);
	    \*/
	    Snap.animate = function (from, to, setter, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        var now = mina.time(),
	            anim = mina(from, to, now, now + ms, mina.time, setter, easing);
	        callback && eve.once("mina.finish." + anim.id, callback);
	        return anim;
	    };
	    /*\
	     * Element.stop
	     [ method ]
	     **
	     * Stops all the animations for the current element
	     **
	     = (Element) the current element
	    \*/
	    elproto.stop = function () {
	        var anims = this.inAnim();
	        for (var i = 0, ii = anims.length; i < ii; i++) {
	            anims[i].stop();
	        }
	        return this;
	    };
	    /*\
	     * Element.animate
	     [ method ]
	     **
	     * Animates the given attributes of the element
	     **
	     - attrs (object) key-value pairs of destination attributes
	     - duration (number) duration of the animation in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function that executes when the animation ends
	     = (Element) the current element
	    \*/
	    elproto.animate = function (attrs, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        if (attrs instanceof Animation) {
	            callback = attrs.callback;
	            easing = attrs.easing;
	            ms = attrs.dur;
	            attrs = attrs.attr;
	        }
	        var fkeys = [], tkeys = [], keys = {}, from, to, f, eq,
	            el = this;
	        for (var key in attrs) if (attrs[has](key)) {
	            if (el.equal) {
	                eq = el.equal(key, Str(attrs[key]));
	                from = eq.from;
	                to = eq.to;
	                f = eq.f;
	            } else {
	                from = +el.attr(key);
	                to = +attrs[key];
	            }
	            var len = is(from, "array") ? from.length : 1;
	            keys[key] = slice(fkeys.length, fkeys.length + len, f);
	            fkeys = fkeys.concat(from);
	            tkeys = tkeys.concat(to);
	        }
	        var now = mina.time(),
	            anim = mina(fkeys, tkeys, now, now + ms, mina.time, function (val) {
	                var attr = {};
	                for (var key in keys) if (keys[has](key)) {
	                    attr[key] = keys[key](val);
	                }
	                el.attr(attr);
	            }, easing);
	        el.anims[anim.id] = anim;
	        anim._attrs = attrs;
	        anim._callback = callback;
	        eve("snap.animcreated." + el.id, anim);
	        eve.once("mina.finish." + anim.id, function () {
	            eve.off("mina.*." + anim.id);
	            delete el.anims[anim.id];
	            callback && callback.call(el);
	        });
	        eve.once("mina.stop." + anim.id, function () {
	            eve.off("mina.*." + anim.id);
	            delete el.anims[anim.id];
	        });
	        return el;
	    };
	});
	
	// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    // Colours are from https://www.materialui.co
	    var red         = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000",
	        pink        = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162",
	        purple      = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF",
	        deeppurple  = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA",
	        indigo      = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE",
	        blue        = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF",
	        lightblue   = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA",
	        cyan        = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4",
	        teal        = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5",
	        green       = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853",
	        lightgreen  = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17",
	        lime        = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00",
	        yellow      = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600",
	        amber       = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00",
	        orange      = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00",
	        deeporange  = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00",
	        brown       = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723",
	        grey        = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121",
	        bluegrey    = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
	    /*\
	     * Snap.mui
	     [ property ]
	     **
	     * Contain Material UI colours.
	     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.mui.deeppurple, stroke: Snap.mui.amber[600]});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.mui = {};
	    /*\
	     * Snap.flat
	     [ property ]
	     **
	     * Contain Flat UI colours.
	     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.flat.carrot, stroke: Snap.flat.wetasphalt});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.flat = {};
	    function saveColor(colors) {
	        colors = colors.split(/(?=#)/);
	        var color = new String(colors[5]);
	        color[50] = colors[0];
	        color[100] = colors[1];
	        color[200] = colors[2];
	        color[300] = colors[3];
	        color[400] = colors[4];
	        color[500] = colors[5];
	        color[600] = colors[6];
	        color[700] = colors[7];
	        color[800] = colors[8];
	        color[900] = colors[9];
	        if (colors[10]) {
	            color.A100 = colors[10];
	            color.A200 = colors[11];
	            color.A400 = colors[12];
	            color.A700 = colors[13];
	        }
	        return color;
	    }
	    Snap.mui.red = saveColor(red);
	    Snap.mui.pink = saveColor(pink);
	    Snap.mui.purple = saveColor(purple);
	    Snap.mui.deeppurple = saveColor(deeppurple);
	    Snap.mui.indigo = saveColor(indigo);
	    Snap.mui.blue = saveColor(blue);
	    Snap.mui.lightblue = saveColor(lightblue);
	    Snap.mui.cyan = saveColor(cyan);
	    Snap.mui.teal = saveColor(teal);
	    Snap.mui.green = saveColor(green);
	    Snap.mui.lightgreen = saveColor(lightgreen);
	    Snap.mui.lime = saveColor(lime);
	    Snap.mui.yellow = saveColor(yellow);
	    Snap.mui.amber = saveColor(amber);
	    Snap.mui.orange = saveColor(orange);
	    Snap.mui.deeporange = saveColor(deeporange);
	    Snap.mui.brown = saveColor(brown);
	    Snap.mui.grey = saveColor(grey);
	    Snap.mui.bluegrey = saveColor(bluegrey);
	    Snap.flat.turquoise = "#1abc9c";
	    Snap.flat.greensea = "#16a085";
	    Snap.flat.sunflower = "#f1c40f";
	    Snap.flat.orange = "#f39c12";
	    Snap.flat.emerland = "#2ecc71";
	    Snap.flat.nephritis = "#27ae60";
	    Snap.flat.carrot = "#e67e22";
	    Snap.flat.pumpkin = "#d35400";
	    Snap.flat.peterriver = "#3498db";
	    Snap.flat.belizehole = "#2980b9";
	    Snap.flat.alizarin = "#e74c3c";
	    Snap.flat.pomegranate = "#c0392b";
	    Snap.flat.amethyst = "#9b59b6";
	    Snap.flat.wisteria = "#8e44ad";
	    Snap.flat.clouds = "#ecf0f1";
	    Snap.flat.silver = "#bdc3c7";
	    Snap.flat.wetasphalt = "#34495e";
	    Snap.flat.midnightblue = "#2c3e50";
	    Snap.flat.concrete = "#95a5a6";
	    Snap.flat.asbestos = "#7f8c8d";
	    /*\
	     * Snap.importMUIColors
	     [ method ]
	     **
	     * Imports Material UI colours into global object.
	     | Snap.importMUIColors();
	     | Snap().rect(0, 0, 10, 10).attr({fill: deeppurple, stroke: amber[600]});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.importMUIColors = function () {
	        for (var color in Snap.mui) {
	            if (Snap.mui.hasOwnProperty(color)) {
	                window[color] = Snap.mui[color];
	            }
	        }
	    };
	});
	
	module.exports = Snap


/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FacebookSDK = function (_Component) {
	  _inherits(FacebookSDK, _Component);
	
	  function FacebookSDK() {
	    _classCallCheck(this, FacebookSDK);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  FacebookSDK.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.parseXFBML();
	  };
	
	  FacebookSDK.prototype.parseXFBML = function parseXFBML() {
	    if (typeof window !== "undefined" && {}.hasOwnProperty.call(window, "FB")) {
	      // Get all the divs with a Facebook plugin
	      // Convert the NodeList to an array
	      var plugins = [].slice.call(document.querySelectorAll(".fb-plugin"));
	
	      // Use the FB SDK to parse each opf the plugins
	      plugins.map(function (plugin) {
	        return window.FB.XFBML.parse(plugin);
	      });
	    }
	  };
	
	  FacebookSDK.prototype.render = function render() {
	    return null;
	  };
	
	  return FacebookSDK;
	}(_react.Component);
	
	exports.default = FacebookSDK;
	module.exports = exports["default"];

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  box-shadow: inset 0 2px 18px 0 rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n\n  @media (min-width: 1025px) {\n    text-align: center;\n  }\n\n  a {\n    color: #fff;\n    font-size: 14px;\n    transition: all 300ms ease-in-out;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n\n    &:visited {\n      color: #fff;\n    }\n  }\n"], ["\n  background: ", ";\n  box-shadow: inset 0 2px 18px 0 rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n\n  @media (min-width: 1025px) {\n    text-align: center;\n  }\n\n  a {\n    color: #fff;\n    font-size: 14px;\n    transition: all 300ms ease-in-out;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n\n    &:visited {\n      color: #fff;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 48em) {\n    text-align: center;\n  }\n"], ["\n  @media (min-width: 48em) {\n    text-align: center;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  color: #fff;\n  display: inline-block;\n  font-size: 12px;\n  position: relative;\n"], ["\n  color: #fff;\n  display: inline-block;\n  font-size: 12px;\n  position: relative;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  left: -6px;\n  opacity: 0.8;\n  position: absolute;\n  top: -7px;\n"], ["\n  left: -6px;\n  opacity: 0.8;\n  position: absolute;\n  top: -7px;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  position: relative;\n\n  @media (min-width: 48em) {\n    text-align: center;\n  }\n"], ["\n  display: inline-block;\n  position: relative;\n\n  @media (min-width: 48em) {\n    text-align: center;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  font-weight: 300;\n  padding: 10px;\n"], ["\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  font-weight: 300;\n  padding: 10px;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  left: -90px;\n  opacity: 0.3;\n  position: absolute;\n  top: -80px;\n\n  @media (min-width: 48em) {\n    left: 25%;\n    top: -90px;\n  }\n"], ["\n  left: -90px;\n  opacity: 0.3;\n  position: absolute;\n  top: -80px;\n\n  @media (min-width: 48em) {\n    left: 25%;\n    top: -90px;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  right: -120px;\n  opacity: 0.3;\n  position: absolute;\n  top: -80px;\n\n  @media (min-width: 48em) {\n    right: -60px;\n    top: -130px;\n  }\n"], ["\n  right: -120px;\n  opacity: 0.3;\n  position: absolute;\n  top: -80px;\n\n  @media (min-width: 48em) {\n    right: -60px;\n    top: -130px;\n  }\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  bottom: -85px;\n  left: 25%;\n  position: absolute;\n\n  @media (min-width: 48em) {\n    left: 40%;\n  }\n"], ["\n  bottom: -85px;\n  left: 25%;\n  position: absolute;\n\n  @media (min-width: 48em) {\n    left: 40%;\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: -18px;\n  top: -15px;\n"], ["\n  position: absolute;\n  right: -18px;\n  top: -15px;\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: -29px;\n  top: -26px;\n"], ["\n  position: absolute;\n  right: -29px;\n  top: -26px;\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: -39px;\n  top: -33px;\n"], ["\n  position: absolute;\n  right: -39px;\n  top: -33px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(181);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(3);
	
	var _index = __webpack_require__(15);
	
	var _FacebookButton = __webpack_require__(31);
	
	var _FacebookButton2 = _interopRequireDefault(_FacebookButton);
	
	var _Navbar = __webpack_require__(151);
	
	var _logoWhite = __webpack_require__(305);
	
	var _logoWhite2 = _interopRequireDefault(_logoWhite);
	
	var _Circle = __webpack_require__(6);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// import TiHeartFullOutline from "react-icons/lib/ti/heart-full-outline";
	
	var px = [1, 1, 3];
	var py = [1, 1, 2];
	
	var Footer = function Footer(_ref) {
	  var siteMetadata = _ref.siteMetadata;
	  return _react2.default.createElement(
	    StyledBar,
	    { mx: [0], py: [4, 4, 4, 5], is: "footer" },
	    _react2.default.createElement(
	      _rebass.Container,
	      null,
	      _react2.default.createElement(
	        _rebass.Flex,
	        { wrap: true, justify: "center" },
	        _react2.default.createElement(
	          _rebass.Box,
	          { w: [1], px: px, py: py, mb: [3] },
	          _react2.default.createElement(
	            LogoWrap,
	            null,
	            _react2.default.createElement("img", { src: _logoWhite2.default, alt: "Pipeline Logo", height: "27" })
	          )
	        ),
	        _react2.default.createElement(
	          _rebass.Box,
	          { w: [1 / 2, 1 / 2, "auto"], px: px, py: py },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            "Home"
	          )
	        ),
	        _Navbar.navLinks.map(function (link, i) {
	          return _react2.default.createElement(
	            _rebass.Box,
	            { w: [1 / 2, 1 / 2, "auto"], px: px, py: py, key: i },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: link.path },
	              link.label
	            )
	          );
	        }),
	        _react2.default.createElement(
	          _rebass.Box,
	          { w: [1, 1, "auto"], px: px, py: py },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/privacy" },
	            "Privacy Policy"
	          )
	        ),
	        _react2.default.createElement(
	          _rebass.Box,
	          { w: [1], px: px, py: [0], mt: [4], className: "text-center-desktop" },
	          _react2.default.createElement(
	            FacebookWrap,
	            null,
	            _react2.default.createElement(
	              _rebass.Link,
	              { href: siteMetadata.appUrl },
	              _react2.default.createElement(
	                StyledFacebookButton,
	                { mb: [2, 2, 3] },
	                "Login with Facebook"
	              )
	            ),
	            _react2.default.createElement(FacebookCircle1, { strokeColor: "#fff", r: 6 }),
	            _react2.default.createElement(FacebookCircle2, { strokeColor: "#fff", r: 3.5 }),
	            _react2.default.createElement(FacebookCircle3, { strokeColor: "#fff", r: 2.5 })
	          )
	        ),
	        _react2.default.createElement(
	          _rebass.Box,
	          { w: [1], px: px, py: [0], mt: [0], className: "text-center-desktop" },
	          _react2.default.createElement(
	            Copyright,
	            null,
	            _react2.default.createElement(CopyrightCircle, { strokeColor: "#fff", r: 2 }),
	            "\xA9 Pipeline Social ",
	            new Date().getFullYear()
	          )
	        )
	      ),
	      _react2.default.createElement(Circle1, { strokeColor: "#fff", r: 62 }),
	      _react2.default.createElement(Circle2, { strokeColor: "#fff", r: 100 }),
	      _react2.default.createElement(Circle3, { strokeColor: "#fff", r: 47 })
	    )
	  );
	};
	
	exports.default = Footer;
	
	
	var StyledBar = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (p) {
	  return p.theme.colors.support4;
	});
	
	var LogoWrap = _styledComponents2.default.div(_templateObject2);
	
	// const TagLine = styled.p`
	//   color: palevioletred;
	//   font-size: 12px;
	//   margin: 0;
	
	//   @media (min-width: 48em) {
	//     text-align: center;
	//   }
	// `;
	
	var Copyright = _styledComponents2.default.div(_templateObject3);
	
	var CopyrightCircle = (0, _styledComponents2.default)(_Circle2.default)(_templateObject4);
	
	var FacebookWrap = _styledComponents2.default.div(_templateObject5);
	
	var StyledFacebookButton = (0, _styledComponents2.default)(_FacebookButton2.default)(_templateObject6);
	
	var Circle1 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject7);
	
	var Circle2 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject8);
	
	var Circle3 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject9);
	
	var FacebookCircle1 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject10);
	
	var FacebookCircle2 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject11);
	
	var FacebookCircle3 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject12);
	module.exports = exports["default"];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-family: \"PT Sans\", sans-serif;\n  font-weight: 400;\n  position: relative;\n  z-index: 1;\n"], ["\n  color: ", ";\n  font-family: \"PT Sans\", sans-serif;\n  font-weight: 400;\n  position: relative;\n  z-index: 1;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-weight: 300;\n  line-height: 1.6;\n  position: relative;\n  z-index: 1;\n"], ["\n  font-weight: 300;\n  line-height: 1.6;\n  position: relative;\n  z-index: 1;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);\n  height: 56px;\n  padding-top: 15px;\n  position: relative;\n  width: auto;\n  z-index: 1;\n"], ["\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.17);\n  height: 56px;\n  padding-top: 15px;\n  position: relative;\n  width: auto;\n  z-index: 1;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  color: #a8b3bb;\n"], ["\n  color: #a8b3bb;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  background: #ffffff;\n  border-radius: 30px;\n  box-shadow: -4px 4px 0 2px #ebecee, -2px -1px 49px 0 rgba(88, 95, 100, 0.04);\n  margin: 0 auto;\n  padding: 30px;\n\n  /* &:hover {\n    box-shadow: inset -2px 2px 2px 0 #f5f5f7,\n      -2px -1px 49px 0 rgba(88, 95, 100, 0.04), inset 1px 0px 1px 1px #f5f5f7;\n\n    svg {\n      left: -2px;\n      opacity: 0.86;\n      position: relative;\n      top: 2px;\n    }\n  } */\n\n  svg {\n    display: block;\n    margin: 0 auto;\n    max-height: 180px;\n    opacity: 0.46;\n\n    @media (min-width: 48em) {\n      margin: 30px auto;\n    }\n  }\n"], ["\n  background: #ffffff;\n  border-radius: 30px;\n  box-shadow: -4px 4px 0 2px #ebecee, -2px -1px 49px 0 rgba(88, 95, 100, 0.04);\n  margin: 0 auto;\n  padding: 30px;\n\n  /* &:hover {\n    box-shadow: inset -2px 2px 2px 0 #f5f5f7,\n      -2px -1px 49px 0 rgba(88, 95, 100, 0.04), inset 1px 0px 1px 1px #f5f5f7;\n\n    svg {\n      left: -2px;\n      opacity: 0.86;\n      position: relative;\n      top: 2px;\n    }\n  } */\n\n  svg {\n    display: block;\n    margin: 0 auto;\n    max-height: 180px;\n    opacity: 0.46;\n\n    @media (min-width: 48em) {\n      margin: 30px auto;\n    }\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  background: #f8fbfd;\n  border-radius: 26.4px;\n  border: 1px solid rgba(151, 151, 151, 0.06);\n  box-shadow: 0 0 22px 0 rgba(0, 0, 0, 0.08);\n  margin: 0 auto;\n  opacity: 0.9;\n  padding: 30px;\n  position: relative;\n  transform: rotate(-13deg);\n  width: 215px;\n  z-index: 1;\n\n  @media (min-width: 48em) {\n    padding: 25px;\n    width: 360px;\n  }\n"], ["\n  background: #f8fbfd;\n  border-radius: 26.4px;\n  border: 1px solid rgba(151, 151, 151, 0.06);\n  box-shadow: 0 0 22px 0 rgba(0, 0, 0, 0.08);\n  margin: 0 auto;\n  opacity: 0.9;\n  padding: 30px;\n  position: relative;\n  transform: rotate(-13deg);\n  width: 215px;\n  z-index: 1;\n\n  @media (min-width: 48em) {\n    padding: 25px;\n    width: 360px;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  z-index: 1;\n"], ["\n  display: block;\n  position: relative;\n  z-index: 1;\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  left: 0;\n  margin: 0 auto;\n  max-width: 642px;\n  position: relative;\n  right: 0;\n  /* top: -4%; */\n  width: 90%;\n  z-index: 2;\n\n  /* @media (min-width: 22em) {\n    top: -4%;\n    width: 80%;\n  }\n\n  @media (min-width: 26em) {\n    top: -5%;\n  }\n\n  @media (min-width: 30em) {\n    top: -6%;\n    width: 75%;\n  }\n\n  @media (min-width: 32em) {\n    top: -11%;\n    width: 75%;\n  } */\n"], ["\n  left: 0;\n  margin: 0 auto;\n  max-width: 642px;\n  position: relative;\n  right: 0;\n  /* top: -4%; */\n  width: 90%;\n  z-index: 2;\n\n  /* @media (min-width: 22em) {\n    top: -4%;\n    width: 80%;\n  }\n\n  @media (min-width: 26em) {\n    top: -5%;\n  }\n\n  @media (min-width: 30em) {\n    top: -6%;\n    width: 75%;\n  }\n\n  @media (min-width: 32em) {\n    top: -11%;\n    width: 75%;\n  } */\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  bottom: -30px;\n  left: 51%;\n  margin: 0 auto;\n  position: absolute;\n  right: 50%;\n\n  @media (min-width: 48em) {\n    bottom: -60px;\n    left: 0;\n    right: 0;\n    transform: rotate(18deg);\n  }\n"], ["\n  bottom: -30px;\n  left: 51%;\n  margin: 0 auto;\n  position: absolute;\n  right: 50%;\n\n  @media (min-width: 48em) {\n    bottom: -60px;\n    left: 0;\n    right: 0;\n    transform: rotate(18deg);\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  margin-left: -13px;\n  position: absolute;\n  top: -18px;\n  transform: rotate(-41deg);\n"], ["\n  margin-left: -13px;\n  position: absolute;\n  top: -18px;\n  transform: rotate(-41deg);\n"]);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rebass = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactImage = __webpack_require__(8);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _index = __webpack_require__(15);
	
	var _FacebookButton = __webpack_require__(31);
	
	var _FacebookButton2 = _interopRequireDefault(_FacebookButton);
	
	var _FBUsers = __webpack_require__(67);
	
	var _FBUsers2 = _interopRequireDefault(_FBUsers);
	
	var _introDevices = __webpack_require__(77);
	
	var _introDevices2 = _interopRequireDefault(_introDevices);
	
	var _miniArrow = __webpack_require__(78);
	
	var _miniArrow2 = _interopRequireDefault(_miniArrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// import Users from "../components/Users/Users";
	
	
	var propsToOmit = ["siteMetadata"];
	
	var Hero = function Hero(props) {
	  return React.createElement(
	    _rebass.Box,
	    (0, _lodash2.default)(props, propsToOmit),
	    React.createElement(
	      "div",
	      { className: "container" },
	      React.createElement(
	        _rebass.Flex,
	        { wrap: true },
	        React.createElement(
	          _rebass.Box,
	          { w: [1, 1, 1 / 2] },
	          React.createElement(
	            StyledHeading,
	            {
	              is: "h1",
	              mt: [3, 3, "180px"],
	              mb: [3, 3, 3],
	              className: "text-center text-left-desktop",
	              f: [4, 4, "38px"],
	              color: "base"
	            },
	            "Your automated messaging platform that converts leads into customers."
	          ),
	          React.createElement(
	            StyledSubhead,
	            {
	              is: "p",
	              mb: [4, 4, "48px"],
	              f: ["15px", 2, 2],
	              className: "text-center text-left-desktop",
	              color: "support1",
	              w: [1, 1, "80%"]
	            },
	            "Pipeline sparks Messenger conversations with leads as they move through your sales funnel then helps convert them into customers."
	          ),
	          React.createElement(
	            _rebass.Text,
	            { className: "text-center text-left-desktop relative", mb: [3] },
	            React.createElement(CTAminiArrow, { src: _miniArrow2.default }),
	            React.createElement(
	              _rebass.Link,
	              { href: props.siteMetadata.appUrl },
	              React.createElement(
	                StyledFacebookButton,
	                { mb: [2, 2, 3, 4] },
	                "GET STARTED FOR FREE"
	              )
	            )
	          ),
	          React.createElement(
	            InfoText,
	            { className: "text-center text-left-desktop", f: [1], mb: [5] },
	            "Easy setup | Cancel any time"
	          )
	        ),
	        React.createElement(
	          _rebass.Box,
	          { w: [1, 1, 1 / 2], mt: [0, 0, 4] },
	          React.createElement(
	            MessengerLogoBg,
	            null,
	            React.createElement(
	              StyledMessengerLogo,
	              null,
	              React.createElement(
	                "svg",
	                {
	                  xmlns: "http://www.w3.org/2000/svg",
	                  width: "100%",
	                  height: "100%",
	                  viewBox: "96 83 342 344"
	                },
	                React.createElement(
	                  "defs",
	                  null,
	                  React.createElement(
	                    "filter",
	                    {
	                      xmlns: "http://www.w3.org/2000/svg",
	                      id: "dropshadow",
	                      height: "130%"
	                    },
	                    React.createElement("feGaussianBlur", { "in": "SourceAlpha", stdDeviation: "5" }),
	                    React.createElement("feOffset", { dx: "2", dy: "9", result: "offsetblur" }),
	                    React.createElement(
	                      "feComponentTransfer",
	                      null,
	                      React.createElement("feFuncA", { type: "linear", slope: "0.16" })
	                    ),
	                    React.createElement(
	                      "feMerge",
	                      null,
	                      React.createElement("feMergeNode", null),
	                      React.createElement("feMergeNode", { "in": "SourceGraphic" })
	                    )
	                  )
	                ),
	                React.createElement("path", {
	                  d: "M257 93c-89 0-161 67.2-161 150 0 47.2 23.4 89.3 60 116.8V417l54.8-30.3A172 172 0 0 0 257 393c89 0 161-67.2 161-150S346 93 257 93zm16 202l-41-44-80 44 88-94 42 44 79-44-88 94z",
	                  fill: "#0084ff",
	                  filter: "url(#dropshadow)"
	                })
	              )
	            )
	          ),
	          React.createElement(
	            "div",
	            { className: "relative" },
	            React.createElement(StyledFbUsers, {
	              src: _FBUsers2.default,
	              alt: "Facebook users",
	              w: ["200px", "null", "270px"],
	              mt: [2],
	              mx: "auto",
	              is: _reactImage2.default
	            }),
	            React.createElement(IntroArrow, { src: _miniArrow2.default })
	          )
	        )
	      ),
	      React.createElement(
	        _rebass.Flex,
	        { mb: ["-100px", "-130px", "-150px", "-240px"] },
	        React.createElement(
	          _rebass.Box,
	          { w: [1], mx: "auto" },
	          React.createElement(
	            StyledHeading,
	            {
	              is: "h2",
	              mt: ["50px", "50px", "100px"],
	              mb: [3, 3, 3],
	              f: [4, 4, "28px"],
	              color: "base",
	              align: "center"
	            },
	            "Looking to convert more leads? Meet Pipeline."
	          ),
	          React.createElement(
	            StyledSubhead,
	            {
	              is: "p",
	              mb: [4, 5, 5, "48px"],
	              f: ["15px", 2, 2],
	              color: "support1",
	              align: "center",
	              w: [1, 1, "80%", "50%"],
	              mx: "auto"
	            },
	            "Pipeline allows you to tie conversation automation with your sales funnel. Enabling you to automatically engage with leads as they show interest in your products."
	          ),
	          React.createElement(IntroImage, { src: _introDevices2.default, is: _reactImage2.default })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Hero;
	
	// Styled Components
	
	var StyledHeading = (0, _styledComponents2.default)(_rebass.Heading)(_templateObject, function (p) {
	  return p.theme.colors.base;
	});
	
	var StyledSubhead = (0, _styledComponents2.default)(_rebass.Subhead)(_templateObject2);
	
	var StyledFacebookButton = (0, _styledComponents2.default)(_FacebookButton2.default)(_templateObject3);
	
	var InfoText = (0, _styledComponents2.default)(_rebass.Text)(_templateObject4);
	
	var StyledMessengerLogo = _styledComponents2.default.div(_templateObject5);
	
	var MessengerLogoBg = _styledComponents2.default.div(_templateObject6);
	
	var StyledFbUsers = (0, _styledComponents2.default)(_rebass.Image)(_templateObject7);
	
	var IntroImage = (0, _styledComponents2.default)(_rebass.Image)(_templateObject8);
	
	var IntroArrow = (0, _styledComponents2.default)(_reactImage2.default)(_templateObject9);
	
	var CTAminiArrow = (0, _styledComponents2.default)(_reactImage2.default)(_templateObject10);
	module.exports = exports["default"];

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  &:before {\n    -ms-transform: skewY(3deg);\n    background: #f8fcff;\n    border: 1px solid rgba(151, 151, 151, 0.06);\n    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);\n    content: \"\";\n    display: block;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    transform: skewY(3deg);\n    width: 100%;\n    z-index: 0;\n    z-index: 1;\n  }\n\n  .container {\n    position: relative;\n    z-index: 2;\n  }\n"], ["\n  position: relative;\n\n  &:before {\n    -ms-transform: skewY(3deg);\n    background: #f8fcff;\n    border: 1px solid rgba(151, 151, 151, 0.06);\n    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);\n    content: \"\";\n    display: block;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    transform: skewY(3deg);\n    width: 100%;\n    z-index: 0;\n    z-index: 1;\n  }\n\n  .container {\n    position: relative;\n    z-index: 2;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rebass = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _IntroPart = __webpack_require__(55);
	
	var _IntroPart2 = _interopRequireDefault(_IntroPart);
	
	var _IntroPart3 = __webpack_require__(56);
	
	var _IntroPart4 = _interopRequireDefault(_IntroPart3);
	
	var _IntroPart5 = __webpack_require__(57);
	
	var _IntroPart6 = _interopRequireDefault(_IntroPart5);
	
	var _IntroPart7 = __webpack_require__(58);
	
	var _IntroPart8 = _interopRequireDefault(_IntroPart7);
	
	var _Circle = __webpack_require__(6);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var propsToOmit = ["siteMetadata"];
	
	var Intro = function Intro(props) {
	  return React.createElement(
	    StyledBox,
	    (0, _lodash2.default)(props, propsToOmit),
	    React.createElement(
	      "div",
	      { className: "container" },
	      React.createElement(
	        _rebass.Flex,
	        { mx: "auto", wrap: true },
	        React.createElement(_IntroPart2.default, props),
	        React.createElement(_IntroPart4.default, props),
	        React.createElement(_IntroPart6.default, props),
	        React.createElement(_IntroPart8.default, props)
	      )
	    )
	  );
	};
	
	exports.default = Intro;
	
	// Styled Components
	
	var StyledBox = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	module.exports = exports["default"];

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: none;\n  opacity: 0.8;\n  position: absolute;\n  right: 150px;\n  top: 200px;\n\n  @media (min-width: 56em) {\n    display: block;\n  }\n"], ["\n  display: none;\n  opacity: 0.8;\n  position: absolute;\n  right: 150px;\n  top: 200px;\n\n  @media (min-width: 56em) {\n    display: block;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  left: -25px;\n  position: absolute;\n  top: 50px;\n  }\n"], ["\n  left: -25px;\n  position: absolute;\n  top: 50px;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  left: 15px;\n  position: absolute;\n  top: 60px;\n"], ["\n  left: 15px;\n  position: absolute;\n  top: 60px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  left: 65px;\n  position: absolute;\n  top: 70px;\n"], ["\n  left: 65px;\n  position: absolute;\n  top: 70px;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n\n  @media (min-width: 48em) {\n    max-width: 405px;\n  }\n"], ["\n  width: 100%;\n\n  @media (min-width: 48em) {\n    max-width: 405px;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactImage = __webpack_require__(8);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _Circle = __webpack_require__(6);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	var _Button = __webpack_require__(9);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _segmentIcon = __webpack_require__(82);
	
	var _segmentIcon2 = _interopRequireDefault(_segmentIcon);
	
	var _funnelExample = __webpack_require__(76);
	
	var _funnelExample2 = _interopRequireDefault(_funnelExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Fragment = _react2.default.Fragment;
	
	
	var IntroPart1 = function IntroPart1(props) {
	  return _react2.default.createElement(
	    _rebass.Flex,
	    { pt: [0, 0, "140px", "240px"], wrap: true },
	    _react2.default.createElement(
	      _rebass.Box,
	      {
	        w: [1, 1, "60%"],
	        mb: [4, 4, 6],
	        pl: [0, 0, 0, 5],
	        pt: ["70px"],
	        className: "relative"
	      },
	      _react2.default.createElement(_rebass.Image, {
	        src: _segmentIcon2.default,
	        alt: "Segment your followers icon",
	        mb: [4],
	        is: _reactImage2.default
	      }),
	      _react2.default.createElement(
	        _rebass.Heading,
	        {
	          color: "support2",
	          className: "font-light relative",
	          is: "h4",
	          f: [3, 4, "26px"],
	          mb: [3]
	        },
	        _react2.default.createElement(_Circle2.default, { style: { position: "absolute", left: "-25px", top: "-15px" } }),
	        "Funnel your followers"
	      ),
	      _react2.default.createElement(
	        _rebass.Text,
	        { color: "support1", f: "15px", mb: [4], w: ["70%", "70%", "80%", "70%"] },
	        "Segment your users based on where they are in the sales funnel. It's completely automated, so you just need to set and forget."
	      ),
	      _react2.default.createElement(
	        Section1Circles,
	        null,
	        _react2.default.createElement(Section1Circle1, { r: 14.5 }),
	        _react2.default.createElement(Section1Circle2, { r: 20.5 }),
	        _react2.default.createElement(Section1Circle3, { r: 38 })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { is: "a", href: props.siteMetadata.appUrl },
	        "GET STARTED FOR FREE"
	      )
	    ),
	    _react2.default.createElement(
	      _rebass.Box,
	      { w: [1, 1, "40%"], mb: ["75px", null, "130px"] },
	      _react2.default.createElement(Part1Image, { src: _funnelExample2.default, alt: "funnel example", is: _reactImage2.default })
	    )
	  );
	};
	
	exports.default = IntroPart1;
	
	// Styled Components
	
	var Section1Circles = _styledComponents2.default.div(_templateObject);
	
	var Section1Circle1 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject2);
	
	var Section1Circle2 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject3);
	
	var Section1Circle3 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject4);
	
	var Part1Image = (0, _styledComponents2.default)(_rebass.Image)(_templateObject5);
	module.exports = exports["default"];

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  left: -26px;\n  position: absolute;\n  top: -64px;\n  transform: scale(0.8);\n\n  @media (min-width: 48em) {\n    left: -50px;\n    top: -75px;\n    transform: scale(1);\n  }\n"], ["\n  left: -26px;\n  position: absolute;\n  top: -64px;\n  transform: scale(0.8);\n\n  @media (min-width: 48em) {\n    left: -50px;\n    top: -75px;\n    transform: scale(1);\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  left: 30px;\n  position: absolute;\n  top: 230px;\n  z-index: 0;\n\n  @media (min-width: 48em) {\n    left: 310px;\n    top: -80px;\n  }\n\n  @media (min-width: 56em) {\n    left: 410px;\n    top: -80px;\n  }\n"], ["\n  left: 30px;\n  position: absolute;\n  top: 230px;\n  z-index: 0;\n\n  @media (min-width: 48em) {\n    left: 310px;\n    top: -80px;\n  }\n\n  @media (min-width: 56em) {\n    left: 410px;\n    top: -80px;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  left: -25px;\n  position: absolute;\n  top: -15px;\n"], ["\n  left: -25px;\n  position: absolute;\n  top: -15px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  left: 25px;\n  position: absolute;\n  top: -55px;\n\n  @media (min-width: 56em) {\n    left: 55px;\n    top: -95px;\n  }\n"], ["\n  left: 25px;\n  position: absolute;\n  top: -55px;\n\n  @media (min-width: 56em) {\n    left: 55px;\n    top: -95px;\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  left: 105px;\n  position: absolute;\n  top: -35px;\n\n  @media (min-width: 56em) {\n    left: 175px;\n    top: -55px;\n  }\n"], ["\n  left: 105px;\n  position: absolute;\n  top: -35px;\n\n  @media (min-width: 56em) {\n    left: 175px;\n    top: -55px;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  left: 125px;\n  position: absolute;\n  top: 20px;\n\n  @media (min-width: 56em) {\n    left: 255px;\n    top: 30px;\n  }\n"], ["\n  left: 125px;\n  position: absolute;\n  top: 20px;\n\n  @media (min-width: 56em) {\n    left: 255px;\n    top: 30px;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactImage = __webpack_require__(8);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _Button = __webpack_require__(9);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Circle = __webpack_require__(6);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	var _conversationsIcon = __webpack_require__(74);
	
	var _conversationsIcon2 = _interopRequireDefault(_conversationsIcon);
	
	var _notifcationLeads = __webpack_require__(79);
	
	var _notifcationLeads2 = _interopRequireDefault(_notifcationLeads);
	
	var _notifcationRegistrations = __webpack_require__(80);
	
	var _notifcationRegistrations2 = _interopRequireDefault(_notifcationRegistrations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Fragment = _react2.default.Fragment;
	
	
	var IntroPart2 = function IntroPart2(props) {
	  return _react2.default.createElement(
	    Fragment,
	    null,
	    _react2.default.createElement(
	      _rebass.Box,
	      {
	        w: [0, 0, 1 / 3],
	        mb: [4, 4, 5, "480px"],
	        pr: [0, 0, "50px", "80px"],
	        mt: [0, 0, "-50px", "-90px", "-170px"]
	      },
	      _react2.default.createElement(_rebass.Image, { src: _notifcationLeads2.default, alt: "leads notification", width: "377", is: _reactImage2.default })
	    ),
	    _react2.default.createElement(
	      _rebass.Box,
	      {
	        ml: "auto",
	        w: [1, 1, 1 / 3],
	        mb: [4, 4, 6],
	        mt: [0, 0, 4, "100px"],
	        className: "relative"
	      },
	      _react2.default.createElement(
	        Section2Circles,
	        null,
	        _react2.default.createElement(Section2Circle1, { r: 8 }),
	        _react2.default.createElement(Section2Circle2, { r: 8 }),
	        _react2.default.createElement(Section2Circle3, { r: 13 }),
	        _react2.default.createElement(Section2Circle4, { r: 5 })
	      ),
	      _react2.default.createElement(
	        _rebass.Heading,
	        {
	          color: "support2",
	          is: "h4",
	          f: [3, 4, "26px"],
	          mb: [3],
	          className: "relative font-light text-right  text-left-desktop"
	        },
	        _react2.default.createElement(ConversationsIcon, {
	          src: _conversationsIcon2.default,
	          alt: "Conversations icon",
	          is: _reactImage2.default
	        }),
	        "Spark conversations with your followers at scale"
	      ),
	      _react2.default.createElement(
	        _rebass.Text,
	        {
	          color: "support1",
	          f: "15px",
	          className: "text-right text-left-desktop",
	          mb: [4]
	        },
	        "Break free from those static, text only marketing emails and start real conversations with functional and content-rich messages."
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "text-right text-left-desktop" },
	        _react2.default.createElement(
	          _Button2.default,
	          { is: "a", href: props.siteMetadata.appUrl, mb: [4] },
	          "GET STARTED FOR FREE"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _rebass.Box,
	      {
	        w: [1, 1, 1 / 3],
	        mb: ["195px", null, 6],
	        px: [0, 0, 3],
	        mt: [0, 0, 6, "180px"]
	      },
	      _react2.default.createElement(_rebass.Image, {
	        src: _notifcationRegistrations2.default,
	        alt: "registrations notification",
	        width: "458px",
	        className: "relative",
	        is: _reactImage2.default
	      })
	    )
	  );
	};
	
	exports.default = IntroPart2;
	
	// Styled Components
	
	var ConversationsIcon = (0, _styledComponents2.default)(_rebass.Image)(_templateObject);
	var Section2Circles = _styledComponents2.default.div(_templateObject2);
	
	var Section2Circle1 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject3);
	
	var Section2Circle2 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject4);
	
	var Section2Circle3 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject5);
	
	var Section2Circle4 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject6);
	module.exports = exports["default"];

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  right: -73px;\n  margin: 0;\n  position: absolute;\n  top: -54px;\n  transform: scale(0.8);\n\n  @media (min-width: 48em) {\n    right: auto;\n    left: -38px;\n    top: -94px;\n    transform: scale(1);\n  }\n"], ["\n  right: -73px;\n  margin: 0;\n  position: absolute;\n  top: -54px;\n  transform: scale(0.8);\n\n  @media (min-width: 48em) {\n    right: auto;\n    left: -38px;\n    top: -94px;\n    transform: scale(1);\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  bottom: -86px;\n  position: absolute;\n  left: 5%;\n  transform: rotate(5deg);\n\n  @media (min-width: 48em) {\n    bottom: auto;\n    left: 30px;\n    top: -120px;\n    transform: rotate(-5deg);\n  }\n\n  @media (min-width: 72em) {\n    top: -180px;\n  }\n"], ["\n  bottom: -86px;\n  position: absolute;\n  left: 5%;\n  transform: rotate(5deg);\n\n  @media (min-width: 48em) {\n    bottom: auto;\n    left: 30px;\n    top: -120px;\n    transform: rotate(-5deg);\n  }\n\n  @media (min-width: 72em) {\n    top: -180px;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  bottom: 20px;\n  position: absolute;\n  right: 20%;\n  transform: rotate(-5deg);\n\n  @media (min-width: 48em) {\n    bottom: auto;\n    left: 310px;\n    top: -80px;\n    transform: rotate(4deg);\n  }\n"], ["\n  bottom: 20px;\n  position: absolute;\n  right: 20%;\n  transform: rotate(-5deg);\n\n  @media (min-width: 48em) {\n    bottom: auto;\n    left: 310px;\n    top: -80px;\n    transform: rotate(4deg);\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: none;\n  position: absolute;\n\n  @media (min-width: 56em) {\n    display: block;\n    bottom: auto;\n    left: 0;\n    top: 170px;\n    transform: rotate(-4deg);\n  }\n\n  @media (min-width: 72em) {\n    left: 90px;\n    top: 70px;\n  }\n"], ["\n  display: none;\n  position: absolute;\n\n  @media (min-width: 56em) {\n    display: block;\n    bottom: auto;\n    left: 0;\n    top: 170px;\n    transform: rotate(-4deg);\n  }\n\n  @media (min-width: 72em) {\n    left: 90px;\n    top: 70px;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  display: none;\n  position: absolute;\n\n  @media (min-width: 48em) {\n    display: block;\n    bottom: auto;\n    left: 70%;\n    top: 20px;\n    transform: rotate(3deg);\n  }\n\n  @media (min-width: 72em) {\n    left: 610px;\n    top: 0px;\n  }\n"], ["\n  display: none;\n  position: absolute;\n\n  @media (min-width: 48em) {\n    display: block;\n    bottom: auto;\n    left: 70%;\n    top: 20px;\n    transform: rotate(3deg);\n  }\n\n  @media (min-width: 72em) {\n    left: 610px;\n    top: 0px;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  display: none;\n  position: absolute;\n\n  @media (min-width: 72em) {\n    display: block;\n    bottom: auto;\n    left: 890px;\n    top: 150px;\n    transform: rotate(2deg);\n  }\n"], ["\n  display: none;\n  position: absolute;\n\n  @media (min-width: 72em) {\n    display: block;\n    bottom: auto;\n    left: 890px;\n    top: 150px;\n    transform: rotate(2deg);\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  left: 20px;\n  position: absolute;\n  top: -100px;\n  transform: rotate(3deg);\n\n  @media (min-width: 48em) {\n    display: block;\n    left: 190px;\n    top: 330px;\n    transform: rotate(1deg);\n  }\n  @media (min-width: 72em) {\n    top: 280px;\n  }\n"], ["\n  left: 20px;\n  position: absolute;\n  top: -100px;\n  transform: rotate(3deg);\n\n  @media (min-width: 48em) {\n    display: block;\n    left: 190px;\n    top: 330px;\n    transform: rotate(1deg);\n  }\n  @media (min-width: 72em) {\n    top: 280px;\n  }\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  display: none;\n  position: absolute;\n\n  @media (min-width: 48em) {\n    display: block;\n    bottom: auto;\n    left: 60%;\n    top: 230px;\n    transform: rotate(-3deg);\n  }\n\n  @media (min-width: 72em) {\n    left: 650px;\n    top: 330px;\n  }\n"], ["\n  display: none;\n  position: absolute;\n\n  @media (min-width: 48em) {\n    display: block;\n    bottom: auto;\n    left: 60%;\n    top: 230px;\n    transform: rotate(-3deg);\n  }\n\n  @media (min-width: 72em) {\n    left: 650px;\n    top: 330px;\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  left: 0px;\n  position: absolute;\n  top: -60px;\n\n  @media (min-width: 48em) {\n    left: 70px;\n    top: -240px;\n  }\n"], ["\n  left: 0px;\n  position: absolute;\n  top: -60px;\n\n  @media (min-width: 48em) {\n    left: 70px;\n    top: -240px;\n  }\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  left: 160px;\n  position: absolute;\n  top: 120px;\n\n  @media (min-width: 48em) {\n    left: 150px;\n    top: -70px;\n  }\n"], ["\n  left: 160px;\n  position: absolute;\n  top: 120px;\n\n  @media (min-width: 48em) {\n    left: 150px;\n    top: -70px;\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n  left: 30px;\n  opacity: 0.3;\n  position: absolute;\n  top: 320px;\n\n  @media (min-width: 48em) {\n    left: 30px;\n    top: 40px;\n  }\n"], ["\n  left: 30px;\n  opacity: 0.3;\n  position: absolute;\n  top: 320px;\n\n  @media (min-width: 48em) {\n    left: 30px;\n    top: 40px;\n  }\n"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n  left: 280px;\n  position: absolute;\n  top: 310px;\n\n  @media (min-width: 48em) {\n    left: 90px;\n    top: 300px;\n  }\n"], ["\n  left: 280px;\n  position: absolute;\n  top: 310px;\n\n  @media (min-width: 48em) {\n    left: 90px;\n    top: 300px;\n  }\n"]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n  left: 40px;\n  position: absolute;\n  top: 220px;\n\n  @media (min-width: 48em) {\n    left: 540px;\n    top: 330px;\n  }\n"], ["\n  left: 40px;\n  position: absolute;\n  top: 220px;\n\n  @media (min-width: 48em) {\n    left: 540px;\n    top: 330px;\n  }\n"]),
	    _templateObject15 = _taggedTemplateLiteralLoose(["\n  left: 100px;\n  position: absolute;\n  top: 400px;\n\n  @media (min-width: 48em) {\n    left: 900px;\n    top: 80px;\n  }\n"], ["\n  left: 100px;\n  position: absolute;\n  top: 400px;\n\n  @media (min-width: 48em) {\n    left: 900px;\n    top: 80px;\n  }\n"]),
	    _templateObject16 = _taggedTemplateLiteralLoose(["\n  left: 250px;\n  position: absolute;\n  top: 20px;\n\n  @media (min-width: 48em) {\n    left: 590px;\n    top: -55px;\n  }\n"], ["\n  left: 250px;\n  position: absolute;\n  top: 20px;\n\n  @media (min-width: 48em) {\n    left: 590px;\n    top: -55px;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactImage = __webpack_require__(8);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _Button = __webpack_require__(9);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Circle = __webpack_require__(6);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	var _automateIcon = __webpack_require__(71);
	
	var _automateIcon2 = _interopRequireDefault(_automateIcon);
	
	var _MessengerBubble = __webpack_require__(59);
	
	var _MessengerBubble2 = _interopRequireDefault(_MessengerBubble);
	
	var _ads = __webpack_require__(72);
	
	var _ads2 = _interopRequireDefault(_ads);
	
	var _giles = __webpack_require__(73);
	
	var _giles2 = _interopRequireDefault(_giles);
	
	var _gaz = __webpack_require__(48);
	
	var _gaz2 = _interopRequireDefault(_gaz);
	
	var _bjorn = __webpack_require__(47);
	
	var _bjorn2 = _interopRequireDefault(_bjorn);
	
	var _jose = __webpack_require__(49);
	
	var _jose2 = _interopRequireDefault(_jose);
	
	var _sarah = __webpack_require__(50);
	
	var _sarah2 = _interopRequireDefault(_sarah);
	
	var _sue = __webpack_require__(51);
	
	var _sue2 = _interopRequireDefault(_sue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// import jess from "../../img/avatars/jess.jpg";
	
	
	var Fragment = _react2.default.Fragment;
	
	
	var IntroPart3 = function IntroPart3(props) {
	  return _react2.default.createElement(
	    Fragment,
	    null,
	    _react2.default.createElement(
	      _rebass.Box,
	      { w: [1], mb: ["225px"], pb: [6], className: "relative" },
	      _react2.default.createElement(
	        _rebass.Box,
	        {
	          w: [1, 1, "432px"],
	          mx: [0, 0, "auto"],
	          mt: [0, 0, "100px"],
	          className: "relative"
	        },
	        _react2.default.createElement(
	          StyledHeading,
	          {
	            color: "support2",
	            className: "font-light relative",
	            is: "h4",
	            f: [3, 4, "26px"],
	            mb: [3]
	          },
	          _react2.default.createElement(AutomateIcon, { src: _automateIcon2.default, alt: "Automate icon", is: _reactImage2.default }),
	          "Automate your sales"
	        ),
	        _react2.default.createElement(
	          _rebass.Text,
	          { color: "support1", f: "15px", mb: [4] },
	          "Harness the power of our automated marketing platform by sending personalized messages and responses."
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { is: "a", href: props.siteMetadata.appUrl },
	          "GET STARTED FOR FREE"
	        )
	      ),
	      _react2.default.createElement(Section3Circle1, { r: 4 }),
	      _react2.default.createElement(Section3Circle2, { r: 5.5 }),
	      _react2.default.createElement(Section3Circle3, { r: 8 }),
	      _react2.default.createElement(Section3Circle4, { r: 13 }),
	      _react2.default.createElement(Section3Circle5, { r: 23 }),
	      _react2.default.createElement(Section3Circle6, { r: 9.5 }),
	      _react2.default.createElement(Section3Circle7, { r: 4.5 }),
	      _react2.default.createElement(
	        StyledMessengerBubble1,
	        null,
	        _react2.default.createElement(_MessengerBubble2.default, { message: "Hey Adam", src: _ads2.default })
	      ),
	      _react2.default.createElement(
	        StyledMessengerBubble2,
	        null,
	        _react2.default.createElement(_MessengerBubble2.default, { message: "Hello Giles", src: _giles2.default })
	      ),
	      _react2.default.createElement(
	        StyledMessengerBubble3,
	        null,
	        _react2.default.createElement(_MessengerBubble2.default, { message: "Hi Sarah", src: _sarah2.default })
	      ),
	      _react2.default.createElement(
	        StyledMessengerBubble4,
	        null,
	        _react2.default.createElement(_MessengerBubble2.default, { message: "Hola Jose", src: _jose2.default })
	      ),
	      _react2.default.createElement(
	        StyledMessengerBubble5,
	        null,
	        _react2.default.createElement(_MessengerBubble2.default, { message: "Hei Bj\xF6rn", src: _bjorn2.default })
	      ),
	      _react2.default.createElement(
	        StyledMessengerBubble6,
	        null,
	        _react2.default.createElement(_MessengerBubble2.default, { message: "Hey Gaz", src: _gaz2.default })
	      ),
	      _react2.default.createElement(
	        StyledMessengerBubble7,
	        null,
	        _react2.default.createElement(_MessengerBubble2.default, { message: "Howdy Sue", src: _sue2.default })
	      )
	    )
	  );
	};
	
	exports.default = IntroPart3;
	
	// Styled Components
	
	var AutomateIcon = (0, _styledComponents2.default)(_rebass.Image)(_templateObject);
	
	var StyledHeading = (0, _styledComponents2.default)(_rebass.Heading)(_templateObject2);
	
	var StyledMessengerBubble1 = _styledComponents2.default.div(_templateObject3);
	
	var StyledMessengerBubble2 = _styledComponents2.default.div(_templateObject4);
	
	var StyledMessengerBubble3 = _styledComponents2.default.div(_templateObject5);
	
	var StyledMessengerBubble4 = _styledComponents2.default.div(_templateObject6);
	
	var StyledMessengerBubble5 = _styledComponents2.default.div(_templateObject7);
	
	var StyledMessengerBubble6 = _styledComponents2.default.div(_templateObject8);
	
	var StyledMessengerBubble7 = _styledComponents2.default.div(_templateObject9);
	
	var Section3Circle1 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject10);
	
	var Section3Circle2 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject11);
	
	var Section3Circle3 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject12);
	
	var Section3Circle4 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject13);
	
	var Section3Circle5 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject14);
	
	var Section3Circle6 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject15);
	
	var Section3Circle7 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject16);
	module.exports = exports["default"];

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  min-height: 570px;\n  position: relative;\n\n  @media (min-width: 32em) {\n    min-height: 620px;\n  }\n\n  @media (min-width: 38em) {\n    min-height: 680px;\n  }\n\n  @media (min-width: 48em) {\n    min-height: 610px;\n  }\n\n  @media (min-width: 64em) {\n    min-height: 570px;\n  }\n"], ["\n  min-height: 570px;\n  position: relative;\n\n  @media (min-width: 32em) {\n    min-height: 620px;\n  }\n\n  @media (min-width: 38em) {\n    min-height: 680px;\n  }\n\n  @media (min-width: 48em) {\n    min-height: 610px;\n  }\n\n  @media (min-width: 64em) {\n    min-height: 570px;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  z-index: 2;\n"], ["\n  z-index: 2;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  right: -10px;\n  margin: 0;\n  position: absolute;\n  top: -104px;\n  transform: scale(0.8);\n\n  @media (min-width: 48em) {\n    right: auto;\n    left: 0;\n    top: -130px;\n    transform: scale(1);\n  }\n\n  @media (min-width: 64em) {\n    left: 120px;\n    top: -130px;\n  }\n"], ["\n  right: -10px;\n  margin: 0;\n  position: absolute;\n  top: -104px;\n  transform: scale(0.8);\n\n  @media (min-width: 48em) {\n    right: auto;\n    left: 0;\n    top: -130px;\n    transform: scale(1);\n  }\n\n  @media (min-width: 64em) {\n    left: 120px;\n    top: -130px;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: none;\n  opacity: 0.7;\n\n  @media (min-width: 64em) {\n    display: block;\n    left: 0;\n    position: absolute;\n    top: -260px;\n  }\n\n  @media (min-width: 90em) {\n    left: -7%;\n  }\n\n  @media (min-width: 100em) {\n    left: -20%;\n  }\n\n  @media (min-width: 110em) {\n    left: -35%;\n  }\n\n  @media (min-width: 10em) {\n    display: none;\n  }\n"], ["\n  display: none;\n  opacity: 0.7;\n\n  @media (min-width: 64em) {\n    display: block;\n    left: 0;\n    position: absolute;\n    top: -260px;\n  }\n\n  @media (min-width: 90em) {\n    left: -7%;\n  }\n\n  @media (min-width: 100em) {\n    left: -20%;\n  }\n\n  @media (min-width: 110em) {\n    left: -35%;\n  }\n\n  @media (min-width: 10em) {\n    display: none;\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  left: -425px;\n  position: relative;\n"], ["\n  left: -425px;\n  position: relative;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  left: -425px;\n  position: absolute;\n  top: 50%;\n"], ["\n  left: -425px;\n  position: absolute;\n  top: 50%;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 0;\n  top: 160px;\n  width: 842px;\n  z-index: 1;\n\n  @media (min-width: 32em) {\n    top: 110px;\n  }\n\n  @media (min-width: 48em) {\n    top: -70px;\n  }\n\n  @media (min-width: 56em) {\n    top: -130px;\n  }\n\n  @media (min-width: 64em) {\n    top: -170px;\n  }\n"], ["\n  position: absolute;\n  right: 0;\n  top: 160px;\n  width: 842px;\n  z-index: 1;\n\n  @media (min-width: 32em) {\n    top: 110px;\n  }\n\n  @media (min-width: 48em) {\n    top: -70px;\n  }\n\n  @media (min-width: 56em) {\n    top: -130px;\n  }\n\n  @media (min-width: 64em) {\n    top: -170px;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  bottom: 50px;\n  position: absolute;\n  right: 26%;\n  width: 186px;\n  z-index: 0;\n\n  @media (min-width: 48em) {\n    bottom: 80px;\n  }\n"], ["\n  bottom: 50px;\n  position: absolute;\n  right: 26%;\n  width: 186px;\n  z-index: 0;\n\n  @media (min-width: 48em) {\n    bottom: 80px;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactImage = __webpack_require__(8);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _Circle = __webpack_require__(6);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	var _Button = __webpack_require__(9);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _analyticsIcon = __webpack_require__(69);
	
	var _analyticsIcon2 = _interopRequireDefault(_analyticsIcon);
	
	var _analyticsBg = __webpack_require__(68);
	
	var _analyticsBg2 = _interopRequireDefault(_analyticsBg);
	
	var _analyticsMiniChart = __webpack_require__(70);
	
	var _analyticsMiniChart2 = _interopRequireDefault(_analyticsMiniChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var IntroPart4 = function IntroPart4(props) {
	  return _react2.default.createElement(
	    StyledFlex,
	    { w: [1] },
	    _react2.default.createElement(
	      ContentBox,
	      {
	        ml: ["auto", null, 0],
	        w: [1],
	        mb: [4, 4, 6],
	        pl: [0, 0, 0, "120px"],
	        className: "relative"
	      },
	      _react2.default.createElement(
	        LargeCircles,
	        null,
	        _react2.default.createElement(LargeCircle1, { r: 221.5 }),
	        _react2.default.createElement(LargeCircle2, { r: 221.5 })
	      ),
	      _react2.default.createElement(AnalyticsIcons, { src: _analyticsIcon2.default, alt: "Analytics icon", is: _reactImage2.default }),
	      _react2.default.createElement(
	        _rebass.Heading,
	        {
	          color: "support2",
	          className: "font-light text-right text-left-desktop",
	          is: "h4",
	          f: [3, 4, "26px"],
	          mb: [3]
	        },
	        "Perfect for sales, marketing, and business owners"
	      ),
	      _react2.default.createElement(
	        _rebass.Text,
	        {
	          color: "support1",
	          f: "15px",
	          className: "text-right text-left-desktop",
	          mb: [4],
	          w: [1, 1, 1, 1 / 2, "35%"]
	        },
	        "Pipeline has been built from the ground up with analytics to help you track your marketing spend."
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "text-right text-left-desktop" },
	        _react2.default.createElement(
	          _Button2.default,
	          { is: "a", href: props.siteMetadata.appUrl },
	          "GET STARTED FOR FREE"
	        )
	      )
	    ),
	    _react2.default.createElement(AnalyticsBg, { src: _analyticsBg2.default, alt: "user chart diagram", is: _reactImage2.default }),
	    _react2.default.createElement(AnalyticsMiniChart, {
	      src: _analyticsMiniChart2.default,
	      alt: "analytics mini chart",
	      is: _reactImage2.default
	    })
	  );
	};
	
	exports.default = IntroPart4;
	
	// Styled Components
	
	var StyledFlex = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject);
	
	var ContentBox = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2);
	
	var AnalyticsIcons = (0, _styledComponents2.default)(_rebass.Image)(_templateObject3);
	
	var LargeCircles = _styledComponents2.default.div(_templateObject4);
	
	var LargeCircle1 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject5);
	
	var LargeCircle2 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject6);
	
	var AnalyticsBg = (0, _styledComponents2.default)(_rebass.Image)(_templateObject7);
	
	var AnalyticsMiniChart = (0, _styledComponents2.default)(_rebass.Image)(_templateObject8);
	module.exports = exports["default"];

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  @media (min-width: 48em) {\n    display: none;\n  }\n"], ["\n  @media (min-width: 48em) {\n    display: none;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: #fff !important;\n  display: inline-block !important;\n  font-size: 14px;\n  font-weight: 400;\n  margin: 15px 0;\n  padding: 12px 11px 11px;\n  text-align: left;\n"], ["\n  color: #fff !important;\n  display: inline-block !important;\n  font-size: 14px;\n  font-weight: 400;\n  margin: 15px 0;\n  padding: 12px 11px 11px;\n  text-align: left;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  color: #fff;\n  font-size: 15px;\n  text-decoration: none;\n\n  &:visited,\n  &:active {\n    color: #fff;\n  }\n"], ["\n  color: #fff;\n  font-size: 15px;\n  text-decoration: none;\n\n  &:visited,\n  &:active {\n    color: #fff;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  opacity: 0.3;\n  position: absolute;\n  right: -30px;\n  top: -30px;\n"], ["\n  opacity: 0.3;\n  position: absolute;\n  right: -30px;\n  top: -30px;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  opacity: 0.3;\n  position: absolute;\n  left: -90px;\n  bottom: -90px;\n"], ["\n  opacity: 0.3;\n  position: absolute;\n  left: -90px;\n  bottom: -90px;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  opacity: 0.2;\n  position: absolute;\n  left: 150px;\n  top: 60px;\n"], ["\n  opacity: 0.2;\n  position: absolute;\n  left: 150px;\n  top: 60px;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  text-decoration: none;\n"], ["\n  font-size: 14px;\n  text-decoration: none;\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  height: 13px;\n  position: relative;\n  top: 2px;\n"], ["\n  height: 13px;\n  position: relative;\n  top: 2px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(181);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(3);
	
	var _reactBurgerMenu = __webpack_require__(574);
	
	var _reactImage = __webpack_require__(8);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _index = __webpack_require__(15);
	
	var _FacebookButton = __webpack_require__(31);
	
	var _FacebookButton2 = _interopRequireDefault(_FacebookButton);
	
	var _Navbar = __webpack_require__(151);
	
	var _logoWhite = __webpack_require__(305);
	
	var _logoWhite2 = _interopRequireDefault(_logoWhite);
	
	__webpack_require__(449);
	
	var _Circle = __webpack_require__(6);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	var _facebookMessenger = __webpack_require__(37);
	
	var _facebookMessenger2 = _interopRequireDefault(_facebookMessenger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileNav = function (_React$Component) {
	  _inherits(MobileNav, _React$Component);
	
	  function MobileNav(props) {
	    _classCallCheck(this, MobileNav);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.toggleMenu = function (toggle) {
	      _this.setState({
	        menuActive: toggle
	      });
	    };
	
	    _this.state = {
	      menuActive: false
	    };
	    return _this;
	  }
	
	  MobileNav.prototype.render = function render() {
	    var user = this.props.user;
	
	    return _react2.default.createElement(
	      MenuWrap,
	      { ml: "auto" },
	      this.props.user && _react2.default.createElement(
	        _rebass.Box,
	        { mr: "30px" },
	        _react2.default.createElement(
	          DemoLink,
	          { href: user.demoLink, target: "_blank" },
	          _react2.default.createElement(StyledMessengerLogo, { src: _facebookMessenger2.default, alt: "Messenger Logo" }),
	          " ",
	          "Demo"
	        )
	      ),
	      _react2.default.createElement(
	        _reactBurgerMenu.slide,
	        { isOpen: this.state.menuActive, right: true, width: "280px" },
	        _react2.default.createElement("img", { src: _logoWhite2.default, alt: "Pipeline Logo", height: "27" }),
	        _react2.default.createElement(
	          StyledLink,
	          { to: "/", color: "white", is: _gatsbyLink2.default, mt: "15px", mb: "10px" },
	          "Home"
	        ),
	        _Navbar.navLinks.map(function (link, i) {
	          return _react2.default.createElement(
	            StyledLink,
	            {
	              key: i,
	              to: link.path,
	              color: "white",
	              is: _gatsbyLink2.default,
	              mb: "10px"
	            },
	            link.label
	          );
	        }),
	        _react2.default.createElement(
	          StyledFacebookButton,
	          { is: "a", href: this.props.siteMetadata.appUrl },
	          "Login with Facebook"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "fb-plugin" },
	          _react2.default.createElement("div", {
	            className: "fb-messengermessageus",
	            messenger_app_id: "137853846788998",
	            page_id: "227754084405138",
	            color: "blue",
	            "data-size": "xlarge"
	          })
	        ),
	        _react2.default.createElement(Circle1, { r: 40 }),
	        _react2.default.createElement(Circle2, { r: 100 }),
	        _react2.default.createElement(Circle3, { r: 6 })
	      )
	    );
	  };
	
	  return MobileNav;
	}(_react2.default.Component);
	
	exports.default = MobileNav;
	
	// Styled Components
	
	var MenuWrap = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	
	var StyledFacebookButton = (0, _styledComponents2.default)(_FacebookButton2.default)(_templateObject2);
	
	var StyledLink = (0, _styledComponents2.default)(_rebass.Link)(_templateObject3);
	
	var Circle1 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject4);
	
	var Circle2 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject5);
	
	var Circle3 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject6);
	
	var DemoLink = _styledComponents2.default.a(_templateObject7);
	
	var StyledMessengerLogo = (0, _styledComponents2.default)(_reactImage2.default)(_templateObject8);
	module.exports = exports["default"];

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navLinks = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  height: 56px;\n  position: relative;\n  z-index: 2;\n\n  @media (min-width: 48em) {\n    height: auto;\n    margin-bottom: 20px;\n    padding: 20px 0 0;\n  }\n"], ["\n  height: 56px;\n  position: relative;\n  z-index: 2;\n\n  @media (min-width: 48em) {\n    height: auto;\n    margin-bottom: 20px;\n    padding: 20px 0 0;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: none;\n\n  @media (min-width: 48em) {\n    display: block;\n  }\n"], ["\n  display: none;\n\n  @media (min-width: 48em) {\n    display: block;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  height: 54px;\n  line-height: 54px;\n  text-align: center;\n  text-shadow: 1px 1px #fafafa;\n"], ["\n  height: 54px;\n  line-height: 54px;\n  text-align: center;\n  text-shadow: 1px 1px #fafafa;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  line-height: 56px;\n"], ["\n  line-height: 56px;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  @media (min-width: 52em) {\n    font-size: 15px;\n  }\n"], ["\n  font-size: 14px;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  @media (min-width: 52em) {\n    font-size: 15px;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-family: \"Open Sans\", \"Helvetica\", \"Arial\", sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  text-decoration: none;\n\n  &:visited {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  font-family: \"Open Sans\", \"Helvetica\", \"Arial\", sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  text-decoration: none;\n\n  &:visited {\n    color: ", ";\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  margin-left: 3px;\n  position: relative;\n  top: 3px;\n  width: 19px;\n"], ["\n  margin-left: 3px;\n  position: relative;\n  top: 3px;\n  width: 19px;\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  color: #fff !important;\n  font-size: 13px;\n  margin: 0;\n  padding: 13px 15px 13px;\n  text-transform: uppercase;\n\n  svg {\n    position: relative;\n    top: -1px;\n  }\n"], ["\n  color: #fff !important;\n  font-size: 13px;\n  margin: 0;\n  padding: 13px 15px 13px;\n  text-transform: uppercase;\n\n  svg {\n    position: relative;\n    top: -1px;\n  }\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  height: 45px;\n  padding: 11px 15px 13px;\n\n  img {\n    top: 3.9px;\n    width: 13px;\n  }\n"], ["\n  height: 45px;\n  padding: 11px 15px 13px;\n\n  img {\n    top: 3.9px;\n    width: 13px;\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -webkit-user-select: none;\n  color: ", "!important;\n  font-family: \"PT Sans\", sans-serif;\n  font-weight: 600;\n  text-decoration: none;\n  text-shadow: 1px 1px #fafafa;\n  user-select: none;\n\n  img {\n    margin: 17px 0 0;\n  }\n"], ["\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -webkit-user-select: none;\n  color: ", "!important;\n  font-family: \"PT Sans\", sans-serif;\n  font-weight: 600;\n  text-decoration: none;\n  text-shadow: 1px 1px #fafafa;\n  user-select: none;\n\n  img {\n    margin: 17px 0 0;\n  }\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  display: none;\n  text-align: right;\n\n  @media (min-width: 48em) {\n    display: block;\n  }\n"], ["\n  display: none;\n  text-align: right;\n\n  @media (min-width: 48em) {\n    display: block;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(181);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(3);
	
	var _reactImage = __webpack_require__(8);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _index = __webpack_require__(15);
	
	var _FacebookButton = __webpack_require__(31);
	
	var _FacebookButton2 = _interopRequireDefault(_FacebookButton);
	
	var _MobileNav = __webpack_require__(319);
	
	var _MobileNav2 = _interopRequireDefault(_MobileNav);
	
	var _logo = __webpack_require__(213);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _facebookIcon = __webpack_require__(52);
	
	var _facebookIcon2 = _interopRequireDefault(_facebookIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var navLinks = exports.navLinks = [
	// {
	//   label: "Why",
	//   path: "/why"
	// },
	{
	  label: "Pricing",
	  path: "/pricing"
	}, {
	  label: "Contact",
	  path: "/contact"
	}];
	
	var Navbar = function Navbar(_ref) {
	  var siteMetadata = _ref.siteMetadata,
	      user = _ref.user;
	  return _react2.default.createElement(
	    NavBar,
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        _rebass.Flex,
	        { align: "center" },
	        _react2.default.createElement(
	          LogoBox,
	          { mr: [0, 0, "25px"] },
	          _react2.default.createElement(
	            Logo,
	            { to: "/", is: _gatsbyLink2.default },
	            _react2.default.createElement("img", { src: _logo2.default, alt: "Pipeline", height: "27" })
	          )
	        ),
	        _react2.default.createElement(
	          NavItems,
	          { w: ["340px"], mr: [0, 0, "auto"] },
	          _react2.default.createElement(
	            _rebass.Flex,
	            { align: "center" },
	            navLinks.map(function (link, i) {
	              return _react2.default.createElement(
	                NavBox,
	                { pr: [2, 2, "10px"], pl: i === 0 ? 0 : "10px", key: i },
	                _react2.default.createElement(
	                  NavLink,
	                  { to: link.path },
	                  link.label
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          ControlBox,
	          null,
	          _react2.default.createElement(
	            LoginLink,
	            { href: siteMetadata.appUrl, mb: [0, 2, 3, 4] },
	            "Login with ",
	            _react2.default.createElement(StyledFbIcon, { src: _facebookIcon2.default })
	          )
	        ),
	        user && _react2.default.createElement(
	          ControlBox,
	          { ml: [3] },
	          _react2.default.createElement(
	            StyledMessengerButton,
	            {
	              is: "a",
	              href: user.demoLink,
	              type: "messenger",
	              mb: [0, 2, 3, 4],
	              target: "_blank"
	            },
	            "Try Live Demo"
	          )
	        ),
	        _react2.default.createElement(_MobileNav2.default, { siteMetadata: siteMetadata, user: user })
	      )
	    )
	  );
	};
	
	exports.default = Navbar;
	
	// Styled Components
	
	var NavBar = _styledComponents2.default.nav(_templateObject);
	
	var NavItems = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2);
	
	var NavBox = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3);
	
	var LogoBox = NavBox.extend(_templateObject4);
	
	var NavLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject5);
	
	var LoginLink = _styledComponents2.default.a(_templateObject6, function (p) {
	  return p.theme.colors.facebookBlue;
	}, function (p) {
	  return p.theme.colors.facebookBlue;
	});
	
	var StyledFbIcon = (0, _styledComponents2.default)(_reactImage2.default)(_templateObject7);
	
	var StyledFacebookButton = (0, _styledComponents2.default)(_FacebookButton2.default)(_templateObject8);
	
	var StyledMessengerButton = StyledFacebookButton.extend(_templateObject9);
	
	var Logo = (0, _styledComponents2.default)(_rebass.Text)(_templateObject10, function (p) {
	  return p.theme.colors.support2;
	});
	
	var ControlBox = (0, _styledComponents2.default)(_rebass.Box)(_templateObject11);

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  height: auto;\n  max-width: 80px;\n  opacity: 0.8;\n  width: 100%;\n"], ["\n  height: auto;\n  max-width: 80px;\n  opacity: 0.8;\n  width: 100%;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: #8d9db9;\n  text-decoration: none;\n  transition: all 300ms ease-in-out;\n\n  &:visited {\n    color: #8d9db9;\n  }\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  color: #8d9db9;\n  text-decoration: none;\n  transition: all 300ms ease-in-out;\n\n  &:visited {\n    color: #8d9db9;\n  }\n\n  &:hover {\n    color: ", ";\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  background-size: 100%;\n"], ["\n  background-size: 100%;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  background: url(", ") no-repeat bottom left;\n"], ["\n  background: url(", ") no-repeat bottom left;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 1;\n"], ["\n  position: relative;\n  z-index: 1;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _index = __webpack_require__(15);
	
	var _facebookIcon = __webpack_require__(52);
	
	var _facebookIcon2 = _interopRequireDefault(_facebookIcon);
	
	var _facebookMessenger = __webpack_require__(37);
	
	var _facebookMessenger2 = _interopRequireDefault(_facebookMessenger);
	
	var _slack = __webpack_require__(90);
	
	var _slack2 = _interopRequireDefault(_slack);
	
	var _salesforce = __webpack_require__(81);
	
	var _salesforce2 = _interopRequireDefault(_salesforce);
	
	var _shopify = __webpack_require__(89);
	
	var _shopify2 = _interopRequireDefault(_shopify);
	
	var _zapier = __webpack_require__(91);
	
	var _zapier2 = _interopRequireDefault(_zapier);
	
	var _serviceBg = __webpack_require__(83);
	
	var _serviceBg2 = _interopRequireDefault(_serviceBg);
	
	var _serviceBg3 = __webpack_require__(84);
	
	var _serviceBg4 = _interopRequireDefault(_serviceBg3);
	
	var _serviceBg5 = __webpack_require__(85);
	
	var _serviceBg6 = _interopRequireDefault(_serviceBg5);
	
	var _serviceBg7 = __webpack_require__(86);
	
	var _serviceBg8 = _interopRequireDefault(_serviceBg7);
	
	var _serviceBg9 = __webpack_require__(87);
	
	var _serviceBg10 = _interopRequireDefault(_serviceBg9);
	
	var _serviceBg11 = __webpack_require__(88);
	
	var _serviceBg12 = _interopRequireDefault(_serviceBg11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var propsToOmit = ["siteMetadata"];
	var px = [4, 4, 5, 4];
	var mb = [4, 4, 0];
	
	var Proof = function Proof(props) {
	  return _react2.default.createElement(
	    WrapBox,
	    (0, _lodash2.default)(props, propsToOmit),
	    _react2.default.createElement(
	      _rebass.Container,
	      null,
	      _react2.default.createElement(
	        _rebass.Heading,
	        {
	          center: true,
	          mb: [5, 4, 5],
	          f: [3, 3, "26px"],
	          px: [2],
	          color: "support2",
	          className: "font-light"
	        },
	        "Works in conjunction with\u2026"
	      ),
	      _react2.default.createElement(
	        _rebass.Flex,
	        { wrap: true, align: "center", justify: "center", mb: [4, 4, 4, 5] },
	        _react2.default.createElement(
	          Box1,
	          { flex: "1 1 auto", className: "text-center", px: px, mb: mb },
	          _react2.default.createElement(Customer, { src: _facebookIcon2.default, alt: "facebook logo" })
	        ),
	        _react2.default.createElement(
	          Box2,
	          { flex: "1 1 auto", className: "text-center", px: px, mb: mb },
	          _react2.default.createElement(Customer, { src: _facebookMessenger2.default, alt: "facebook messenger logo" })
	        ),
	        _react2.default.createElement(
	          Box3,
	          { flex: "1 1 auto", className: "text-center", px: px, mb: mb },
	          _react2.default.createElement(Customer, { src: _shopify2.default, alt: "shopify logo" })
	        ),
	        _react2.default.createElement(
	          Box4,
	          { flex: "1 1 auto", className: "text-center", px: px, mb: mb },
	          _react2.default.createElement(
	            _rebass.Tooltip,
	            { text: "Enterprise Plan" },
	            _react2.default.createElement(Customer, { src: _slack2.default, alt: "slack logo" })
	          )
	        ),
	        _react2.default.createElement(
	          Box5,
	          { flex: "1 1 auto", className: "text-center", px: px, mb: mb },
	          _react2.default.createElement(
	            _rebass.Tooltip,
	            { text: "Enterprise Plan" },
	            _react2.default.createElement(Customer, { src: _zapier2.default, alt: "zapier logo" })
	          )
	        ),
	        _react2.default.createElement(
	          Box6,
	          { flex: "1 1 auto", className: "text-center", px: px, mb: mb },
	          _react2.default.createElement(
	            _rebass.Tooltip,
	            { text: "Enterprise Plan" },
	            _react2.default.createElement(Customer, { src: _salesforce2.default, alt: "salesforce logo" })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _rebass.Text,
	        { center: true, className: "font-light" },
	        "And many more!\xA0",
	        _react2.default.createElement(
	          StyledLink,
	          { href: props.siteMetadata.appUrl },
	          "Ready to try?"
	        )
	      )
	    )
	  );
	};
	
	exports.default = Proof;
	
	// Styled Components
	
	var Customer = _styledComponents2.default.img(_templateObject);
	
	var StyledLink = (0, _styledComponents2.default)(_rebass.Link)(_templateObject2, function (p) {
	  return p.theme.colors.primary;
	});
	
	var StyledBox = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3);
	
	var Box1 = StyledBox.extend(_templateObject4, _serviceBg2.default);
	
	var Box2 = StyledBox.extend(_templateObject4, _serviceBg4.default);
	
	var Box3 = StyledBox.extend(_templateObject4, _serviceBg6.default);
	
	var Box4 = StyledBox.extend(_templateObject4, _serviceBg8.default);
	
	var Box5 = StyledBox.extend(_templateObject4, _serviceBg10.default);
	var Box6 = StyledBox.extend(_templateObject4, _serviceBg12.default);
	
	var WrapBox = (0, _styledComponents2.default)(_rebass.Box)(_templateObject5);
	module.exports = exports["default"];

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n  line-height: 1.2;\n"], ["\n  font-weight: 600;\n  line-height: 1.2;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-weight: 300;\n"], ["\n  font-weight: 300;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  opacity: 0.9;\n  position: relative;\n  z-index: 1;\n\n  &:before {\n    border: 1px solid rgba(151, 151, 151, 0.06);\n    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);\n    content: \"\";\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: #f8fbfd;\n    -ms-transform: skewY(-3deg);\n    transform: skewY(-3deg);\n    z-index: 0;\n    top: 0;\n    z-index: 1;\n  }\n\n  .container {\n    position: relative;\n    z-index: 2;\n  }\n"], ["\n  opacity: 0.9;\n  position: relative;\n  z-index: 1;\n\n  &:before {\n    border: 1px solid rgba(151, 151, 151, 0.06);\n    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);\n    content: \"\";\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: #f8fbfd;\n    -ms-transform: skewY(-3deg);\n    transform: skewY(-3deg);\n    z-index: 0;\n    top: 0;\n    z-index: 1;\n  }\n\n  .container {\n    position: relative;\n    z-index: 2;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  left: 0;\n  opacity: 0.9;\n  position: absolute;\n  top: -68px;\n  transform: scale(0.4);\n\n  @media (min-width: 48em) {\n    transform: scale(0.6);\n  }\n\n  @media (min-width: 56em) {\n    top: -68px;\n    transform: scale(1);\n  }\n"], ["\n  left: 0;\n  opacity: 0.9;\n  position: absolute;\n  top: -68px;\n  transform: scale(0.4);\n\n  @media (min-width: 48em) {\n    transform: scale(0.6);\n  }\n\n  @media (min-width: 56em) {\n    top: -68px;\n    transform: scale(1);\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  bottom: -100px;\n  left: auto;\n  right: 20px;\n  top: auto;\n  transform: rotate(200deg) scale(0.5);\n\n  @media (min-width: 48em) {\n    transform: rotate(200deg) scale(0.6);\n  }\n"], ["\n  bottom: -100px;\n  left: auto;\n  right: 20px;\n  top: auto;\n  transform: rotate(200deg) scale(0.5);\n\n  @media (min-width: 48em) {\n    transform: rotate(200deg) scale(0.6);\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  left: -25px;\n  position: absolute;\n  top: 50px;\n  }\n"], ["\n  left: -25px;\n  position: absolute;\n  top: 50px;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  left: 15px;\n  position: absolute;\n  top: 60px;\n"], ["\n  left: 15px;\n  position: absolute;\n  top: 60px;\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  left: 65px;\n  position: absolute;\n  top: 70px;\n"], ["\n  left: 65px;\n  position: absolute;\n  top: 70px;\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  left: 20%;\n  position: absolute;\n  top: 0;\n"], ["\n  left: 20%;\n  position: absolute;\n  top: 0;\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 10%;\n  top: -20px;\n"], ["\n  position: absolute;\n  right: 10%;\n  top: -20px;\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  bottom: -34px;\n  position: absolute;\n  right: 25%;\n"], ["\n  bottom: -34px;\n  position: absolute;\n  right: 25%;\n"]);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rebass = __webpack_require__(3);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _index = __webpack_require__(15);
	
	var _Button = __webpack_require__(9);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Circle = __webpack_require__(6);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var propsToOmit = ["siteMetadata"];
	
	var Stats = function Stats(props) {
	  return React.createElement(
	    StyledBox,
	    (0, _lodash2.default)(props, propsToOmit),
	    React.createElement(
	      "div",
	      { className: "container" },
	      React.createElement(
	        _rebass.Heading,
	        {
	          center: true,
	          mb: [3],
	          f: [3, 3, 4, 5],
	          px: [2],
	          color: "support2",
	          className: "font-light"
	        },
	        "Grow your business with Facebook Messenger\u2026"
	      ),
	      React.createElement(
	        StyledSubhead,
	        {
	          is: "p",
	          mb: [4, 4, 5],
	          f: ["14px", "15px", "15px"],
	          center: true,
	          color: "support1"
	        },
	        "Pipeline allows you to harness the power of Facebook Messenger and tap into over 1.3 billion active users."
	      ),
	      React.createElement(
	        _rebass.Flex,
	        { mb: [4, 4, 5], wrap: true },
	        React.createElement(
	          _rebass.Box,
	          { w: [1, 1, 1 / 3], mb: [4, 4, 0], className: "relative" },
	          React.createElement(
	            Stat,
	            { center: true, f: [5, 5, 6, 7], color: "support3", mb: [2] },
	            "2 Billion"
	          ),
	          React.createElement(
	            _rebass.Text,
	            {
	              center: true,
	              f: ["12px", 2, 3],
	              color: "support2",
	              className: "font-light"
	            },
	            "Messages Sent/Month"
	          ),
	          React.createElement(
	            CirclePointer,
	            null,
	            React.createElement(CircleInner1, { r: 14.5 }),
	            React.createElement(CircleInner2, { r: 20.5 }),
	            React.createElement(CircleInner3, { r: 38 })
	          )
	        ),
	        React.createElement(
	          _rebass.Box,
	          { w: [1, 1, 1 / 3], mb: [4, 4, 0], className: "relative" },
	          React.createElement(
	            Stat,
	            { center: true, f: [5, 5, 6, 7], color: "support3", mb: [2] },
	            "1.3 Billion"
	          ),
	          React.createElement(
	            _rebass.Text,
	            {
	              center: true,
	              f: ["12px", 2, 3],
	              color: "support2",
	              className: "font-light"
	            },
	            "Active Messenger Users"
	          ),
	          React.createElement(SubscriberCircle1, { r: 8.5 }),
	          React.createElement(SubscriberCircle2, { r: 18.5 }),
	          React.createElement(SubscriberCircle3, { r: 13.5 })
	        ),
	        React.createElement(
	          _rebass.Box,
	          { w: [1, 1, 1 / 3], mb: [4, 4, 0], className: "relative" },
	          React.createElement(
	            Stat,
	            { center: true, f: [5, 5, 6, 7], color: "support3", mb: [2] },
	            "Over 80%"
	          ),
	          React.createElement(
	            _rebass.Text,
	            {
	              center: true,
	              f: ["12px", 2, 3],
	              color: "support2",
	              className: "font-light"
	            },
	            "Open Rates"
	          ),
	          React.createElement(
	            CirclePointer2,
	            null,
	            React.createElement(CircleInner1, { r: 14.5 }),
	            React.createElement(CircleInner2, { r: 20.5 }),
	            React.createElement(CircleInner3, { r: 38 })
	          )
	        )
	      ),
	      React.createElement(
	        _rebass.Text,
	        { center: true },
	        React.createElement(
	          _Button2.default,
	          { is: "a", href: props.siteMetadata.appUrl },
	          "GET STARTED FOR FREE"
	        )
	      )
	    )
	  );
	};
	
	exports.default = Stats;
	
	// Styled Components
	
	var Stat = (0, _styledComponents2.default)(_rebass.Text)(_templateObject);
	
	var StyledSubhead = (0, _styledComponents2.default)(_rebass.Subhead)(_templateObject2);
	
	var StyledBox = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3);
	
	var CirclePointer = _styledComponents2.default.div(_templateObject4);
	
	var CirclePointer2 = CirclePointer.extend(_templateObject5);
	
	var CircleInner1 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject6);
	
	var CircleInner2 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject7);
	
	var CircleInner3 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject8);
	
	var SubscriberCircle1 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject9);
	
	var SubscriberCircle2 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject10);
	
	var SubscriberCircle3 = (0, _styledComponents2.default)(_Circle2.default)(_templateObject11);
	module.exports = exports["default"];

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 40px;\n"], ["\n  position: relative;\n  width: 40px;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  border: 1px solid rgba(77, 80, 82, 0.13);\n  box-shadow: 0 -1px 2px 0 rgba(0, 0, 0, 0.08);\n  border-radius: 100%;\n  height: 40px;\n  opacity: 0.73;\n  width: 40px;\n"], ["\n  border: 1px solid rgba(77, 80, 82, 0.13);\n  box-shadow: 0 -1px 2px 0 rgba(0, 0, 0, 0.08);\n  border-radius: 100%;\n  height: 40px;\n  opacity: 0.73;\n  width: 40px;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  bottom: 6px;\n  position: absolute;\n  right: -2px;\n"], ["\n  bottom: 6px;\n  position: absolute;\n  right: -2px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactImage = __webpack_require__(8);
	
	var _reactImage2 = _interopRequireDefault(_reactImage);
	
	var _fbmMiniLogo = __webpack_require__(75);
	
	var _fbmMiniLogo2 = _interopRequireDefault(_fbmMiniLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var propsToOmit = ["src"];
	
	var User = function User(props) {
	  return _react2.default.createElement(
	    Wrap,
	    (0, _lodash2.default)(props, propsToOmit),
	    _react2.default.createElement(StyledImg, { src: props.src }),
	    _react2.default.createElement(FbmLogo, { src: _fbmMiniLogo2.default, alt: "Facebook Messenger", className: "user-fbm-logo" })
	  );
	};
	
	exports.default = User;
	
	// Styled Components
	
	var Wrap = _styledComponents2.default.div(_templateObject);
	
	var StyledImg = (0, _styledComponents2.default)(_reactImage2.default)(_templateObject2);
	
	var FbmLogo = (0, _styledComponents2.default)(_reactImage2.default)(_templateObject3);
	module.exports = exports["default"];

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(542);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(125);
	
	var _pl = __webpack_require__(337);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Fragment = _react2.default.Fragment;
	
	// 1. [x]  Check storage for existing user
	// 2. [ ]  Create new user
	// 3. [ ]  Setup m.me links, pass through context
	
	var UserProvider = function (_Component) {
	  _inherits(UserProvider, _Component);
	
	  function UserProvider() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserProvider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      user: null,
	      error: ""
	    }, _this.setUser = function (user) {
	      _this.setState({
	        user: user
	      });
	    }, _this.createUser = function (user) {
	      // Store the user in state
	      _this.setUser(user);
	
	      // Alias and identify them in Mixpanel
	      _this.context.mixpanel.alias(user.leadId);
	      // this.context.mixpanel.identify(user.leadId);
	
	      // Save the user to localStorage
	      window.localStorage.setItem("_PL_meta", JSON.stringify(user));
	    }, _this.requestUser = function () {
	      // Get ref from querystring
	      var ref = (0, _pl.getParameterByName)("ref") || "";
	
	      var endpoint = _config.isProduction ? "https://api.pipeline.social/leads/init/pipeline/" + ref : "https://dev.api.pipeline.social/leads/init/pipeline/" + ref;
	
	      fetch(endpoint, {
	        method: "GET"
	      }).then(function (response) {
	        return response.ok ? response.json() : new Error("Network response was not ok.");
	      }).then(function (response) {
	        // If we have a demoLink and a leadId...
	        if ((0, _lodash2.default)(response, "demoLink") && (0, _lodash2.default)(response, "leadId")) {
	          _this.createUser(response);
	        } else {
	          throw new Error("No user data returned");
	        }
	      }).catch(function (error) {
	        return _this.setState({
	          error: error
	        });
	      });
	    }, _this.initUser = function () {
	      var user = _this.checkForExistingUser();
	
	      // If we have an existing user...
	      if (user) {
	        // Store them in state
	        _this.setUser(user);
	        // Identify them in Mixpanel
	        // this.context.mixpanel.identify(user.leadId);
	        _this.context.mixpanel.alias(user.leadId);
	      } else {
	        // If not create a new user
	        _this.requestUser();
	      }
	    }, _this.checkForExistingUser = function () {
	      var user = window.localStorage.getItem("_PL_meta") ? JSON.parse(window.localStorage.getItem("_PL_meta")) : {};
	
	      return {}.hasOwnProperty.call(user, "leadId") ? user : null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  UserProvider.prototype.componentDidMount = function componentDidMount() {
	    this.initUser();
	  };
	
	  UserProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      Fragment,
	      null,
	      this.props.render(this.state.user)
	    );
	  };
	
	  return UserProvider;
	}(_react.Component);
	
	UserProvider.contextTypes = { mixpanel: _propTypes2.default.object.isRequired };
	
	exports.default = UserProvider;
	module.exports = exports["default"];

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: #ffffff;\n  border-radius: 15px;\n  border: 1px solid rgba(151, 151, 151, 0.06);\n  box-shadow: 1px 1px 1px 0 rgba(255, 255, 255, 0.59),\n    inset 1px 1px 3px 0 rgba(0, 0, 0, 0.07);\n  display: inline-block;\n  height: 60px;\n  padding: 10px;\n"], ["\n  background: #ffffff;\n  border-radius: 15px;\n  border: 1px solid rgba(151, 151, 151, 0.06);\n  box-shadow: 1px 1px 1px 0 rgba(255, 255, 255, 0.59),\n    inset 1px 1px 3px 0 rgba(0, 0, 0, 0.07);\n  display: inline-block;\n  height: 60px;\n  padding: 10px;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  background: #f1f0f0;\n  border-radius: 17.86px;\n  color: #000000;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica,\n    Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 16px;\n  height: 40px;\n  letter-spacing: -0.42px;\n  line-height: 40px;\n  padding: 0 15px;\n"], ["\n  background: #f1f0f0;\n  border-radius: 17.86px;\n  color: #000000;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica,\n    Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 16px;\n  height: 40px;\n  letter-spacing: -0.42px;\n  line-height: 40px;\n  padding: 0 15px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(3);
	
	var _User = __webpack_require__(39);
	
	var _User2 = _interopRequireDefault(_User);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var MessengerBubble = function MessengerBubble(_ref) {
	  var _ref$src = _ref.src,
	      src = _ref$src === undefined ? "https://randomuser.me/api/portraits/women/65.jpg" : _ref$src,
	      _ref$message = _ref.message,
	      message = _ref$message === undefined ? "Hello Sarah" : _ref$message;
	  return _react2.default.createElement(
	    Greeting,
	    null,
	    _react2.default.createElement(
	      _rebass.Flex,
	      null,
	      _react2.default.createElement(
	        _rebass.Box,
	        { pr: ["10px"] },
	        _react2.default.createElement(_User2.default, { src: src })
	      ),
	      _react2.default.createElement(
	        _rebass.Box,
	        null,
	        _react2.default.createElement(
	          ChatBubble,
	          null,
	          message,
	          "\u2026"
	        )
	      )
	    )
	  );
	};
	
	exports.default = MessengerBubble;
	
	// Styled Components
	
	var Greeting = _styledComponents2.default.div(_templateObject);
	
	var ChatBubble = (0, _styledComponents2.default)(_rebass.Text)(_templateObject2);
	module.exports = exports["default"];

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/FB-Users.64e1d1ef.png";

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/analytics-bg.9b2d7252.jpg";

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTgiIGhlaWdodD0iMTA3IiB2aWV3Qm94PSIwIDAgNTggMTA3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGNpcmNsZSBzdHJva2Utb3BhY2l0eT0iLjMiIHN0cm9rZT0iIzAwODRGRiIgZmlsbD0iI0ZGRiIgb3BhY2l0eT0iLjciIGN4PSIyOCIgY3k9Ijc3IiByPSIyOCIvPjxwYXRoIGQ9Ik0xNy4zIDc3Ljh2OS4xYS42LjYgMCAwIDEtMS4yIDB2LTkuMWEuNi42IDAgMCAxIDEuMiAwem00LTQuM2MtLjQgMC0uNy4yLS43LjZ2MTIuOGEuNi42IDAgMCAwIDEuMiAwVjc0LjFjMC0uNC0uMi0uNi0uNi0uNnptNC40IDMuN2MtLjMgMC0uNi4yLS42LjZ2OS4xYS42LjYgMCAwIDAgMS4yIDB2LTkuMWMwLS4zLS4yLS42LS42LS42ek0zMC4yIDY2Yy0uMyAwLS42LjItLjYuNnYyMC4yYS42LjYgMCAwIDAgMS4yIDBWNjYuN2MwLS40LS4yLS42LS41LS42em00LjUgMy43Yy0uMyAwLS42LjItLjYuNnYxNi41YS42LjYgMCAwIDAgMS4yIDBWNzAuNGMwLS40LS4yLS42LS41LS42em00LjUgMTFjLS4zIDAtLjYuMy0uNi43djUuNGEuNi42IDAgMCAwIDEuMiAwdi01LjRjMC0uMy0uMi0uNi0uNS0uNnoiIGZpbGw9IiMwMDg0RkYiIGZpbGwtb3BhY2l0eT0iLjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQpIiBmaWxsPSIjRkZGIiBvcGFjaXR5PSIuNyIgc3Ryb2tlPSIjMDA4NEZGIiBzdHJva2Utb3BhY2l0eT0iLjMiPjxjaXJjbGUgY3g9IjEzIiBjeT0iMjkiIHI9IjkiLz48Y2lyY2xlIGN4PSI1IiBjeT0iNSIgcj0iNSIvPjwvZz48L2c+PC9zdmc+"

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTEiIGhlaWdodD0iODYiIHZpZXdCb3g9IjAgMCA5MSA4NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxjaXJjbGUgc3Ryb2tlLW9wYWNpdHk9Ii4zIiBzdHJva2U9IiMwMDg0RkYiIGZpbGw9IiNGRkYiIG9wYWNpdHk9Ii43IiBjeD0iNjEiIGN5PSI1NiIgcj0iMjgiLz48cGF0aCBkPSJNNzUuMyA1Ni44aC05LjVjLS40IDAtLjcuMi0uOC41YTQuMiA0LjIgMCAwIDEtOCAwYy0uMS0uMy0uNC0uNS0uOC0uNWgtOS41Yy0uNCAwLS43LjMtLjcuOFY2OGMwIC40LjMuNy44LjdoMjguNWMuNCAwIC43LS4zLjctLjdWNTcuNmMwLS41LS4zLS44LS44LS44eiIgZmlsbD0iI0ZGRiIvPjxwYXRoIGQ9Ik03NS4zIDU2LjhoLTkuNWMtLjQgMC0uNy4yLS44LjVhNC4yIDQuMiAwIDAgMS04IDBjLS4xLS4zLS40LS41LS44LS41aC05LjVjLS40IDAtLjcuMy0uNy44VjY4YzAgLjQuMy43LjguN2gyOC41Yy40IDAgLjctLjMuNy0uN1Y1Ny42YzAtLjUtLjMtLjgtLjgtLjh6bS0uOCA1LjVoLTIuN2EuNy43IDAgMSAwIDAgMS41aDIuN3YzLjVoLTI3di00aDIuN2EuNy43IDAgMSAwIDAtMS41aC0yLjd2LTMuNWg4LjJhNS43IDUuNyAwIDAgMCAxMC42IDBoOC4ydjR6TTU2LjQgNTEuOGEuNi42IDAgMSAxIC44LS45bDMuMiAzLjF2LTkuMmEuNi42IDAgMCAxIDEuMiAwVjU0bDMuMi0zYS42LjYgMCAwIDEgLjguOEw2MS40IDU2YS42LjYgMCAwIDEtLjggMGwtNC4yLTQuMnoiIGZpbGwtb3BhY2l0eT0iLjMiIGZpbGw9IiMwMDg0RkYiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxnIGZpbGw9IiNGRkYiIG9wYWNpdHk9Ii43IiBzdHJva2U9IiMwMDg0RkYiIHN0cm9rZS1vcGFjaXR5PSIuMyI+PGNpcmNsZSBjeD0iMjciIGN5PSIyMCIgcj0iOSIvPjxjaXJjbGUgY3g9IjUiIGN5PSI1IiByPSI1Ii8+PC9nPjwvZz48L3N2Zz4="

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bjorn.de2392e8.jpg";

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gaz.cf029740.jpg";

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTAwIiBoZWlnaHQ9IjI1MDAiIHZpZXdCb3g9IjAgMCAyNjYuOSAyNjYuOSI+PHBhdGggZD0iTTI1Mi4yIDI2Ni45YzguMSAwIDE0LjctNi42IDE0LjctMTQuN1YxNC43YzAtOC4xLTYuNi0xNC43LTE0LjctMTQuN0gxNC43QzYuNiAwIDAgNi42IDAgMTQuN3YyMzcuNWMwIDguMSA2LjYgMTQuNyAxNC43IDE0LjdoMjM3LjV6IiBmaWxsPSIjNDg1YTk2Ii8+PHBhdGggZD0iTTE4NC4yIDI2Ni45VjE2My41aDM0LjZsNS4yLTQwLjJoLTM5LjhWOTcuNWMwLTExLjYgMy4yLTE5LjYgMjAtMTkuNmgyMS4yVjQyYy0zLjYtLjUtMTYuMy0xLjYtMzEtMS42LTMwLjggMC01MS44IDE4LjgtNTEuOCA1My4zdjI5LjdoLTM0Ljh2NDAuMmgzNC44VjI2N2g0MS42eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg=="

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNDg1IiBoZWlnaHQ9IjI1MDAiIHZpZXdCb3g9Ijk2IDkzIDMyMiAzMjQiPjxwYXRoIGQ9Ik0yNTcgOTNjLTg5IDAtMTYxIDY3LjItMTYxIDE1MCAwIDQ3LjIgMjMuNCA4OS4zIDYwIDExNi44VjQxN2w1NC44LTMwLjNBMTcyIDE3MiAwIDAgMCAyNTcgMzkzYzg5IDAgMTYxLTY3LjIgMTYxLTE1MFMzNDYgOTMgMjU3IDkzem0xNiAyMDJsLTQxLTQ0LTgwIDQ0IDg4LTk0IDQyIDQ0IDc5LTQ0LTg4IDk0eiIgZmlsbD0iIzAwODRmZiIvPjwvc3ZnPg=="

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNSAxNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBvcGFjaXR5PSIuOSI+PGcgb3BhY2l0eT0iLjciIHRyYW5zZm9ybT0icm90YXRlKC02IDcuMyA1LjcpIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxyZWN0IGZpbGw9IiNGRkYiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgcng9IjciLz48cGF0aCBkPSJNNyAxM0E2IDYgMCAxIDAgNyAxYTYgNiAwIDAgMCAwIDEyem0uNi00LjRMNiA2LjkgMyA4LjYgNi4zIDUgOCA2LjcgMTEgNSA3LjYgOC42eiIgZmlsbD0iIzAwODRGRiIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9nPjwvZz48L3N2Zz4="

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/funnel-example.3134e995.jpg";

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/intro-devices.91bbdd18.png";

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAdwAAACuCAMAAACr4Ey5AAAABGdBTUEAALGPC/xhBQAAAvdQTFRFAAAA////gICAVVVVQEBAMzMzKysrSUlJQEBAOTk5MzMzLi4uKysrOzs7Nzc3MzMzMDAwLS0tKysrNjY2MzMzMTExLi4uLCwsKysrMzMzMTExLy8vLi4uLCwsKysrMTExMDAwLi4uLS0tLCwsMDAwLy8vLi4uLS0tLCwsLy8vLi4uLS0tLCwsKysrKysrLy8vLi4uLS0tLCwsKysrKysrLi4uLi4uLS0tLCwsKysrKysrLi4uLS0tLS0tLCwsKysrKysrLi4uLS0tLCwsLCwsKysrKysrLS0tLS0tLCwsLCwsKysrKysrLS0tLS0tLCwsLCwsKysrKysrKioqLCwsLCwsKysrKysrKysrKioqLCwsLCwsKysrKysrKysrKioqLCwsLCwsKysrKysrKioqLCwsLCwsKysrKysrKysrKioqLCwsLCwsKysrKysrKysrKioqLCwsLCwsKysrKysrKysrKioqLCwsLCwsKysrKysrKysrKioqLCwsKysrKysrKysrKysrKioqLCwsKysrKysrKysrKysrKioqLCwsKysrKysrKysrKysrKioqLCwsKysrKysrKysrKysrKioqLCwsKysrKysrKysrKysrKioqLCwsKysrKysrKysrKysrKioqLCwsKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKysrKysrKysrKysrKioqKioqKioq5s5CDwAAAPx0Uk5TAAECAwQFBgcICQoLDA0ODxAREhMUFRYXGBkaGxwdHh8gISIjJSYnKCkrLC0uLzAxMjM0NTY3ODk6Ozw9Pj9AQUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVpbXF1eX2BhYmNlZmdoaWprbG1ub3BxcnN0dXZ3eHl6e3x9fn+AgYKDhIWGh4iJiouMjY6PkJGSk5SVlpeYmZqbnJ2en6ChoqOkpaanqKmqq6ytrq+wsbKztLW2t7i5uru8vb6/wMHCw8TFxsfIycrLzM3Oz9DR0tPU1dbX2Nna29zd3t/g4eLj5OXm5+jp6uvs7e7v8PHy8/T19vf4+fr7/P3+/2DsQQAADkhJREFUeNrtnXlgFdUVxuclIYREZCmLJCBW0OBWFiFVFBTEQooBFVFEQcCVoqJRkMWFaBWjuLTBsqgBghJpkVYqi0TAEraoCFJlMyyGJUBMAiEb780fZZX35p65M3eZtef7M3PnnPOd38ub9d2rKBYo7qo7+rSJVnws/zuENWhJYVA9qZofFtyMDn2lK1eoYfq0rUeqLiD0kL8cylBGrRqhmteivFB2F5XQC/5yKEH3k02aFvAVXK86FNel5aR1dZSf4HrWobACawDnanmif+B616Gw2qmgxvsHrncdCmswbP07/8D1rkNhTYGtVwd8A9e7DoW1HLauNvYNXO86FNZs2Hko1jdwvetQWI/D1vf755jrXYfCuh62PtM/cL3rUFjxJaD1rv6B612H4uoHOZ/tpztUnnUoQe+Qzjc28hNczzqUoLortc7zmyi+gutVhzIUuO/ncOPb7/LG5T3DIz+POpSjhJd2nH3iWbnp0ToeKZoBrkcdSlOdtn1GjbiplYc+0kxwPenw/1iscFEIF4VwUQgXhXBRCBfhohAup5y+TG774PNTP127q6pyT8Hn2ZkPX+KJhG2HT3w7Z0nBrqPBX376+ovcib2bugtuw1uefH/N1n3HQhV7NublPvv7OnZY1Ori9K+1lrdM7hZjnWsJCRMHf7CHJLVr/v31XAK36YjFNZpUFcsfqWuNxfURr/Gd3x4Ynh8Cn0yXpOu/MdSQHP6RpQkj1XjSD6qeSrM6yoDL7FBVLw/b1GxKJVjdzyPjrLAYWUmPc39u+YVuDHV7mjS4ogkjfGeUq1R9c5MjcB/4dUP0hGO6xRXdYoHFyEomnf3roF+oMZYly7IumPC8Gk0qU40UmlrfAbjTz/29eR6tuJr75FuMrOSrM1HmGcUo6STJumDCX/Wgse9T2t3Lfrhbzv65+34DLmOlW4ys5PQxsN5a4xClXeRYF0x47vvuHdWsxtkON3T6NZzAcycMaxsl26KmkpPHwMAnZiKUXSfHuljCs2mXqOY10m64ap9TbOeYKO3YbyVb1FRy8hj4mrkI5R2kWBdLeOai70cG42roPrvhZpz82+umaluqyLWoqeQrZYTZEAVRMqyLJTyljiUqk2rTbIabp/tTBUJDFakWNZVUj641HeJhGdbFEp5Ug59URlUk2Qv3WMxdIZOl7Y2SanG9yq0jTWRYF0p4Up+wx8m2F676XpXp0rorMi0K9Pr8FZxNcMmEivIIR5hQR3vhijkUsChSSehqm60TCZVrKnnirHQt3BLyVquARZFK1Ndttk4kTNhKGRwM6m663a1w1X6KRIsGlZRuK6Vs3RWQbp0tod5Z6Hev9WrXNCq6+VUPfFoBbV/jWrjTtNFELOpXUjZ5cMqpM5j45PRv9MakyLTOnjBqBzhoQfiDmN/MBE5Vg00cg1vx7dx3P847orc5XxNMyKJeJbVZzcLd61xET5FnnSdhX2jIgRs1GXseJwcNdgbuytTWZ757Yrpnw5dHZZpgQhZ1KtnQLnLv+OngsJ8DsqxzJYQeE+69jCCSWmtQlk1wd0Yc6rsVgoNaRQYTsghXUtSC2D0XHHi9JOtcCa8Eth9vAyCZSJ6VRtsONzhGcybc5hA0rHfEGDGLYCVVwCOYhE3QyNFyrPMlnAZsz4CQJJBP27raDpec5Lc7NOzpiCFiFsFKhpl8Lqad64PbOlfCOOBAUww/jn+SGDjBbrjPA9GgRz0zwgcIWoQqWQ0bWwYMXSvFOl/C64DNj8KRWhMDs2yGmwVFuxEY+PfwAYIWoUoGwrtD3yLlUqzzJXyK3LpV71XJzdqRufbC3QI+EQgUkyOXhA8QtAhUsldvd+CNSvViCdY5E35idIUTpiztyC/thavz8c0x+BYTtAhUovsuz3tGJ3ec1jkT7iU3JulFelY7crOtcP+rM1f+MODOU/h2QYtkJTW607PcZnRyx2edM2FL4CpY9zWVQcR9AFvh3qNTFnBM3Rm2WdQiWckR3d3rA72eKm6dM+GdBicjEbqZuCEWsBFuud4iF83JcAfDNgtaZOq1UkQmm2MlXGrCN8htz+gG6kGMbWgjXH2H5FvqFWFbBS2y9Rp4q3qhpXBpCT8jt92oG+gPxNhmroC7k7yRFbZV0CJbr4ETnOWWwqUlXE1sOpGgG4i8/x7nCrjfU+EKWmTr9VjS2jpL4dISbiE2hQ7qinhIXK24Au56KlxRi0y9/hNwdW4pXFrCIpFn4uohd8BdQYUrapGp18Bl2W5L4dISHhdyvtMdcJdS4YpaZOr1QDJCiaVwKQljhYyr33oArrBFpl4DrwVUWwqXkrCZmPM8D8AVtsjU69vJCLWWwqUkvEzM+QwPwBW2yNRrYEWsw5bCpSTsIuY83QNwhS0y9fohMsIOS+FSEgo6T/M/3DS2Xo8mIxRYCpeSMFnMebIH4ApbZOr1eLvvUFESthAyfiLWA3CFLTL1+s8GTymkw6UkrCfkfIfiAbjCFpl6Dbw4MNNSuLSENcSmwhWmlekFuMIWmXoNPIZ+w1K4tITF9FpY5Fa4ohaZeg38RmuCpXBpCbcTmz72G1xRiyyVNAW+2QdaaZ2asIDY9JXf4IpaZKkEeou2jZXWqQkXkQckv8EVtchSyTOqwWDZ1qkJM8i+NPAZXFGLLJWsIp0tsdQ6NSGwImZfn8EVtchQSWNggrsMK63TE7ZUpZ0uA3BfdANcUYsMlQwCjoD9rLRukPAAsXGjPLhvugGuqEWGSpYCvU6y0rpBQuDdwM7S4Ga7Aq6gRfOV3Ay0ushK60YJXyA3z5MG9zNXwBW0aL4S6PdNb1pp3ShhKnCz/BJZcNe4Aq6gRdOVDIVuTl9hoXXDhHHA7OrLoiTBPRztBriCFs1W0rMaaHW+hdZNJPwLMGKMgd8OJuGeX33BSbiCFoFfLV0A7NDpKPR/NEyKde6E7YERtX+k+b58eXUrk3CzXAFXzCJwYNs3VLtWVdQT4LIa5QlSrPMnhOYiC6br+k6aXK35WSIFblnY7J+xjsEVswhO4LAhcgailHXw4+Bpcj7X/AkfBUfltgV9d8o5/Xi0urU5uGrJ2YuO9i9uynQOrpBFnXl1lqZ3Or1KVXSLGzILdR71hzpIg8uZsCE8oWlwformqyA6ZeI63Y+kolwL59vzUdb8Vad+3L7AObhCFilz2R0v+uFAkPIex1RFIly+hH/VG3rkX2N7Xt2qvhLd7Ipud476R/hJZw25TITRm2ibnYMrZJF/itG9F8qGy56wwT76LrXQBIsziTDNDTJXOAhXxCJ/r1MVm+ECCaGfJBiqlphez/BHOS2cgytikbvXOYrNcHPA7izgiPQhEeWowR5dHYQrYJG318VNbIZbDM95k1TGHuoEca650mCPIU7C5bfI2evqVMVeuHBChW95h9naIC8b7PCSk3D5LfL1uipVsRduVapuf15mjxbULurZ2+whwRG43Ba5el1xi2Iv3Ara6rLj2OPN0ISIP0wfv85ZuLwWeXp9tJtiL1zdhGc0mvl0gzh+T6DvcNhhuJwWOXpdqrsepkVw9ROeOyiFWMJtBVbAbmSwpHQDh+HyWWTv9cctFXvhUhKeU9pO80fvF+pCEe6h79XBabhcFll7vbk7pcdWwKUmPH8b4onDpqL99NxFOhEmUvcb4DhcHotsvS59PEaxFa5BwvDbdK8aLotWM79XQD/AmBr9PQ/1cR4uh0Xg2fl4nQXGgqvTm9EbzPmwnj9hhFplbqZdKK8e05y+f/tNOt9yiwfGKm6Ay2wRrKTzu8SPB6sWjWiuyJClCROHzgVmlldLPhtzQ5zx3oFbF2pfgw9ueat3vOImsVjU+ZjF9Bk/a21h8bFg1e71/5w+aWTfC2QVZ3XCQIeHxk2Z/fmGwqPBI9vWLpr11oThVwRM790k9cXPN+0pD1Ue2Lp+ydvDr3UXWFaLTD+XtRCuy9qn+EII18dCuAgX4SJchItwES7CRSFcFMJFuAgX4SJchItwES5SQLgohItCuAgX4SJchItwES7CRSFcFMJFuAgX4SJchItwES7CtVqzCrRa7rOEKBQKhUKhUM6oR+7+E4f/fXcAO+E7Rb1/9iolL0FSxJYPv5H54MXYWRewzf71GnSFlJ+WN/rg9BzZJ6bXxeY6rfSwOwwLJcSLzz8X7csLsbvOKuZQ+P2jp4TjRYet8bsKj+LOqmvkzEYpovEiZqW8C/vrqDTrrO1uLBaufcTkXYuwv45qiObG/tJYkWh1v48IdgD766iu1z62WRAjEC0zMlYl9tdRRR/U0p0bxR3sTs1CQXuxv87qCXLabd6T3JuqtJ8TbK/D/7rkYh1z47gi/Y5YWOMGbK/DSiSnjtyQyBGnzX5iYmxsruPqRU66vq8zc5SUA9ogRY2xt84rg5z0tXIk44H33ioixq3YWTccdlcAc/r+J5khQgD4fGRhY12hFoXQnOHj6pjdPxlYQW1bPPbVHbq0CJpp/cd7o83sHPdSNbC+XAp21S1KLgYn0t82xPB+VVS/7dCew7Gn7tE1JfA6CTvSqQv9JDwGolXHYkfdpM56y2QFvxzeUOeftstknY/EFOynu3Rdsf4yJ/mv99euHnLRoDmHdNexxKf0blPr7+iLT32R/cpj/W+74+7BwybOWV9KGbm4DjbTdbqAZ01tUvPqYStdqMAkcbSh5/E72aUaWCbI9vgAbKJrlbRQiG1RR2yhq/95D/KzXZyI/XO3Gmdzot1/NzbP/eqRz4E2mNUAO+cJ9VzFynZjF+yaZ9Q9jwXtyrQobJmXlPK3I+bI1ubgObL3FJs277gh2sJXW2KnvKn6Q+bu0gdbk/d0O+yRp5U4YMq6GuI2455l796Bv8D1haKTOvcf+Ur2gtycD6dnvT1+wDX4ihQKZZP+B8TFlRzjhnbJAAAAAElFTkSuQmCC"

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDkgMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcuMyA3LjRMNC45IDEwVi42SDMuNlYxMEwxLjIgNy40bC0xIDEgNCA0LjIgNC00LjJ6IiBmaWxsPSIjQTVEMkUyIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4="

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/notifcation-leads.914881c1.jpg";

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/notifcation-registrations.185ed4ff.jpg";

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTg2IiBoZWlnaHQ9IjYyIiB2aWV3Qm94PSIwIDAgMTg2IDYyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIG9wYWNpdHk9Ii45Ij48Y2lyY2xlIG9wYWNpdHk9Ii40IiBjeD0iMTI3IiBjeT0iMTAiIHI9IjE2NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMTE0KSIgc3Ryb2tlPSIjMDA4NEZGIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1vcGFjaXR5PSIuMyIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODciIGhlaWdodD0iMTg3IiB2aWV3Qm94PSIwIDAgMTg3IDE4NyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiMwMDg0RkYiIHN0cm9rZS1vcGFjaXR5PSIuMzA3IiBvcGFjaXR5PSIuOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjg1NyAuOTI5KSI+PGNpcmNsZSBjeD0iMjE4LjUiIGN5PSIyMTEuNSIgcj0iNjAuNSIgb3BhY2l0eT0iLjQiLz48Y2lyY2xlIGN4PSItNzkuOTY0IiBjeT0iNy4wMzYiIHI9IjE2NS4wMzYiIG9wYWNpdHk9Ii40Ii8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODciIGhlaWdodD0iMTUxIiB2aWV3Qm94PSIwIDAgMTg3IDE1MSI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiMwMDg0RkYiIHN0cm9rZS1vcGFjaXR5PSIuMzA3IiBvcGFjaXR5PSIuOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjcxNCAtMzUpIj48Y2lyY2xlIGN4PSIyMTAuNSIgY3k9IjgwLjUiIHI9IjUwLjUiIG9wYWNpdHk9Ii40Ii8+PGNpcmNsZSBjeD0iLTQuNSIgY3k9IjIxMi41IiByPSI2MC41IiBvcGFjaXR5PSIuNCIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODciIGhlaWdodD0iMTU2IiB2aWV3Qm94PSIwIDAgMTg3IDE1NiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiMwMDg0RkYiIHN0cm9rZS1vcGFjaXR5PSIuMzA3IiBvcGFjaXR5PSIuOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjU3MSAtMzAuMTQzKSI+PGNpcmNsZSBjeD0iLTExLjUiIGN5PSI4MC41IiByPSI1MC41IiBvcGFjaXR5PSIuNCIvPjxjaXJjbGUgY3g9IjIyMy41IiBjeT0iMTY1LjUiIHI9Ijk1LjUiIG9wYWNpdHk9Ii40Ii8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODciIGhlaWdodD0iMTg2IiB2aWV3Qm94PSIwIDAgMTg3IDE4NiI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiMwMDg0RkYiIHN0cm9rZS1vcGFjaXR5PSIuMzA3IiBvcGFjaXR5PSIuOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjQyOSkiPjxjaXJjbGUgY3g9Ii41IiBjeT0iMTY1LjUiIHI9Ijk1LjUiIG9wYWNpdHk9Ii40Ii8+PGNpcmNsZSBjeD0iMjMwLjUiIGN5PSItNC41IiByPSI5NS41IiBvcGFjaXR5PSIuNCIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDQiIGhlaWdodD0iOTIiIHZpZXdCb3g9IjAgMCAxMDQgOTIiPjxnIG9wYWNpdHk9Ii45Ij48Y2lyY2xlIGN4PSI3LjUiIGN5PSItNC41IiByPSI5NS41IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDg0RkYiIHN0cm9rZS1vcGFjaXR5PSIuMzA3IiBvcGFjaXR5PSIuNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjI4NikiLz48L2c+PC9zdmc+"

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjU2IiBoZWlnaHQ9IjI5MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCI+PHBhdGggZD0iTTIyMy43NyA1Ny4zNGEyLjggMi44IDAgMCAwLTIuNTMtMi4zNmMtMS4wNi0uMDktMjMuMzktMS43NC0yMy4zOS0xLjc0bC0xNy4yLTE3LjFjLTEuNy0xLjctNS4wMy0xLjE4LTYuMzItLjgtLjIuMDUtMy40IDEuMDQtOC42OCAyLjY4LTUuMTgtMTQuOTEtMTQuMzItMjguNi0zMC40LTI4LjYtLjQ1IDAtLjkuMDEtMS4zNy4wNEMxMjkuMzEgMy40IDEyMy42NC43OCAxMTguNzUuNzggODEuMjkuNzggNjMuMzkgNDcuNiA1Ny43NyA3MS40YTIyNzI3IDIyNzI3IDAgMCAwLTI2LjIyIDguMTRjLTguMTIgMi41NS04LjM4IDIuOC05LjQ1IDEwLjQ2QzIxLjMgOTUuOC4wNCAyNjAuMjQuMDQgMjYwLjI0bDE2NS42NyAzMS4wNCA4OS43OC0xOS40MlMyMjMuOTcgNTguOCAyMjMuNzcgNTcuMzR6bS02Ny4yOC0xNi41bC0xNC4wMiA0LjM1LjAxLTMuMDNjMC05LjI2LTEuMjktMTYuNzItMy4zNS0yMi42MyA4LjI5IDEuMDQgMTMuOCAxMC40NyAxNy4zNiAyMS4zMnptLTI3LjY0LTE5LjQ4YzIuMyA1Ljc4IDMuOCAxNC4wNiAzLjggMjUuMjR2MS42M2wtMjguOTYgOC45NmM1LjU4LTIxLjUxIDE2LjAzLTMxLjkgMjUuMTYtMzUuODN6bS0xMS4xMy0xMC41M2MxLjYyIDAgMy4yNS41NSA0LjggMS42Mi0xMiA1LjY1LTI0Ljg3IDE5Ljg4LTMwLjMgNDguM2wtMjIuOSA3LjA4YzYuMzctMjEuNjcgMjEuNS01NyA0OC40LTU3eiIgZmlsbD0iIzk1QkY0NiIvPjxwYXRoIGQ9Ik0yMjEuMjQgNTQuOThjLTEuMDYtLjA5LTIzLjM5LTEuNzQtMjMuMzktMS43NGwtMTcuMi0xNy4xYTQuMjUgNC4yNSAwIDAgMC0yLjQtMS4xbC0xMi41MyAyNTYuMjQgODkuNzctMTkuNDJTMjIzLjk3IDU4LjggMjIzLjc3IDU3LjM0YTIuOCAyLjggMCAwIDAtMi41My0yLjM2IiBmaWxsPSIjNUU4RTNFIi8+PHBhdGggZD0iTTEzNS4yNCAxMDQuNTlsLTExLjA3IDMyLjkycy05LjctNS4xOC0yMS41OC01LjE4Yy0xNy40MyAwLTE4LjMgMTAuOTQtMTguMyAxMy43IDAgMTUuMDQgMzkuMiAyMC44IDM5LjIgNTYuMDIgMCAyNy43MS0xNy41OCA0NS41Ni00MS4yOSA0NS41Ni0yOC40NCAwLTQyLjk4LTE3LjctNDIuOTgtMTcuN2w3LjYyLTI1LjE2czE0Ljk1IDEyLjg0IDI3LjU2IDEyLjg0YzguMjQgMCAxMS42LTYuNSAxMS42LTExLjI0IDAtMTkuNjEtMzIuMTYtMjAuNDktMzIuMTYtNTIuNzIgMC0yNy4xMyAxOS40Ny01My4zOCA1OC43Ny01My4zOCAxNS4xNSAwIDIyLjYzIDQuMzQgMjIuNjMgNC4zNCIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg=="

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUwMCIgaGVpZ2h0PSIyNTAwIiB2aWV3Qm94PSIwIDAgMjU2IDI1NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCI+PHBhdGggZD0iTTE2NiAxNS44QTIyLjggMjIuOCAwIDEgMCAxMjIuNiAzMGw1OSAxODEuNGEyMi44IDIyLjggMCAwIDAgMjcuNyAxNC4xIDIyLjYgMjIuNiAwIDAgMCAxNS42LTI4LjJsLTU5LTE4MS40IiBmaWxsPSIjREZBMjJGIi8+PHBhdGggZD0iTTc0LjYgNDUuNWEyMi44IDIyLjggMCAwIDAtNDMuMyAxNC4xbDU5IDE4MS40YTIyLjggMjIuOCAwIDAgMCAyNy42IDE0LjEgMjIuNiAyMi42IDAgMCAwIDE1LjctMjguMmwtNTktMTgxLjQiIGZpbGw9IiMzQ0IxODciLz48cGF0aCBkPSJNMjQwLjIgMTY2YTIyLjggMjIuOCAwIDEgMC0xNC4xLTQzLjNsLTE4MS40IDU5YTIyLjggMjIuOCAwIDAgMC0xNC4xIDI3LjdBMjIuNiAyMi42IDAgMCAwIDU4LjggMjI1bDE4MS40LTU5IiBmaWxsPSIjQ0UxRTVCIi8+PHBhdGggZD0iTTgyLjUgMjE3LjNsNDMuNC0xNC4xLTE0LjEtNDMuNEw2OC40IDE3NGwxNC4xIDQzLjQiIGZpbGw9IiMzOTI1MzgiLz48cGF0aCBkPSJNMTczLjggMTg3LjZsNDMuNC0xNC0xNC00My41LTQzLjQgMTQuMSAxNCA0My40IiBmaWxsPSIjQkIyNDJBIi8+PHBhdGggZD0iTTIxMC41IDc0LjdhMjIuOCAyMi44IDAgMCAwLTE0LjEtNDMuNEwxNSA5MC4zQTIyLjggMjIuOCAwIDAgMCAxIDExOGEyMi42IDIyLjYgMCAwIDAgMjguMiAxNS42bDE4MS40LTU4LjkiIGZpbGw9IiM3MkM1Q0QiLz48cGF0aCBkPSJNNTIuOCAxMjZsNDMuNC0xNC4yTDgyIDY4LjVsLTQzLjQgMTRMNTIuOCAxMjYiIGZpbGw9IiMyNDhDNzMiLz48cGF0aCBkPSJNMTQ0LjIgOTYuM2w0My4zLTE0LjFhNTQ2MTc5LjIgNTQ2MTc5LjIgMCAwIDAtMTQtNDMuNEwxMzAgNTNsMTQgNDMuNCIgZmlsbD0iIzYyODAzQSIvPjwvc3ZnPg=="

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUwMCIgaGVpZ2h0PSIyNTAwIiB2aWV3Qm94PSIwIDAgMjU2IDI1NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCI+PHBhdGggZD0iTTE2MCAxMjhhNzYuNSA3Ni41IDAgMCAxLTUgMjcgNzYuNyA3Ni43IDAgMCAxLTI3IDVjLTkuNiAwLTE4LjctMS43LTI3LTVhNzYuNiA3Ni42IDAgMCAxLTUtMjcgNzYuNiA3Ni42IDAgMCAxIDUtMjcgNzYuNSA3Ni41IDAgMCAxIDI3LTUgNzYuNSA3Ni41IDAgMCAxIDI3IDUgNzYuNSA3Ni41IDAgMCAxIDUgMjd6bTk0LjItMjEuM2gtNzQuN2w1Mi44LTUyLjlhMTI4LjUgMTI4LjUgMCAwIDAtMTMuOC0xNi4zIDEyOSAxMjkgMCAwIDAtMTYuMy0xMy44bC01Mi45IDUyLjhWMS44QTEyOC42IDEyOC42IDAgMCAwIDEyOC4xIDBoLS4yYy03LjIgMC0xNC4zLjYtMjEuMiAxLjh2NzQuN0w1My44IDIzLjdhMTI3LjggMTI3LjggMCAwIDAtMTYuMyAxMy44IDEyOC44IDEyOC44IDAgMCAwLTEzLjggMTYuM2w1Mi44IDUyLjlIMS44UzAgMTIwLjcgMCAxMjhjMCA3LjMuNiAxNC40IDEuOCAyMS4zaDc0LjdsLTUyLjggNTIuOWExMjkgMTI5IDAgMCAwIDMwLjEgMzAuMWw1Mi45LTUyLjh2NzQuN2ExMjkuMyAxMjkuMyAwIDAgMCAyMS4yIDEuOGguMmExMjkuMiAxMjkuMiAwIDAgMCAyMS4yLTEuOHYtNzQuN2w1Mi45IDUyLjhhMTI5IDEyOSAwIDAgMCAxNi4zLTEzLjggMTI5LjIgMTI5LjIgMCAwIDAgMTMuOC0xNi4zbC01Mi44LTUyLjloNzQuN2MxLjItNi45IDEuOC0xNCAxLjgtMjEuMnYtLjJjMC03LjItLjYtMTQuMy0xLjgtMjEuMnoiIGZpbGw9IiNGRjRBMDAiLz48L3N2Zz4="

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 1;\n"], ["\n  position: relative;\n  z-index: 1;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _rebass = __webpack_require__(3);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactMixpanel = __webpack_require__(207);
	
	var _reactMixpanel2 = _interopRequireDefault(_reactMixpanel);
	
	var _gatsbyBrowser = __webpack_require__(149);
	
	var _theme = __webpack_require__(154);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Navbar = __webpack_require__(151);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Footer = __webpack_require__(318);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _FacebookSDK = __webpack_require__(317);
	
	var _FacebookSDK2 = _interopRequireDefault(_FacebookSDK);
	
	var _UserProvider = __webpack_require__(326);
	
	var _UserProvider2 = _interopRequireDefault(_UserProvider);
	
	__webpack_require__(547);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// import OptIn from "../components/OptIn";
	
	
	var Fragment = _react2.default.Fragment;
	
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children,
	      siteMetadata = _ref.data.site.siteMetadata;
	  return _react2.default.createElement(
	    _rebass.Provider,
	    { theme: _theme2.default },
	    _react2.default.createElement(_reactHelmet2.default, { title: "Pipeline" }),
	    _react2.default.createElement(
	      _reactMixpanel2.default,
	      { mixpanel: _gatsbyBrowser.mixpanel },
	      _react2.default.createElement(_UserProvider2.default, {
	        render: function render(user) {
	          return _react2.default.createElement(
	            Fragment,
	            null,
	            _react2.default.createElement(_Navbar2.default, { siteMetadata: siteMetadata, user: user }),
	            _react2.default.createElement(
	              Children,
	              null,
	              children()
	            ),
	            _react2.default.createElement(_Footer2.default, { siteMetadata: siteMetadata }),
	            _react2.default.createElement(_FacebookSDK2.default, null),
	            _react2.default.createElement("div", { className: "fb-customerchat", page_id: "227754084405138" })
	          );
	        }
	      })
	    )
	  );
	};
	
	exports.default = TemplateWrapper;
	
	// Styled Components
	
	var Children = _styledComponents2.default.div(_templateObject);
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 1;\n"], ["\n  position: relative;\n  z-index: 1;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLoadScript = __webpack_require__(122);
	
	var _reactLoadScript2 = _interopRequireDefault(_reactLoadScript);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Hero = __webpack_require__(53);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Intro = __webpack_require__(54);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	var _Proof = __webpack_require__(30);
	
	var _Proof2 = _interopRequireDefault(_Proof);
	
	var _Stats = __webpack_require__(38);
	
	var _Stats2 = _interopRequireDefault(_Stats);
	
	var _Connect = __webpack_require__(29);
	
	var _Connect2 = _interopRequireDefault(_Connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.handleScriptLoad = function handleScriptLoad() {
	    if (typeof window !== "undefined" && window.netlifyIdentity) {
	      window.netlifyIdentity.on("init", function (user) {
	        if (!user) {
	          window.netlifyIdentity.on("login", function () {
	            document.location.href = "/admin/";
	          });
	        }
	      });
	    }
	    window.netlifyIdentity.init();
	  };
	
	  IndexPage.prototype.render = function render() {
	    var data = this.props.data;
	    var siteMetadata = data.site.siteMetadata;
	
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        Wrap,
	        null,
	        _react2.default.createElement(_Hero2.default, { siteMetadata: siteMetadata, pt: [2, 2, 5] }),
	        _react2.default.createElement(_Intro2.default, { mb: [5, 5, 6], siteMetadata: siteMetadata }),
	        _react2.default.createElement(_Proof2.default, { siteMetadata: siteMetadata, mb: [5, 5, 6] }),
	        _react2.default.createElement(_Stats2.default, { py: ["80px"], mb: ["80px"], siteMetadata: siteMetadata }),
	        _react2.default.createElement(_Connect2.default, { mb: [5, 5, 6], pt: [5] })
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	
	var Wrap = _styledComponents2.default.div(_templateObject);

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getParameterByName = getParameterByName;
	function getParameterByName(name, url) {
	  var location = url || window.location.href;
	  var formattedName = name.replace(/[\[\]]/g, "\\$&");
	
	  var regex = new RegExp("[?&]" + formattedName + "(=([^&#]*)|&|#|$)");
	  var results = regex.exec(location);
	
	  if (!results) return null;
	  if (!results[2]) return "";
	
	  return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
	
	exports.default = "";

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// Default values
	exports.default = {
	  colors: {
	    base: "#343D42",
	    support1: "#3A88BA",
	    support2: "#2E5A77",
	    support3: "#4D5052",
	    support4: "#103046",
	    gray1: "#FAFAFA",
	    gray2: "#EAEAEA",
	    gray3: "#CBCBCB",
	    facebookBlue: "#365899",
	    messengerBlue: "#3A82F7",
	    error: "#da3f51",
	    success: "#00d1b2",
	    info: "#c2e0ff",
	    edit: "#B6B9EF",
	    beige: "#f7f7f5"
	  }
	};
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-8127827681f69a41c9d0.js